import React, { useState, useEffect, useCallback, useRef } from "react";
import "./../../App.css";
import "./Payroll.css";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { CreateTableForEmployeeSelect } from "../ManageTable";
import { CreateButton, CreateSearchBarWithPlaceHolder } from "../CommonObjects";
import {
  SetAuditTrail,
  SetAuditTrailBulk,
} from "./../Reports/AuditTrailReportEmployeeSetup";
import { token, domain } from "../Security";
import axios from "axios";
import { useTable, useSortBy } from "react-table";
import * as XLSX from "xlsx"; // Import all exports from xlsx library
import loadingSpinner from "./../../assets/loading.gif";
import { format } from "date-fns";
import { globalTimeFormat } from "./../Security";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
// icons
import SyncIcon from "@mui/icons-material/Sync";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import SettingsIcon from "@mui/icons-material/Settings";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import DownloadIcon from "@mui/icons-material/Download";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import SettingsBackupRestoreIcon from "@mui/icons-material/SettingsBackupRestore";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";
import FileOpenIcon from "@mui/icons-material/FileOpen";
import PaidIcon from "@mui/icons-material/Paid";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import PostAddIcon from "@mui/icons-material/PostAdd";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

function Payroll({ user, userAccess, isHideSideMenu }) {
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [loadingUploadRequest, setLoadingUploadRequest] = useState(false);
  const [showSetting, setShowSetting] = useState(false);
  const settingRef = useRef(null);
  const buttonRef = useRef(null);

  const [payrollData, setPayrollData] = useState([]);
  const [payrollDataAdjustment, setPayrollDataAdjustment] = useState([]);

  const [otherAdditionData, setOtherAdditionData] = useState([]);
  const [otherDeductionData, setOtherDeductionData] = useState([]);
  const [otherAdjustmentData, setOtherAdjustmentData] = useState([]);
  const [otherLateAdjustmentData, setOtherLateAdjustmentData] = useState([]);

  const [showUploadForm, setShowUploadForm] = useState(false);
  const [settingType, setSettingType] = useState("");
  const [payrollIdForUpload, setPayrollIdForUpload] = useState("");
  const [payTypeIdForUpload, setPayTypeIdForUpload] = useState("");
  //filters
  const [filterPayrollPeriodId, setFilterPayrollPeriodId] = useState("");
  const [filterPayTypeId, setFilterPayTypeId] = useState("");
  const [filterClassificationId, setFilterClassificationId] = useState("");
  const [filterLocationId, setFilterLocationId] = useState("");
  const [filterSectionId, setFilterSectionId] = useState("");

  const [noDataMessage, setNoDataMessage] = useState(false);
  const [showPostMessage, setShowPostMessage] = useState(false);
  const [successPostMessage, setSuccessPostMessage] = useState(false);
  const [isGenerate, setIsGenerate] = useState(false);
  const [generateMessage, setGenerateMessage] = useState(false);
  const [showRevertPayrollForm, setShowRevertPayrollForm] = useState(false);
  const [showProcessPayrollForm, setShowProcessPayrollForm] = useState(false);
  const [showPostPayrollForm, setShowPostPayrollForm] = useState(false);
  const [isRevert, setIsRevert] = useState(false);
  const [isProcess, setIsProcess] = useState(false);
  const [isPost, setIsPost] = useState(false);
  const [isUpload, setIsUpload] = useState(false);

  const [loading, setLoading] = useState(false);
  const [filterData, setFilterData] = useState([]);

  const [type, setType] = useState(0);

  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
    if (showRequestMessage) {
      const timeoutId = setTimeout(() => {
        setShowRequestMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }

    if (generateMessage) {
      const timeoutId = setTimeout(() => {
        setGenerateMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }
  }, [generateMessage, showRequestMessage]);

  // =============================================================
  // ===================PROCESSED=================================
  // =============================================================
  const apiUrl = domain + "/api/PayrollSummaryStaging/";

  const fetchDataProcessedPayroll = useCallback(async () => {
    if (!isGenerate) return;

    let classifiedData = filterClassificationId;

    if (!filterPayTypeId || !filterPayrollPeriodId || !classifiedData) {
      return;
    }
    try {
      setLoading(true);

      const response = await axios.get(
        apiUrl +
          `process/${filterPayTypeId}/${filterPayrollPeriodId}/${classifiedData}/${filterLocationId ? filterLocationId : 0}/${filterSectionId ? filterSectionId : 0}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // You can include other headers if needed
          },
        }
      );
      // const filteredDatas = response.data.filter(filteredData => filteredData.payrollPeriodId === parseInt(filterPayrollPeriodId));
      // const newFilteredDatas = filteredDatas.filter(filteredData => filteredData.payTypeId === parseInt(filterPayTypeId));
      // setPayrollData(newFilteredDatas); // Set the response data to the state
      // setFilterData(newFilteredDatas); // Set the response data to the state

      setPayrollData(response.data); // Set the response data to the state
      setFilterData(response.data); // Set the response data to the state
      // setIsGenerate(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  }, [
    apiUrl,
    isGenerate,
    filterPayrollPeriodId,
    filterPayTypeId,
    filterClassificationId,
    setPayrollData,
    filterLocationId,
    filterSectionId
  ]);
  // =============================================================
  // ===================PROCESSED=================================
  // =============================================================

  const offGenerateLateApprovedAdjustments = true;

  const handleGenerateLateApprovedAdjustments = useCallback(async () => {
    if (!offGenerateLateApprovedAdjustments) {
      let classifiedData = filterClassificationId;

      // Constructing the URL with the correct format
      const apiUrl =
        domain +
        `/api/OtherAdjustmentStaging/generate-late-approval-adjustments/paytype/${filterPayTypeId}/payrollperiod/${filterPayrollPeriodId}/classification/${classifiedData}`;

      try {
        // Making the Axios POST request with the constructed URL
        await axios.post(apiUrl, null, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  }, [
    filterPayTypeId,
    filterPayrollPeriodId,
    filterClassificationId,
    offGenerateLateApprovedAdjustments,
  ]);

  // =============================================================
  // ===================ADJUSTMENTS===============================
  // =============================================================
  const [loadingOtherAddition, setLoadingOtherAddition] = useState(false);
  const [loadingOtherDedujction, setLoadingOtherDedujction] = useState(false);
  const [loadingAdjustment, setLoadingAdjustment] = useState(false);
  const [loadingLateAdjustment, setLoadingLateAdjustment] = useState(false);
  const [filterDataAddition, setFilterDataAddition] = useState([]);
  const [filterDataDeduction, setFilterDataDeduction] = useState([]);
  const [filterDataAdjustment, setFilterDataAdjustment] = useState([]);
  const [filterDataLateAdjustment, setFilterDataLateAdjustment] = useState([]);

  const fetchAdditionData = useCallback(async () => {
    const apiUrl = domain + "/api/";
    if (!isGenerate) return;

    let classifiedData = filterClassificationId;

    if (!filterPayTypeId || !filterPayrollPeriodId || !classifiedData) {
      return;
    }
    try {
      setLoadingOtherAddition(true);
      const response = await axios.get(
        apiUrl +
          `OtherAdditionStaging/paytype/${filterPayTypeId}/payrollperiod/${filterPayrollPeriodId}/classification/${classifiedData}/location/${filterLocationId ? filterLocationId : 0}/section/${filterSectionId ? filterSectionId : 0}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // You can include other headers if needed
          },
        }
      );
      setOtherAdditionData(response.data); // Set the response data to the state
      setFilterDataAddition(response.data); // Set the response data to the state
      setIsUpload(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingOtherAddition(false);
    }
  }, [
    setIsUpload,
    isGenerate,
    filterPayTypeId,
    filterPayrollPeriodId,
    filterClassificationId,
    filterLocationId,
    filterSectionId,
    setOtherAdditionData,
  ]);
  const fetchDeductionData = useCallback(async () => {
    const apiUrl = domain + "/api/";
    if (!isGenerate) return;

    let classifiedData = filterClassificationId;

    if (!filterPayTypeId || !filterPayrollPeriodId || !classifiedData) {
      return;
    }
    try {
      setLoadingOtherDedujction(true);
      const response = await axios.get(
        apiUrl +
          `OtherDeductionStaging/paytype/${filterPayTypeId}/payrollperiod/${filterPayrollPeriodId}/classification/${classifiedData}/location/${filterLocationId ? filterLocationId : 0}/section/${filterSectionId ? filterSectionId : 0}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // You can include other headers if needed
          },
        }
      );
      setOtherDeductionData(response.data); // Set the response data to the state
      setFilterDataDeduction(response.data); // Set the response data to the state
      setIsUpload(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingOtherDedujction(false);
    }
  }, [
    setIsUpload,
    isGenerate,
    filterPayTypeId,
    filterPayrollPeriodId,
    filterClassificationId,
    filterLocationId,
    filterSectionId,
    setOtherDeductionData,
  ]);
  const fetchAdjustmentData = useCallback(async () => {
    const apiUrl = domain + "/api/";
    if (!isGenerate) return;

    setLoadingAdjustment(true);

    let classifiedData = filterClassificationId;

    if (!filterPayTypeId || !filterPayrollPeriodId || !classifiedData) {
      return;
    }
    try {
      const response = await axios.get(
        apiUrl +
          `OtherAdjustmentStaging/paytype/${filterPayTypeId}/payrollperiod/${filterPayrollPeriodId}/classification/${classifiedData}/location/${filterLocationId ? filterLocationId : 0}/section/${filterSectionId ? filterSectionId : 0}/current`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // You can include other headers if needed
          },
        }
      );
      setOtherAdjustmentData(response.data); // Set the response data to the state
      setFilterDataAdjustment(response.data); // Set the response data to the state
      setIsUpload(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingAdjustment(false);
    }
  }, [
    setIsUpload,
    isGenerate,
    filterPayTypeId,
    filterPayrollPeriodId,
    filterClassificationId,
    filterLocationId,
    filterSectionId,
    setOtherAdjustmentData,
  ]);
  const fetchLateAdjustmentData = useCallback(async () => {
    const apiUrl = domain + "/api/";
    if (!isGenerate) return;

    setLoadingLateAdjustment(true);

    let classifiedData = filterClassificationId;

    if (!filterPayTypeId || !filterPayrollPeriodId || !classifiedData) {
      return;
    }
    try {
      const response = await axios.get(
        apiUrl +
          `OtherAdjustmentStaging/paytype/${filterPayTypeId}/payrollperiod/${filterPayrollPeriodId}/classification/${classifiedData}/location/${filterLocationId ? filterLocationId : 0}/section/${filterSectionId ? filterSectionId : 0}/late`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // You can include other headers if needed
          },
        }
      );
      setOtherLateAdjustmentData(response.data); // Set the response data to the state
      setFilterDataLateAdjustment(response.data); // Set the response data to the state
      setIsUpload(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingLateAdjustment(false);
    }
  }, [
    setIsUpload,
    isGenerate,
    filterPayTypeId,
    filterPayrollPeriodId,
    filterClassificationId,
    filterLocationId,
    filterSectionId,
    setOtherLateAdjustmentData,
  ]);
  // =============================================================
  // ===================ADJUSTMENTS===============================
  // =============================================================
  const handleGenerate = async () => {
    let classifiedData = filterClassificationId;

    if (!filterPayrollPeriodId || !filterPayTypeId || !classifiedData) {
      setGenerateMessage(true);
      return;
    }

    setIsGenerate(true);
  };
  const handlePost = async (event) => {
    event.preventDefault();

    let classifiedData = filterClassificationId;

    // Constructing the URL with the correct format
    const apiUrl =
      domain +
      `/api/PayrollSummaryStaging/post/${filterPayTypeId}/${filterPayrollPeriodId}/classification/${classifiedData}`;

    try {
      setLoadingRequest(true);
      // Making the Axios POST request with the constructed URL
      await axios.post(apiUrl, null, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      // Rest of your logic for success
      setShowRequestMessage(true);
      setIsSuccess(true);
      // Fetch updated data
      await fetchAdditionData();
      await fetchDeductionData();
      await fetchAdjustmentData();
      await fetchLateAdjustmentData();
      await fetchDataProcessedPayroll();

      closePostMessage();
    } catch (error) {
      // Handling errors
      setShowRequestMessage(true);
      setIsSuccess(false);
      setRequestMessage("Fail to post data!");
    } finally {
      setLoadingRequest(false);
    }
  };

  const handleSetting = () => {
    setShowSetting(!showSetting);
  };
  const closePostMessage = () => {
    setShowPostMessage(false);
  };
  useEffect(() => {
    if (noDataMessage) {
      const timeoutId = setTimeout(() => {
        setNoDataMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }
    if (successPostMessage) {
      const timeoutId = setTimeout(() => {
        setSuccessPostMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }
  }, [noDataMessage, successPostMessage]);
  useEffect(() => {
    var settingIcon = document.getElementById("setting-icon");

    if (showSetting) {
      //change the down icon to up
      settingIcon.setAttribute("data-testid", "KeyboardArrowUpIcon"); //Up Arrow Test ID
      settingIcon.children[0].setAttribute(
        "d",
        `M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z`
      ); // Up Arrow.Path d attribute
    } else {
      //change the up icon to down
      settingIcon.setAttribute("data-testid", "KeyboardArrowDownIcon"); // Down Arrow Test ID
      settingIcon.children[0].setAttribute(
        "d",
        `M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z`
      ); // Down Arrow.Path d attribute
    }

    const handleClickOutside = (event) => {
      if (settingRef.current && !settingRef.current.contains(event.target)) {
        if (buttonRef.current && !buttonRef.current.contains(event.target)) {
          setShowSetting(false);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showSetting]);

  const fetchAllEmployees = async () => {
    const apiUrl = domain + "/api/Employee/masterlist";
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      });

      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  };

  const generateDownloadTemplate = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet();

    const header = ["EmployeeId", "EmployeeName", "Description", "Amount"];
    const headerRow = worksheet.addRow(header);
    worksheet.columns = [
      { key: "employeePersonalInformationEmployeeId", width: 30 },
      { key: "employeePersonalInformationFullName", width: 30 },
      { key: "description", width: 30 },
      { key: "amount", width: 30 },
    ];
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center" };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "92d050" },
      };
    });

    worksheet.addRow([
      "<EMP1234>",
      "<LastName, FirstName>",
      "<Description>",
      "<500.00>",
    ]);

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, "Template.xlsx");
  };
  const generateDownloadAdjustmentTemplate = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet();

    const header = [
      "EmployeeId",
      "EmployeeName",
      "Description",
      "Amount",
      "NumberOfHours",
      "AdjustmentDate",
      "ReferenceId",
    ];
    const headerRow = worksheet.addRow(header);
    worksheet.columns = [
      { key: "employeePersonalInformationEmployeeId", width: 30 },
      { key: "employeePersonalInformationFullName", width: 30 },
      { key: "description", width: 30 },
      { key: "amount", width: 30 },
      { key: "noIfHours", width: 30 },
      { key: "adjustmentDate", width: 30 },
      { key: "referenceId", width: 20 },
    ];
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center" };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "92d050" },
      };
    });

    worksheet.addRow([
      "<EMP1234>",
      "<LastName, FirstName>",
      "<Description>",
      "<500.00>",
      "<8.00>",
      "<mm/dd/yyyy>",
      "<REF00001>",
    ]);

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, "Template.xlsx");
  };

  const convertToDateTime = (value) => {
    if (
      value === null ||
      value === undefined ||
      value === "" ||
      (typeof value === "string" &&
        value.startsWith("<") &&
        value.endsWith(">"))
    ) {
      return null;
    }

    if (!value) {
      return null;
    }

    if (typeof value === "number") {
      // Convert Excel serial number to JavaScript Date
      const excelStartDate = new Date(1899, 11, 31); // Correct base date
      const jsDate = new Date(excelStartDate.getTime() + value * 86400000); // Convert days to milliseconds

      return jsDate.toISOString().split("T")[0];
    }

    if (typeof value === "string") {
      let formattedValue = value.replace(/-/g, "/"); // Ensure compatibility

      const parts = formattedValue.split("/");
      if (parts.length === 3) {
        let [first, second, third] = parts.map((p) => parseInt(p, 10));

        let year, month, day;

        if (third > 31) {
          // Case: YYYY/MM/DD (Ensure proper year detection)
          year = third;
          month = first;
          day = second;
        } else if (first > 12) {
          // Case: DD/MM/YYYY (Auto-detect)
          day = first;
          month = second;
          year = third;
        } else {
          // Case: MM/DD/YYYY (US format)
          month = first;
          day = second;
          year = third;
        }

        return new Date(Date.UTC(year, month - 1, day))
          .toISOString()
          .split("T")[0]; // Return YYYY-MM-DD
      }
    }

    return null;
  };

  const [uploadAdjustments, setUploadAdjustments] = useState([]);
  const uploadFunc = async (file, type, payrollPeriodId, payTypeId) => {
    setLoadingUploadRequest(true);
    const employees = await fetchAllEmployees();

    function sanitizeValue(value) {
      if (
        value === null ||
        value === undefined ||
        value === "" ||
        (typeof value === "string" &&
          value.startsWith("<") &&
          value.endsWith(">"))
      ) {
        return "";
      }
      return value;
    }
    function sanitizeValueInt(value) {
      if (
        value === null ||
        value === undefined ||
        value === "" ||
        (typeof value === "string" &&
          value.startsWith("<") &&
          value.endsWith(">"))
      ) {
        return 0;
      }
      return value;
    }
    function validateData(data) {
      let newData = [];

      data.forEach((item, index) => {
        const missing = [];

        if (!item.employeePersonalInformationEmployeeId)
          missing.push("Employee Id");
        if (!item.description) missing.push("Description");
        if (!item.amount) missing.push("Amount");

        if (type === "Other Adjustments") {
          if (!item.noOfHours) missing.push("Number Of Hours");
          if (!item.adjustmentDate) missing.push("Adjustment Date");
          if (!item.referenceId) missing.push("Reference Id");
        }

        // ✅ Construct error message properly
        let errorMessage = "";

        const existingEmployee = employees.find(
          (employee) =>
            employee.employeeId ===
            item.employeePersonalInformationEmployeeId?.toString()
        );
        if (!existingEmployee) {
          errorMessage +=
            errorMessage.length > 0
              ? ` Employee Id does not exist.`
              : `Employee Id does not exist. `;
        }

        if (missing.length > 0) {
          errorMessage += ` Missing fields - ${missing.join(", ")}`;
        }

        newData.push({ ...item, errors: errorMessage });
      });

      newData.sort((a, b) => (a.error ? -1 : 1) - (b.error ? -1 : 1));

      return newData;
    }

    const reader = new FileReader();
    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      const parseWorksheet = (worksheet) => {
        return XLSX.utils.sheet_to_json(worksheet, { defval: "" });
      };

      const informations = parseWorksheet(
        workbook.Sheets[workbook.SheetNames[0]]
      );

      let bulkData = [];

      informations.forEach((info) => {
        let adjustmentDateFormatted = "";

        if (type === "Other Adjustments") {
          adjustmentDateFormatted = convertToDateTime(info.AdjustmentDate);
        }

        bulkData.push({
          employeePersonalInformationEmployeeId: sanitizeValue(
            info.EmployeeId
          ).toString(),
          employeePersonalInformationFullName: sanitizeValue(
            info.EmployeeName
          ).toString(),
          payrollPeriodId: parseInt(payrollPeriodId),
          payTypeId: parseInt(payTypeId),
          description: sanitizeValue(info.Description),
          amount: info.Amount ? parseInt(sanitizeValueInt(info.Amount)) : 0,
          ...(type === "Other Adjustments" && {
            noOfHours: info.NumberOfHours
              ? parseInt(sanitizeValueInt(info.NumberOfHours))
              : 0,
          }),
          ...(type === "Other Adjustments" && {
            adjustmentDate: adjustmentDateFormatted,
          }),
          ...(type === "Other Adjustments" && {
            referenceId: info.ReferenceId
              ? parseInt(sanitizeValueInt(info.ReferenceId))
              : 0,
          }),
          ...(type === "Other Adjustments" && { transactionType: "Leave" }),
        });
      });

      const validatedData = validateData(bulkData);
      const sortedData = validatedData.sort((a, b) => {
        const hasErrorA = a.errors && a.errors.length > 0;
        const hasErrorB = b.errors && b.errors.length > 0;

        return hasErrorB - hasErrorA; // Move items with errors to the top
      });
      setUploadAdjustments(sortedData);
    };

    setLoadingUploadRequest(false);
    reader.readAsArrayBuffer(file);
  };
  const handleFileUpload = async (files, type, payrollPeriodId, payTypeId) => {
    if (!files || files.length === 0) {
      console.error("No files selected");
      return;
    }

    const file = files[0];
    uploadFunc(file, type, payrollPeriodId, payTypeId);
  };
  const handleFinalFileUpload = async (bulkData, type) => {
    setLoadingRequest(true);

    console.log(bulkData);

    var apiUrl = "";
    if (type === "Other Additions") {
      apiUrl = domain + "/api/OtherAdditionStaging/bulk";
    } else if (type === "Other Deductions") {
      apiUrl = domain + "/api/OtherDeductionStaging/bulk";
    } else if (type === "Other Adjustments") {
      apiUrl = domain + "/api/OtherAdjustmentStaging/bulk";
    }

    try {
      axios.post(apiUrl, bulkData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      let field = "";

      if (type === "Other Additions") {
        field = "Upload Other Additions";
      } else if (type === "Other Deductions") {
        field = "Upload Other Deductions";
      } else if (type === "Other Adjustments") {
        field = "Upload Other Adjustments";
      }

      await SetAuditTrail({
        setupArea: "Payroll",
        actionTaken: "insert",
        field: field,
        newValue: "[bulk data]",
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id,
      });

      setTimeout(async () => {
        await fetchAdditionData();
        await fetchDeductionData();
        await fetchAdjustmentData();
        await fetchLateAdjustmentData();
        await fetchDataProcessedPayroll();
      }, 1000);

      setShowRequestMessage(true);
      setIsSuccess(true);
      setIsUpload(true);
    } catch (error) {
      console.error("Error parsing Excel file:", error);
      setShowRequestMessage(true);
      setIsSuccess(false);

      if (error.response && error.response.data && error.response.data.errors) {
        const errorMessage = error.response.data.errors["$"][0]; // Accessing the error message
        setRequestMessage(errorMessage);
      } else if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        const errorMessage = error.response.data.message; // Fallback to general message
        setRequestMessage(errorMessage);
      } else {
        setRequestMessage("An unknown error occurred."); // Default message
      }
    } finally {
      setLoadingRequest(false);
    }
  };

  const openUploadFormHandleClick = () => {
    setShowUploadForm(true);
  };
  const closeUploadFormHandleClick = () => {
    setShowUploadForm(false);
  };
  const openRevertPayrollForm = () => {
    setShowRevertPayrollForm(true);
  };
  const closeRevertPayrollForm = () => {
    setShowRevertPayrollForm(false);
  };
  const openProcessPayrollForm = () => {
    setShowProcessPayrollForm(true);
  };
  const closeProcessPayrollForm = () => {
    setShowProcessPayrollForm(false);
  };
  const openPostPayrollForm = () => {
    setShowPostPayrollForm(true);
  };
  const closePostPayrollForm = () => {
    setShowPostPayrollForm(false);
  };

  const [showLateAdjustmentForm, setShowLateAdjustmentForm] = useState(false);
  const openLateAdjustmentForm = () => {
    setShowLateAdjustmentForm(true);
  };
  const closeLateAdjustmentForm = () => {
    setShowLateAdjustmentForm(false);
  };

  /* const s2ab = s => {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
    }; */

  const [currentFilterPayTypeIdPayTypeId, setCurrentFilterPayTypeIdPayTypeId] = useState("");
  const [currentFilterClassificationId, setCurrentFilterClassificationId] = useState("");

  useEffect(() => {
    if (currentFilterPayTypeIdPayTypeId !== filterPayTypeId) {
      setCurrentFilterPayTypeIdPayTypeId(filterPayTypeId);
      setFilterClassificationId("");
      setFilterPayrollPeriodId("");
      setFilterLocationId("")
      setFilterSectionId("")
    }
  }, [currentFilterPayTypeIdPayTypeId, filterPayTypeId]);

  useEffect(() => {
    if (setCurrentFilterClassificationId !== filterClassificationId) {
      setCurrentFilterClassificationId(filterClassificationId);
      setFilterLocationId("")
      setFilterSectionId("")
    }
  }, [currentFilterClassificationId, filterClassificationId]);

  return (
    <div>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="PayrollInfo shadow-xl">
            <div className="sub-title row" style={{ padding: "5px 20px" }}>
              <span style={{ padding: "0 5px 0 0", color: "#b0b0b0" }}>
                {"Payroll >"}{" "}
              </span>
              <span style={{ borderBottom: "1px solid black" }}>
                {"Process Payroll"}
              </span>
            </div>
            <div className="payrollHeader row">
              <div
                style={{ width: "70%", color: "#668fca" }}
                className="payroll-title row"
              >
                <PaidIcon style={{ padding: "0 10px 0 0" }} />
                <h3>Process Payroll</h3>
              </div>
              <div style={{ width: "30%", textAlign: "right" }}>
                <button
                  ref={buttonRef}
                  onClick={handleSetting}
                  title="Setting"
                  type="button"
                  className="setting"
                >
                  <SettingsIcon />
                  <KeyboardArrowDownIcon id="setting-icon" />
                </button>
                <div ref={settingRef}>
                  {showSetting && (
                    <SettingInit
                      generateDownloadTemplate={generateDownloadTemplate}
                      generateDownloadAdjustmentTemplate={
                        generateDownloadAdjustmentTemplate
                      }
                      openUploadFormHandleClick={openUploadFormHandleClick}
                      openRevertPayrollForm={openRevertPayrollForm}
                      openProcessPayrollForm={openProcessPayrollForm}
                      openPostPayrollForm={openPostPayrollForm}
                      setSettingType={setSettingType}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="payroll-body">
              <div style={{ padding: "10px" }}>
                <div className="filters-payroll">
                  <span>Filter</span>
                  <div
                    className="payroll-item-holder info-item-holder row"
                    style={{
                      justifyContent: "start",
                      padding: "0 10px 20px 10px",
                    }}
                  >
                    <div className="filter-item-payroll popUp-item info-item column">
                      <div className="info-item-label">Pay Type</div>
                      <div className="info-item-input">
                        <PayTypeIdSelect
                          payTypeId={filterPayTypeId}
                          setPayTypeId={setFilterPayTypeId}
                        />
                      </div>
                      <span
                        style={{
                          visibility: "hidden",
                          color: "#ff6565",
                          fontSize: "12px",
                        }}
                      >
                        Please fill up Pay Type first
                      </span>
                    </div>
                    <div className="filter-item-payroll popUp-item info-item column">
                      <div className="info-item-label">Payroll Period</div>
                      <div className="info-item-input">
                        <PayrollPeriodIdSelectFilter
                          payrollPeriodId={filterPayrollPeriodId}
                          setPayrollPeriodId={setFilterPayrollPeriodId}
                          payTypeId={filterPayTypeId}
                        />
                      </div>
                      <span
                        style={{
                          visibility: !filterPayTypeId ? "visible" : "hidden",
                          color: "#ff6565",
                          fontSize: "12px",
                        }}
                      >
                        Please fill up Pay Type first
                      </span>
                    </div>
                    {userAccess.length <= 0 && (
                      <div className="filter-item-payroll popUp-item info-item column">
                        <div className="info-item-label">
                          Classification Type
                        </div>
                        <div className="info-item-input">
                          <ClassificationIdSelectDummy />
                        </div>
                        <span
                          style={{
                            visibility: "hidden",
                            color: "#ff6565",
                            fontSize: "12px",
                          }}
                        >
                          Please fill up Pay Type first
                        </span>
                      </div>
                    )}
                    <div className="filter-item-payroll popUp-item info-item column">
                      <div className="info-item-label">Classification Type</div>
                      <div className="info-item-input">
                        <ClassificationIdSelectFilter
                          user={user}
                          classificationId={filterClassificationId}
                          setClassificationId={setFilterClassificationId}
                          payTypeId={filterPayTypeId}
                        />
                      </div>
                      <span
                        style={{
                          visibility: !filterPayTypeId ? "visible" : "hidden",
                          color: "#ff6565",
                          fontSize: "12px",
                        }}
                      >
                        Please fill up Pay Type first
                      </span>
                    </div>
                  </div>
                  { filterClassificationId.toString() === "2" &&
                  <div
                    className="payroll-item-holder info-item-holder row"
                    style={{
                      justifyContent: "start",
                      padding: "0 10px 20px 10px",
                    }}
                  >
                    <div className="filter-item-payroll popUp-item info-item column">
                      <div className="info-item-label">Location</div>
                      <div className="info-item-input">
                        <LocationIdSelect
                          locationId={filterLocationId}
                          setLocationId={setFilterLocationId}
                        />
                      </div>
                      <span
                        style={{
                          visibility: "hidden",
                          color: "#ff6565",
                          fontSize: "12px",
                        }}
                      >
                        Please fill up location first
                      </span>
                    </div>
                  </div>
                  }
                  { filterClassificationId.toString() === "3" &&
                  <div
                    className="payroll-item-holder info-item-holder row"
                    style={{
                      justifyContent: "start",
                      padding: "0 10px 20px 10px",
                    }}
                  >
                    <div className="filter-item-payroll popUp-item info-item column">
                      <div className="info-item-label">Location</div>
                      <div className="info-item-input">
                        <LocationIdSelect
                          locationId={filterLocationId}
                          setLocationId={setFilterLocationId}
                        />
                      </div>
                      <span
                        style={{
                          visibility: "hidden",
                          color: "#ff6565",
                          fontSize: "12px",
                        }}
                      >
                        Please fill up location first
                      </span>
                    </div>
                    <div className="filter-item-payroll popUp-item info-item column">
                      <div className="info-item-label">Section</div>
                      <div className="info-item-input">
                        <SectionIdSelect
                          sectionId={filterSectionId}
                          setSectionId={setFilterSectionId}
                        />
                      </div>
                      <span
                        style={{
                          visibility: "hidden",
                          color: "#ff6565",
                          fontSize: "12px",
                        }}
                      >
                        Please fill up section first
                      </span>
                    </div>
                  </div>
                  }
                  <div className="rightSide-btn" style={{ marginRight: "5px" }}>
                    {CreateButton(
                      "",
                      "generate row",
                      handleGenerate,
                      "GENERATE",
                      RestartAltIcon
                    )}
                  </div>
                </div>
              </div>
              <ShowTab
                type={type}
                setType={setType}
                filterPayrollPeriodId={filterPayrollPeriodId}
                filterPayTypeId={filterPayTypeId}
                filterClassificationId={filterClassificationId}
                userAccess={userAccess}
                payrollData={payrollData}
                setPayrollData={setPayrollData}
                payrollDataAdjustment={payrollDataAdjustment}
                setPayrollDataAdjustment={setPayrollDataAdjustment}
                otherAdditionData={otherAdditionData}
                otherDeductionData={otherDeductionData}
                otherAdjustmentData={otherAdjustmentData}
                otherLateAdjustmentData={otherLateAdjustmentData}
                setOtherAdditionData={setOtherAdditionData}
                setOtherDeductionData={setOtherDeductionData}
                setOtherAdjustmentData={setOtherAdjustmentData}
                setOtherLateAdjustmentData={setOtherLateAdjustmentData}
                showPostMessage={showPostMessage}
                isGenerate={isGenerate}
                setIsGenerate={setIsGenerate}
                isRevert={isRevert}
                isProcess={isProcess}
                isPost={isPost}
                isUpload={isUpload}
                setIsUpload={setIsUpload}
                loading={loading}
                fetchData={fetchDataProcessedPayroll}
                filterData={filterData}
                loadingOtherAddition={loadingOtherAddition}
                loadingOtherDedujction={loadingOtherDedujction}
                loadingAdjustment={loadingAdjustment}
                loadingLateAdjustment={loadingLateAdjustment}
                filterDataAddition={filterDataAddition}
                filterDataDeduction={filterDataDeduction}
                filterDataAdjustment={filterDataAdjustment}
                filterDataLateAdjustment={filterDataLateAdjustment}
                fetchAdditionData={fetchAdditionData}
                fetchDeductionData={fetchDeductionData}
                fetchAdjustmentData={fetchAdjustmentData}
                fetchLateAdjustmentData={fetchLateAdjustmentData}
                fetchDataProcessedPayroll={fetchDataProcessedPayroll}
                handleGenerateLateApprovedAdjustments={
                  handleGenerateLateApprovedAdjustments
                }
                openLateAdjustmentForm={openLateAdjustmentForm}
                user={user}
              />
            </div>
          </div>
        </div>
      </div>
      <UploadForm
        isOpen={showUploadForm}
        onClose={closeUploadFormHandleClick}
        payrollPeriodId={payrollIdForUpload}
        payTypeId={payTypeIdForUpload}
        setPayrollPeriodId={setPayrollIdForUpload}
        setPayTypeId={setPayTypeIdForUpload}
        type={settingType}
        data_temp={uploadAdjustments}
        setData_temp={setUploadAdjustments}
        handleFileUpload={handleFileUpload}
        handleFinalFileUpload={handleFinalFileUpload}
      ></UploadForm>
      <PostMessage
        isOpen={showPostMessage}
        onClose={closePostMessage}
        handlePost={handlePost}
      ></PostMessage>
      <RevertPayrollForm
        isOpen={showRevertPayrollForm}
        onClose={closeRevertPayrollForm}
        fetchOtherAddition={fetchAdditionData}
        fetchOtherDeduction={fetchDeductionData}
        fetchOtherAdjustment={fetchAdjustmentData}
        fetchLateAdjustmentData={fetchLateAdjustmentData}
        fetchProcess={fetchDataProcessedPayroll}
        setIsRevert={setIsRevert}
        isGenerate={isGenerate}
        user={user}
      ></RevertPayrollForm>
      <ProcessPayrollForm
        isOpen={showProcessPayrollForm}
        onClose={closeProcessPayrollForm}
        fetchOtherAddition={fetchAdditionData}
        fetchOtherDeduction={fetchDeductionData}
        fetchOtherAdjustment={fetchAdjustmentData}
        fetchLateAdjustmentData={fetchLateAdjustmentData}
        fetchProcess={fetchDataProcessedPayroll}
        setIsProcess={setIsProcess}
        isGenerate={isGenerate}
        user={user}
      ></ProcessPayrollForm>
      <PostPayrollForm
        isOpen={showPostPayrollForm}
        onClose={closePostPayrollForm}
        fetchOtherAddition={fetchAdditionData}
        fetchOtherDeduction={fetchDeductionData}
        fetchOtherAdjustment={fetchAdjustmentData}
        fetchLateAdjustmentData={fetchLateAdjustmentData}
        fetchProcess={fetchDataProcessedPayroll}
        setIsPost={setIsPost}
        isGenerate={isGenerate}
        user={user}
      ></PostPayrollForm>
      <SyncLateAdjustment
        isOpen={showLateAdjustmentForm}
        onClose={closeLateAdjustmentForm}
        fetchOtherAddition={fetchAdditionData}
        fetchOtherDeduction={fetchDeductionData}
        fetchOtherAdjustment={fetchAdjustmentData}
        fetchLateAdjustmentData={fetchLateAdjustmentData}
        fetchProcess={fetchDataProcessedPayroll}
        mainPayrollPeriod={filterPayrollPeriodId}
        setIsPost={setIsPost}
        isGenerate={isGenerate}
        user={user}
      ></SyncLateAdjustment>
      <GenerateMessage
        form={noDataMessage}
        message={"No data to post!"}
        isSuccess={false}
      ></GenerateMessage>
      <GenerateMessage
        form={successPostMessage}
        message={"Data posted!"}
        isSuccess={true}
      ></GenerateMessage>
      <GenerateMessage
        form={showRequestMessage}
        message={isSuccess ? "Request Success!" : requestMessage}
        isSuccess={isSuccess}
      ></GenerateMessage>
      <GenerateMessage
        form={generateMessage}
        message={
          "Please select payroll period, pay type and classification type!"
        }
        isSuccess={false}
      ></GenerateMessage>
      {loadingRequest ? (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: "3005",
          }}
        >
          <img src={loadingSpinner} alt="Loading..." />
        </div>
      ) : (
        <></>
      )}

      {loadingUploadRequest ? (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100vw",
            height: "100vh",
            zIndex: "10000",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            backgroundColor: "#ffffff59",
          }}
        >
          <img src={loadingSpinner} alt="Loading..." />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}

function ShowTab({
  type,
  setType,
  filterPayrollPeriodId,
  filterPayTypeId,
  filterClassificationId,
  userAccess,
  payrollData,
  setPayrollData,
  payrollDataAdjustment,
  setPayrollDataAdjustment,
  otherAdditionData,
  otherDeductionData,
  otherAdjustmentData,
  otherLateAdjustmentData,
  setOtherAdditionData,
  setOtherDeductionData,
  setOtherAdjustmentData,
  setOtherLateAdjustmentData,
  showPostMessage,
  isGenerate,
  setIsGenerate,
  isRevert,
  isProcess,
  isPost,
  isUpload,
  setIsUpload,

  loading,
  fetchData,
  filterData,
  loadingOtherAddition,
  loadingOtherDedujction,
  loadingAdjustment,
  loadingLateAdjustment,
  filterDataAddition,
  filterDataDeduction,
  filterDataAdjustment,
  filterDataLateAdjustment,
  fetchAdditionData,
  fetchDeductionData,
  fetchAdjustmentData,
  fetchLateAdjustmentData,
  fetchDataProcessedPayroll,
  handleGenerateLateApprovedAdjustments,
  openLateAdjustmentForm,
  user,
}) {
  var processedHeader = [
    "Id",
    "Employee Id",
    "Name",
    "Classification",
    "Pay Type",
    "Total Basic",
    "Rate",
    "Total Days",
    "Days Absent",
    "Absent/s",
    "Days Leave",
    "Leave/s",
    "Hours Undertime",
    "Undertime Value",
    "Undertime",
    "Hours Late",
    "Late Value",
    "Late",
    "Hours Night Differential",
    "Night Differential",
    "Allowance",
    "Benefits",
    "Benefits List",
    "Total Days Regular Holidays",
    "Total Regular Holiday Worked",
    "Total Regular Holidays",
    "Total Days Special Non-Working Holidays",
    "Total Special Non-Working Holidays",
    "Hours OT Regular",
    "Total OT Regular",
    // "Hours OT Exceeded",
    // "Total OT Exceeded",
    "Hours OT Restday",
    "Total OT Restday",
    // "Hours Exceeded",
    // "Total Exceeded",
    "Hours Holiday Special",
    "Total Holiday Special",
    // "Hours Exceeded",
    // "Total Exceeded",
    "Hours Holiday Regular",
    "Total Holiday Regular",
    // "Hours Exceeded",
    // "Total Exceeded",
    "Hours Restday Holiday Special",
    "Total Restday Holiday Special",
    // "Hours Exceeded",
    // "Total Exceeded",
    "Hours Restday Holiday Regular",
    "Total Restday Holiday Regular",
    // "Hours Exceeded",
    // "Total Exceeded",
    "SSS",
    "Pagibig",
    "Philhealth",
    "SSS Loan",
    "SSS Calamity Loan",
    "Pagibig Loan",
    "Pagibig Calamity Loan",
    "Cash Advance",
    "Other Cash Advance",
    "Other Cash Advance List",
    "Company Loans",
    "Company Loans List",
    "Tax",
    "Additions",
    "Deductions",
    "Adjustments",
    "Total Gross Pay",
    "Total Net Pay",
    "Date Processed",
    // "User ID",
    // ""
  ];
  var processedAccessor = [
    "id",
    "employeePersonalInformationEmployeeId",
    "employeePersonalInformationFullName",
    "classificationDescription",
    "payTypeDescription",
    "totalBasic",
    "rate",
    "totalDays",
    "totalDaysAbsents",
    "totalAbsents",
    "totalDaysLeaves",
    "totalLeaves",
    "totalHoursUndertime",
    "undertimeValue",
    "totalUndertime",
    "totalHoursLate",
    "lateValue",
    "totalLate",
    "totalNighDiff",
    "totalNighDiffAmount",
    "totalAllowance",
    "totalBenefits",
    "benefits",
    "totalDaysRegularHolidays",
    "totalRegularHolidayWorked",
    "totalRegularHolidays",
    "totalDaysSpecialNonWorkingHolidays",
    "totalSpecialNonWorkingHolidays",
    "totalHoursOTRegular",
    "totalOTRegular",
    // "totalHoursOTRegularExceeded",
    // "totalOTRegularExceeded",
    "totalHoursOTRestday",
    "totalOTRestday",
    // "totalHoursOTRestdayExceeded",
    // "totalOTRestdayExceeded",
    "totalHoursOTHolidaySpecial",
    "totalOTHolidaySpecial",
    // "totalHoursOTHolidaySpecialExceeded",
    // "totalOTHolidaySpecialExceeded",
    "totalHoursOTHolidayRegular",
    "totalOTHolidayRegular",
    // "totalHoursOTHolidayRegularExceeded",
    // "totalOTHolidayRegularExceeded",
    "totalHoursOTRestdayHolidaySpecial",
    "totalOTRestdayHolidaySpecial",
    // "totalHoursOTRestdayHolidaySpecialExceeded",
    // "totalOTRestdayHolidaySpecialExceeded",
    "totalHoursOTRestdayHolidayRegular",
    "totalOTRestdayHolidayRegular",
    // "totalHoursOTRestdayHolidayRegularExceeded",
    // "totalOTRestdayHolidayRegularExceeded",
    "totalSSS",
    "totalPagibig",
    "totalPhilhealth",
    "totalSSSLoan",
    "totalSSSCalamityLoan",
    "totalPagibigLoan",
    "totalPagibigCalamityLoan",
    "totalCashAdvance",
    "totalOtherCashAdvance",
    "otherCashAdvances",
    "totalCompanyLoan",
    "companyLoans",
    "totalTax",
    "totalAddition",
    "totalDeduction",
    "totalAdjustment",
    "totalGrossPay",
    "totalNetPay",
    "dateProcessed",
    // "userId",
    // "manage"
  ];
  const [currentPage, setCurrentPage] = useState(1);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  // Add
  const [showAddForm, setShowAddForm] = useState(false);
  const [payrollPeriodId, setPayrollPeriodId] = useState("");
  const [employeePersonalInformationId, setEmployeePersonalInformationId] =
    useState("");
  const [
    employeePersonalInformationFullName,
    setEmployeePersonalInformationFullName,
  ] = useState("");
  const [payTypeId, setPayTypeId] = useState("");
  const [totalEcola, setTotalEcola] = useState("");
  const [totalAllowance, setTotalAllowance] = useState("");
  const [totalTax, setTotalTax] = useState("");
  const [totalDays, setTotalDays] = useState("");
  const [totalDaysAbsents, setTotalDaysAbsents] = useState("");
  const [totalAbsents, setTotalAbsents] = useState("");
  const [totalDaysLeaves, setTotalDaysLeaves] = useState("");
  const [totalLeaves, setTotalLeaves] = useState("");
  const [totalDeduction, setTotalDeduction] = useState("");
  const [totalAddition, setTotalAddition] = useState("");
  const [totalAdjustment, setTotalAdjustment] = useState("");
  const [rate, setRate] = useState("");
  const [totalNighDiff, setTotalNighDiff] = useState("");
  const [totalHoursOTRegular, setTotalHoursOTRegular] = useState("");
  const [totalOTRegular, setTotalOTRegular] = useState("");
  const [totalHoursOTRegularExceeded, setTotalHoursOTRegularExceeded] =
    useState("");
  const [totalOTRegularExceeded, setTotalOTRegularExceeded] = useState("");
  const [totalHoursOTRestday, setTotalHoursOTRestday] = useState("");
  const [totalOTRestday, setTotalOTRestday] = useState("");
  const [totalHoursOTRestdayExceeded, setTotalHoursOTRestdayExceeded] =
    useState("");
  const [totalOTRestdayExceeded, setTotalOTRestdayExceeded] = useState("");
  const [totalHoursOTHolidaySpecial, setTotalHoursOTHolidaySpecial] =
    useState("");
  const [totalOTHolidaySpecial, setTotalOTHolidaySpecial] = useState("");
  const [
    totalHoursOTHolidaySpecialExceeded,
    setTotalHoursOTHolidaySpecialExceeded,
  ] = useState("");
  const [totalOTHolidaySpecialExceeded, setTotalOTHolidaySpecialExceeded] =
    useState("");
  const [totalHoursOTHolidayRegular, setTotalHoursOTHolidayRegular] =
    useState("");
  const [totalOTHolidayRegular, setTotalOTHolidayRegular] = useState("");
  const [
    totalHoursOTHolidayRegularExceeded,
    setTotalHoursOTHolidayRegularExceeded,
  ] = useState("");
  const [totalOTHolidayRegularExceeded, setTotalOTHolidayRegularExceeded] =
    useState("");
  const [
    totalHoursOTRestdayHolidaySpecial,
    setTotalHoursOTRestdayHolidaySpecial,
  ] = useState("");
  const [totalOTRestdayHolidaySpecial, setTotalOTRestdayHolidaySpecial] =
    useState("");
  const [
    totalHoursOTRestdayHolidaySpecialExceeded,
    setTotalHoursOTRestdayHolidaySpecialExceeded,
  ] = useState("");
  const [
    totalOTRestdayHolidaySpecialExceeded,
    setTotalOTRestdayHolidaySpecialExceeded,
  ] = useState("");
  const [
    totalHoursOTRestdayHolidayRegular,
    setTotalHoursOTRestdayHolidayRegular,
  ] = useState("");
  const [totalOTRestdayHolidayRegular, setTotalOTRestdayHolidayRegular] =
    useState("");
  const [
    totalHoursOTRestdayHolidayRegularExceeded,
    setTotalHoursOTRestdayHolidayRegularExceeded,
  ] = useState("");
  const [
    totalOTRestdayHolidayRegularExceeded,
    setTotalOTRestdayHolidayRegularExceeded,
  ] = useState("");
  const [totalSSS, setTotalSSS] = useState("");
  const [totalPagibig, setTotalPagibig] = useState("");
  const [totalPhilhealth, setTotalPhilhealth] = useState("");
  const [totalHoursUndertime, setTotalHoursUndertime] = useState("");
  const [totalUndertime, setTotalUndertime] = useState("");
  const [totalHoursLate, setTotalHoursLate] = useState("");
  const [totalLate, setTotalLate] = useState("");
  const [totalBasic, setTotalBasic] = useState("");
  const [totalGrossPay, setTotalGrossPay] = useState("");
  const [totalNetPay, setTotalNetPay] = useState("");
  const [dateProcessed, setDateProcessed] = useState("");
  const [userId, setUserId] = useState("");
  //Update
  const [showEditForm, setShowEditForm] = useState(false);
  const [editById, setEditById] = useState("");
  const [dataToEdit, setDataToEdit] = useState([]);
  // Delete
  const [showDeleteForm, setShowDeleteForm] = useState(false);
  const [deleteById, setDeleteById] = useState([]);
  // Delete All
  const [showDeleteAllForm, setShowDeleteAllForm] = useState(false);
  const [payrollIdForDelete, setPayrollIdForDelete] = useState("");

  const [showEmployeeForm, setShowEmployeeForm] = useState(false);
  // const [generateMessage, setGenerateMessage] = useState(false);
  const [successPostMessage, setSuccessPostMessage] = useState(false);
  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
    if (showRequestMessage) {
      const timeoutId = setTimeout(() => {
        setShowRequestMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }
  }, [showRequestMessage]);

  const apiUrl = domain + "/api/PayrollSummaryStaging/";

  const handleFilter = (value) => {
    setCurrentPage(1);
    const lowercaseValue = value.toLowerCase();
    var res = filterData.filter((f) =>
      f.employeePersonalInformationFullName
        .toLowerCase()
        .includes(lowercaseValue)
    );

    setPayrollData(res);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!payrollPeriodId || !employeePersonalInformationId || !payTypeId) {
      alert("Required to fill up all data");
      return; // Exit early if fields are empty
    }

    const currentDate = new Date();

    const data = {
      payrollPeriodId: payrollPeriodId,
      employeePersonalInformationId: employeePersonalInformationId,
      payTypeId: payTypeId,
      totalEcola: totalEcola ? totalEcola : 0,
      totalAllowance: totalAllowance ? totalAllowance : 0,
      totalTax: totalTax ? totalTax : 0,
      totalDays: totalDays ? totalDays : 0,
      totalDaysAbsents: totalDaysAbsents ? totalDaysAbsents : 0,
      totalAbsents: totalAbsents ? totalAbsents : 0,
      totalDaysLeaves: totalDaysLeaves ? totalDaysLeaves : 0,
      totalLeaves: totalLeaves ? totalLeaves : 0,
      totalDeduction: totalDeduction ? totalDeduction : 0,
      totalAddition: totalAddition ? totalAddition : 0,
      totalAdjustment: totalAdjustment ? totalAdjustment : 0,
      rate: rate ? rate : 0,
      totalNighDiff: totalNighDiff ? totalNighDiff : 0,
      totalHoursOTRegular: totalHoursOTRegular ? totalHoursOTRegular : 0,
      totalOTRegular: totalOTRegular ? totalOTRegular : 0,
      totalHoursOTRegularExceeded: totalHoursOTRegularExceeded
        ? totalHoursOTRegularExceeded
        : 0,
      totalOTRegularExceeded: totalOTRegularExceeded
        ? totalOTRegularExceeded
        : 0,
      totalHoursOTRestday: totalHoursOTRestday ? totalHoursOTRestday : 0,
      totalOTRestday: totalOTRestday ? totalOTRestday : 0,
      totalHoursOTRestdayExceeded: totalHoursOTRestdayExceeded
        ? totalHoursOTRestdayExceeded
        : 0,
      totalOTRestdayExceeded: totalOTRestdayExceeded
        ? totalOTRestdayExceeded
        : 0,
      totalHoursOTHolidaySpecial: totalHoursOTHolidaySpecial
        ? totalHoursOTHolidaySpecial
        : 0,
      totalOTHolidaySpecial: totalOTHolidaySpecial ? totalOTHolidaySpecial : 0,
      totalHoursOTHolidaySpecialExceeded: totalHoursOTHolidaySpecialExceeded
        ? totalHoursOTHolidaySpecialExceeded
        : 0,
      totalOTHolidaySpecialExceeded: totalOTHolidaySpecialExceeded
        ? totalOTHolidaySpecialExceeded
        : 0,
      totalHoursOTHolidayRegular: totalHoursOTHolidayRegular
        ? totalHoursOTHolidayRegular
        : 0,
      totalOTHolidayRegular: totalOTHolidayRegular ? totalOTHolidayRegular : 0,
      totalHoursOTHolidayRegularExceeded: totalHoursOTHolidayRegularExceeded
        ? totalHoursOTHolidayRegularExceeded
        : 0,
      totalOTHolidayRegularExceeded: totalOTHolidayRegularExceeded
        ? totalOTHolidayRegularExceeded
        : 0,
      totalHoursOTRestdayHolidaySpecial: totalHoursOTRestdayHolidaySpecial
        ? totalHoursOTRestdayHolidaySpecial
        : 0,
      totalOTRestdayHolidaySpecial: totalOTRestdayHolidaySpecial
        ? totalOTRestdayHolidaySpecial
        : 0,
      totalHoursOTRestdayHolidaySpecialExceeded:
        totalHoursOTRestdayHolidaySpecialExceeded
          ? totalHoursOTRestdayHolidaySpecialExceeded
          : 0,
      totalOTRestdayHolidaySpecialExceeded: totalOTRestdayHolidaySpecialExceeded
        ? totalOTRestdayHolidaySpecialExceeded
        : 0,
      totalHoursOTRestdayHolidayRegular: totalHoursOTRestdayHolidayRegular
        ? totalHoursOTRestdayHolidayRegular
        : 0,
      totalOTRestdayHolidayRegular: totalOTRestdayHolidayRegular
        ? totalOTRestdayHolidayRegular
        : 0,
      totalHoursOTRestdayHolidayRegularExceeded:
        totalHoursOTRestdayHolidayRegularExceeded
          ? totalHoursOTRestdayHolidayRegularExceeded
          : 0,
      totalOTRestdayHolidayRegularExceeded: totalOTRestdayHolidayRegularExceeded
        ? totalOTRestdayHolidayRegularExceeded
        : 0,
      totalSSS: totalSSS ? totalSSS : 0,
      totalPagibig: totalPagibig ? totalPagibig : 0,
      totalPhilhealth: totalPhilhealth ? totalPhilhealth : 0,
      totalHoursUndertime: totalHoursUndertime ? totalHoursUndertime : 0,
      totalUndertime: totalUndertime ? totalUndertime : 0,
      totalHoursLate: totalHoursLate ? totalHoursLate : 0,
      totalLate: totalLate ? totalLate : 0,
      totalBasic: totalBasic ? totalBasic : 0,
      totalGrossPay: totalGrossPay ? totalGrossPay : 0,
      totalNetPay: totalNetPay ? totalNetPay : 0,
      dateProcessed: currentDate,
      userId: userId ? userId : 0,
    };

    try {
      setLoadingRequest(true);
      await axios.post(apiUrl, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      console.log("Data added successfully");
      setShowRequestMessage(true);
      setIsSuccess(true);

      // Reload table data and reset form fields
      await fetchData(); // Assuming fetchData() fetches the updated data for the table
      setPayrollPeriodId("");
      setEmployeePersonalInformationId("");
      setPayTypeId("");
      setTotalEcola("");
      setTotalAllowance("");
      setTotalTax("");
      setTotalDays("");
      setTotalDaysAbsents("");
      setTotalAbsents("");
      setTotalDaysLeaves("");
      setTotalLeaves("");
      setTotalDeduction("");
      setTotalAddition("");
      setTotalAdjustment("");
      setRate("");
      setTotalNighDiff("");
      setTotalHoursOTRegular("");
      setTotalOTRegular("");
      setTotalHoursOTRegularExceeded("");
      setTotalOTRegularExceeded("");
      setTotalHoursOTRestday("");
      setTotalOTRestday("");
      setTotalHoursOTRestdayExceeded("");
      setTotalOTRestdayExceeded("");
      setTotalHoursOTHolidaySpecial("");
      setTotalOTHolidaySpecial("");
      setTotalHoursOTHolidaySpecialExceeded("");
      setTotalOTHolidaySpecialExceeded("");
      setTotalHoursOTHolidayRegular("");
      setTotalOTHolidayRegular("");
      setTotalHoursOTHolidayRegularExceeded("");
      setTotalOTHolidayRegularExceeded("");
      setTotalHoursOTRestdayHolidaySpecial("");
      setTotalOTRestdayHolidaySpecial("");
      setTotalHoursOTRestdayHolidaySpecialExceeded("");
      setTotalOTRestdayHolidaySpecialExceeded("");
      setTotalHoursOTRestdayHolidayRegular("");
      setTotalOTRestdayHolidayRegular("");
      setTotalHoursOTRestdayHolidayRegularExceeded("");
      setTotalOTRestdayHolidayRegularExceeded("");
      setTotalSSS("");
      setTotalPagibig("");
      setTotalPhilhealth("");
      setTotalHoursUndertime("");
      setTotalUndertime("");
      setTotalHoursLate("");
      setTotalLate("");
      setTotalBasic("");
      setTotalGrossPay("");
      setTotalNetPay("");
      setDateProcessed("");
      setUserId("");
      setShowAddForm(false); // Hide the add form
    } catch (error) {
      console.error("There was a problem adding data:", error);
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error("Error:", error);
      const errorMessage = JSON.parse(
        error.response.request.responseText
      ).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }

    setShowAddForm(false);
  };
  const handleUpdate = async (event) => {
    event.preventDefault();

    if (!payrollPeriodId || !employeePersonalInformationId || !payTypeId) {
      alert("Required to fill up all data");
      return; // Exit early if fields are empty
    }

    const data = {
      payrollPeriodId: payrollPeriodId,
      employeePersonalInformationId: employeePersonalInformationId,
      payTypeId: payTypeId,
      totalEcola: totalEcola ? totalEcola : 0,
      totalAllowance: totalAllowance ? totalAllowance : 0,
      totalTax: totalTax ? totalTax : 0,
      totalDays: totalDays ? totalDays : 0,
      totalDaysAbsents: totalDaysAbsents ? totalDaysAbsents : 0,
      totalAbsents: totalAbsents ? totalAbsents : 0,
      totalDaysLeaves: totalDaysLeaves ? totalDaysLeaves : 0,
      totalLeaves: totalLeaves ? totalLeaves : 0,
      totalDeduction: totalDeduction ? totalDeduction : 0,
      totalAddition: totalAddition ? totalAddition : 0,
      totalAdjustment: totalAdjustment ? totalAdjustment : 0,
      rate: rate ? rate : 0,
      totalNighDiff: totalNighDiff ? totalNighDiff : 0,
      totalHoursOTRegular: totalHoursOTRegular ? totalHoursOTRegular : 0,
      totalOTRegular: totalOTRegular ? totalOTRegular : 0,
      totalHoursOTRegularExceeded: totalHoursOTRegularExceeded
        ? totalHoursOTRegularExceeded
        : 0,
      totalOTRegularExceeded: totalOTRegularExceeded
        ? totalOTRegularExceeded
        : 0,
      totalHoursOTRestday: totalHoursOTRestday ? totalHoursOTRestday : 0,
      totalOTRestday: totalOTRestday ? totalOTRestday : 0,
      totalHoursOTRestdayExceeded: totalHoursOTRestdayExceeded
        ? totalHoursOTRestdayExceeded
        : 0,
      totalOTRestdayExceeded: totalOTRestdayExceeded
        ? totalOTRestdayExceeded
        : 0,
      totalHoursOTHolidaySpecial: totalHoursOTHolidaySpecial
        ? totalHoursOTHolidaySpecial
        : 0,
      totalOTHolidaySpecial: totalOTHolidaySpecial ? totalOTHolidaySpecial : 0,
      totalHoursOTHolidaySpecialExceeded: totalHoursOTHolidaySpecialExceeded
        ? totalHoursOTHolidaySpecialExceeded
        : 0,
      totalOTHolidaySpecialExceeded: totalOTHolidaySpecialExceeded
        ? totalOTHolidaySpecialExceeded
        : 0,
      totalHoursOTHolidayRegular: totalHoursOTHolidayRegular
        ? totalHoursOTHolidayRegular
        : 0,
      totalOTHolidayRegular: totalOTHolidayRegular ? totalOTHolidayRegular : 0,
      totalHoursOTHolidayRegularExceeded: totalHoursOTHolidayRegularExceeded
        ? totalHoursOTHolidayRegularExceeded
        : 0,
      totalOTHolidayRegularExceeded: totalOTHolidayRegularExceeded
        ? totalOTHolidayRegularExceeded
        : 0,
      totalHoursOTRestdayHolidaySpecial: totalHoursOTRestdayHolidaySpecial
        ? totalHoursOTRestdayHolidaySpecial
        : 0,
      totalOTRestdayHolidaySpecial: totalOTRestdayHolidaySpecial
        ? totalOTRestdayHolidaySpecial
        : 0,
      totalHoursOTRestdayHolidaySpecialExceeded:
        totalHoursOTRestdayHolidaySpecialExceeded
          ? totalHoursOTRestdayHolidaySpecialExceeded
          : 0,
      totalOTRestdayHolidaySpecialExceeded: totalOTRestdayHolidaySpecialExceeded
        ? totalOTRestdayHolidaySpecialExceeded
        : 0,
      totalHoursOTRestdayHolidayRegular: totalHoursOTRestdayHolidayRegular
        ? totalHoursOTRestdayHolidayRegular
        : 0,
      totalOTRestdayHolidayRegular: totalOTRestdayHolidayRegular
        ? totalOTRestdayHolidayRegular
        : 0,
      totalHoursOTRestdayHolidayRegularExceeded:
        totalHoursOTRestdayHolidayRegularExceeded
          ? totalHoursOTRestdayHolidayRegularExceeded
          : 0,
      totalOTRestdayHolidayRegularExceeded: totalOTRestdayHolidayRegularExceeded
        ? totalOTRestdayHolidayRegularExceeded
        : 0,
      totalSSS: totalSSS ? totalSSS : 0,
      totalPagibig: totalPagibig ? totalPagibig : 0,
      totalPhilhealth: totalPhilhealth ? totalPhilhealth : 0,
      totalHoursUndertime: totalHoursUndertime ? totalHoursUndertime : 0,
      totalUndertime: totalUndertime ? totalUndertime : 0,
      totalHoursLate: totalHoursLate ? totalHoursLate : 0,
      totalLate: totalLate ? totalLate : 0,
      totalBasic: totalBasic ? totalBasic : 0,
      totalGrossPay: totalGrossPay ? totalGrossPay : 0,
      totalNetPay: totalNetPay ? totalNetPay : 0,
      dateProcessed: dateProcessed,
      userId: userId ? userId : 0,
    };

    try {
      setLoadingRequest(true);
      await axios.put(apiUrl + `${editById}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      console.log("Data added successfully");
      setShowRequestMessage(true);
      setIsSuccess(true);

      // Reload table data and reset form fields
      await fetchData(); // Assuming fetchData() fetches the updated data for the table
      setPayrollPeriodId("");
      setEmployeePersonalInformationId("");
      setPayTypeId("");
      setTotalEcola("");
      setTotalAllowance("");
      setTotalTax("");
      setTotalDays("");
      setTotalDaysAbsents("");
      setTotalAbsents("");
      setTotalDaysLeaves("");
      setTotalLeaves("");
      setTotalDeduction("");
      setTotalAddition("");
      setTotalAdjustment("");
      setRate("");
      setTotalNighDiff("");
      setTotalHoursOTRegular("");
      setTotalOTRegular("");
      setTotalHoursOTRegularExceeded("");
      setTotalOTRegularExceeded("");
      setTotalHoursOTRestday("");
      setTotalOTRestday("");
      setTotalHoursOTRestdayExceeded("");
      setTotalOTRestdayExceeded("");
      setTotalHoursOTHolidaySpecial("");
      setTotalOTHolidaySpecial("");
      setTotalHoursOTHolidaySpecialExceeded("");
      setTotalOTHolidaySpecialExceeded("");
      setTotalHoursOTHolidayRegular("");
      setTotalOTHolidayRegular("");
      setTotalHoursOTHolidayRegularExceeded("");
      setTotalOTHolidayRegularExceeded("");
      setTotalHoursOTRestdayHolidaySpecial("");
      setTotalOTRestdayHolidaySpecial("");
      setTotalHoursOTRestdayHolidaySpecialExceeded("");
      setTotalOTRestdayHolidaySpecialExceeded("");
      setTotalHoursOTRestdayHolidayRegular("");
      setTotalOTRestdayHolidayRegular("");
      setTotalHoursOTRestdayHolidayRegularExceeded("");
      setTotalOTRestdayHolidayRegularExceeded("");
      setTotalSSS("");
      setTotalPagibig("");
      setTotalPhilhealth("");
      setTotalHoursUndertime("");
      setTotalUndertime("");
      setTotalHoursLate("");
      setTotalLate("");
      setTotalBasic("");
      setTotalGrossPay("");
      setTotalNetPay("");
      setDateProcessed("");
      setUserId("");
      setShowEditForm(false); // Hide the add form
    } catch (error) {
      console.error("There was a problem adding data:", error);
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error("Error:", error);
      const errorMessage = JSON.parse(
        error.response.request.responseText
      ).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }

    setShowEditForm(false);
  };
  const handleDelete = async () => {
    try {
      setLoadingRequest(true);
      await axios.delete(apiUrl + `${deleteById}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      console.log("Deleted successfully");
      setShowRequestMessage(true);
      setIsSuccess(true);

      // Reload table data and reset state
      await fetchData(); // Assuming fetchData() fetches the updated data for the table
      setShowDeleteForm(false);
      setDeleteById("");
    } catch (error) {
      console.error("There was a problem deleting employee:", error);
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error("Error:", error);
      const errorMessage = JSON.parse(
        error.response.request.responseText
      ).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }

    setShowDeleteForm(false);
  };
  const handleDeleteAll = async () => {
    if (!payrollIdForDelete) {
      alert("Please select payroll period id");
      return; // Exit early if fields are empty
    }

    try {
      setLoadingRequest(true);
      await axios.delete(apiUrl + `payrollperiod/${payrollIdForDelete}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      await SetAuditTrail({
        setupArea: "Payroll",
        actionTaken: "logout",
        field: "Processed Delete All",
        newValue: `-`,
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id,
      });

      await fetchData(); // Assuming fetchData() fetches the updated data for the table

      console.log("Deleted successfully");
      setShowRequestMessage(true);
      setIsSuccess(true);

      // Reload table data and reset state
      setShowDeleteAllForm(false);
      setPayrollIdForDelete("");
    } catch (error) {
      console.error("There was a problem deleting employee:", error);
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error("Error:", error);
      const errorMessage = JSON.parse(
        error.response.request.responseText
      ).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }

    setShowDeleteAllForm(false);
  };
  const handleGenerate = useCallback(async () => {
    await fetchAdditionData();
    await fetchDeductionData();
    await fetchAdjustmentData();
    await fetchLateAdjustmentData();
    await fetchDataProcessedPayroll();
  }, [
    fetchAdditionData,
    fetchDeductionData,
    fetchAdjustmentData,
    fetchLateAdjustmentData,
    fetchDataProcessedPayroll,
  ]);
  useEffect(() => {
    fetchAdditionData();
    fetchDeductionData();
    fetchAdjustmentData();
    fetchLateAdjustmentData();
    fetchDataProcessedPayroll();
  }, [
    type,
    handleGenerate,
    showPostMessage,
    fetchAdditionData,
    fetchDeductionData,
    fetchAdjustmentData,
    fetchLateAdjustmentData,
    fetchDataProcessedPayroll,
    isGenerate,
    isRevert,
    isProcess,
    isPost,
    isUpload,
  ]);

  const handleSelectChange = (index) => {
    setSelectedTab(index);
    setType(index);
  };

  useEffect(() => {
    if (showEditForm) {
      setPayrollPeriodId(dataToEdit.payrollPeriodId);
      setEmployeePersonalInformationId(
        dataToEdit.employeePersonalInformationId
      );
      setEmployeePersonalInformationFullName(
        dataToEdit.employeePersonalInformationFullName
      );
      setPayTypeId(dataToEdit.payTypeId);
      setTotalEcola(dataToEdit.totalEcola);
      setTotalAllowance(dataToEdit.totalAllowance);
      setTotalTax(dataToEdit.totalTax);
      setTotalDays(dataToEdit.totalDays);
      setTotalDaysAbsents(dataToEdit.totalDaysAbsents);
      setTotalAbsents(dataToEdit.totalAbsents);
      setTotalDaysLeaves(dataToEdit.totalDaysLeaves);
      setTotalLeaves(dataToEdit.totalLeaves);
      setTotalDeduction(dataToEdit.totalDeduction);
      setTotalAddition(dataToEdit.totalAddition);
      setTotalAdjustment(dataToEdit.totalAdjustment);
      setRate(dataToEdit.rate);
      setTotalNighDiff(dataToEdit.totalNighDiff);
      setTotalHoursOTRegular(dataToEdit.totalHoursOTRegular);
      setTotalOTRegular(dataToEdit.totalOTRegular);
      setTotalHoursOTRegularExceeded(dataToEdit.totalHoursOTRegularExceeded);
      setTotalOTRegularExceeded(dataToEdit.totalOTRegularExceeded);
      setTotalHoursOTRestday(dataToEdit.totalHoursOTRestday);
      setTotalOTRestday(dataToEdit.totalOTRestday);
      setTotalHoursOTRestdayExceeded(dataToEdit.totalHoursOTRestdayExceeded);
      setTotalOTRestdayExceeded(dataToEdit.totalOTRestdayExceeded);
      setTotalHoursOTHolidaySpecial(dataToEdit.totalHoursOTHolidaySpecial);
      setTotalOTHolidaySpecial(dataToEdit.totalOTHolidaySpecial);
      setTotalHoursOTHolidaySpecialExceeded(
        dataToEdit.totalHoursOTHolidaySpecialExceeded
      );
      setTotalOTHolidaySpecialExceeded(
        dataToEdit.totalOTHolidaySpecialExceeded
      );
      setTotalHoursOTHolidayRegular(dataToEdit.totalHoursOTHolidayRegular);
      setTotalOTHolidayRegular(dataToEdit.totalOTHolidayRegular);
      setTotalHoursOTHolidayRegularExceeded(
        dataToEdit.totalHoursOTHolidayRegularExceeded
      );
      setTotalOTHolidayRegularExceeded(
        dataToEdit.totalOTHolidayRegularExceeded
      );
      setTotalHoursOTRestdayHolidaySpecial(
        dataToEdit.totalHoursOTRestdayHolidaySpecial
      );
      setTotalOTRestdayHolidaySpecial(dataToEdit.totalOTRestdayHolidaySpecial);
      setTotalHoursOTRestdayHolidaySpecialExceeded(
        dataToEdit.totalHoursOTRestdayHolidaySpecialExceeded
      );
      setTotalOTRestdayHolidaySpecialExceeded(
        dataToEdit.totalOTRestdayHolidaySpecialExceeded
      );
      setTotalHoursOTRestdayHolidayRegular(
        dataToEdit.totalHoursOTRestdayHolidayRegular
      );
      setTotalOTRestdayHolidayRegular(dataToEdit.totalOTRestdayHolidayRegular);
      setTotalHoursOTRestdayHolidayRegularExceeded(
        dataToEdit.totalHoursOTRestdayHolidayRegularExceeded
      );
      setTotalOTRestdayHolidayRegularExceeded(
        dataToEdit.totalOTRestdayHolidayRegularExceeded
      );
      setTotalSSS(dataToEdit.totalSSS);
      setTotalPagibig(dataToEdit.totalPagibig);
      setTotalPhilhealth(dataToEdit.totalPhilhealth);
      setTotalHoursUndertime(dataToEdit.totalHoursUndertime);
      setTotalUndertime(dataToEdit.totalUndertime);
      setTotalHoursLate(dataToEdit.totalHoursLate);
      setTotalLate(dataToEdit.totalLate);
      setTotalBasic(dataToEdit.totalBasic);
      setTotalGrossPay(dataToEdit.totalGrossPay);
      setTotalNetPay(dataToEdit.totalNetPay);
      setDateProcessed(dataToEdit.dateProcessed);
      setUserId(dataToEdit.userId);
    }

    if (successPostMessage) {
      const timeoutId = setTimeout(() => {
        setSuccessPostMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }
  }, [
    showEditForm,
    dataToEdit,
    successPostMessage,
    type,
    handleGenerate,
    showPostMessage,
    fetchData,
    isGenerate,
    isRevert,
    isProcess,
    isPost,
  ]);
  const editHandleClick = (data) => {
    setEditById(data.id);
    setDataToEdit(data);
    setShowEditForm(true);
  };
  const deleteHandleClick = (data) => {
    setShowDeleteForm(true);
    setDeleteById(data.id);
  };
  const deleteAllHandleClick = (data) => {
    setShowDeleteAllForm(true);
  };
  const closeAddHandleClick = () => {
    setShowAddForm(false);
  };
  const closeEditHandleClick = () => {
    setShowEditForm(false);
  };
  const closeDeleteHandleClick = () => {
    setShowDeleteForm(false);
  };
  const closeDeleteAllHandleClick = () => {
    setShowDeleteAllForm(false);
  };
  const closeEmployeeForm = () => {
    setShowEmployeeForm(false);
  };

  function formatDate(dateString) {
    if (!dateString) {
      return "";
    }
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based in JavaScript
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }

  const exportToExcel = async () => {
    if (payrollData.length === 0) {
      setShowRequestMessage(true);
      setIsSuccess(false);
      setRequestMessage("No data to extract");
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet();

    const arrayList = (type, value) => {
      if (type === "otherCashAdvances" || type === "companyLoans") {
        if (Array.isArray(value) && value.length > 0) {
          // Format each cash advance as 'description - defaultDeduction'
          return value
            .map((ca) => `${ca.description} - ${ca.defaultDeduction}`)
            .join(", ");
        }
        return "";
      }

      if (type === "benefits") {
        if (Array.isArray(value) && value.length > 0) {
          // Format each cash advance as 'description - defaultDeduction'
          return value.map((ca) => `${ca.name} - ${ca.amount}`).join(", ");
        }
        return "";
      }
    };

    const header = [
      "Id",
      "Employee Id",
      "Name",
      "Classification",
      "Pay Type",
      "Total Basic",
      "Rate",
      "Total Days",
      "Days Absent",
      "Absent/s",
      "Days Leave",
      "Leave/s",
      "Hours Undertime",
      "Undertime Value",
      "Undertime",
      "Hours Late",
      "Late Value",
      "Late",
      "Hours Night Differential",
      "Night Differential",
      "Allowance",
      "Benefits",
      "Benefits List",
      "Total Days Regular Holidays",
      "Total Regular Holiday Worked",
      "Total Regular Holidays",
      "Total Days Special Non-Working Holidays",
      "Total Special Non-Working Holidays",
      "Hours OT Regular",
      "Total OT Regular",
      "Hours OT Restday",
      "Total OT Restday",
      "Hours Holiday Special",
      "Total Holiday Special",
      "Hours Holiday Regular",
      "Total Holiday Regular",
      "Hours Restday Holiday Special",
      "Total Restday Holiday Special",
      "Hours Restday Holiday Regular",
      "Total Restday Holiday Regular",
      "SSS",
      "Pagibig",
      "Philhealth",
      "SSS Loan",
      "SSS Calamity Loan",
      "Pagibig Loan",
      "Pagibig Calamity Loan",
      "Cash Advance",
      "Other Cash Advance",
      "Other Cash Advance List",
      "Company Loans",
      "Company Loans List",
      "Tax",
      "Additions",
      "Deductions",
      "Adjustments",
      "Total Gross Pay",
      "Total Net Pay",
      "Date Processed",
    ];
    const headerRow = worksheet.addRow(header);
    worksheet.columns = [
      { key: "id", width: 30 },
      { key: "employeePersonalInformationEmployeeId", width: 30 },
      { key: "employeePersonalInformationFullName", width: 30 },
      { key: "classificationDescription", width: 30 },
      { key: "payTypeDescription", width: 30 },
      { key: "totalBasic", width: 30 },
      { key: "rate", width: 20 },
      { key: "totalDays", width: 20 },
      { key: "totalDaysAbsents", width: 20 },
      { key: "totalAbsents", width: 20 },
      { key: "totalDaysLeaves", width: 20 },
      { key: "totalLeaves", width: 20 },
      { key: "totalHoursUndertime", width: 20 },
      { key: "undertimeValue", width: 20 },
      { key: "totalUndertime", width: 20 },
      { key: "totalHoursLate", width: 20 },
      { key: "lateValue", width: 20 },
      { key: "totalLate", width: 20 },
      { key: "totalNighDiff", width: 20 },
      { key: "totalNighDiffAmount", width: 20 },
      { key: "totalAllowance", width: 20 },
      { key: "totalBenefits", width: 20 },
      { key: "benefits", width: 20 },
      { key: "totalDaysRegularHolidays", width: 20 },
      { key: "totalRegularHolidayWorked", width: 20 },
      { key: "totalRegularHolidays", width: 20 },
      { key: "totalDaysSpecialNonWorkingHolidays", width: 20 },
      { key: "totalSpecialNonWorkingHolidays", width: 20 },
      { key: "totalHoursOTRegular", width: 20 },
      { key: "totalOTRegular", width: 20 },
      { key: "totalHoursOTRestday", width: 20 },
      { key: "totalOTRestday", width: 20 },
      { key: "totalHoursOTHolidaySpecial", width: 20 },
      { key: "totalOTHolidaySpecial", width: 20 },
      { key: "totalHoursOTHolidayRegular", width: 20 },
      { key: "totalOTHolidayRegular", width: 20 },
      { key: "totalSSS", width: 20 },
      { key: "totalPagibig", width: 20 },
      { key: "totalPhilhealth", width: 20 },
      { key: "totalSSSLoan", width: 20 },
      { key: "totalSSSCalamityLoan", width: 20 },
      { key: "totalPagibigLoan", width: 20 },
      { key: "totalPagibigCalamityLoan", width: 20 },
      { key: "totalCashAdvance", width: 20 },
      { key: "totalOtherCashAdvance", width: 20 },
      { key: "otherCashAdvances", width: 20 },
      { key: "totalCompanyLoan", width: 20 },
      { key: "companyLoans", width: 20 },
      { key: "totalTax", width: 20 },
      { key: "totalAddition", width: 20 },
      { key: "totalDeduction", width: 20 },
      { key: "totalAdjustment", width: 20 },
      { key: "totalGrossPay", width: 20 },
      { key: "totalNetPay", width: 20 },
      { key: "dateProcessed", width: 20 },
    ];
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center" };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "92d050" },
      };
    });

    payrollData.forEach((item) => {
      worksheet.addRow([
        item.id,
        item.employeePersonalInformationEmployeeId,
        item.employeePersonalInformationFullName,
        item.classificationDescription,
        item.payTypeDescription,
        item.totalBasic.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.rate.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalDays.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalDaysAbsents.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalAbsents.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalDaysLeaves.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalLeaves.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalHoursUndertime.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.undertimeValue.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalUndertime.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),

        item.totalHoursLate.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.lateValue.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalLate.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalNighDiff.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalNighDiffAmount.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalAllowance.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalBenefits.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        arrayList("benefits", item.benefits),
        item.totalDaysRegularHolidays.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalRegularHolidayWorked.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalRegularHolidays,
        item.totalDaysSpecialNonWorkingHolidays.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalSpecialNonWorkingHolidays.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalHoursOTRegular.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalOTRegular.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalHoursOTRestday.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalOTRestday.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalHoursOTHolidaySpecial.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalOTHolidaySpecial.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalHoursOTHolidayRegular.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalOTHolidayRegular.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalHoursOTRestdayHolidaySpecial.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalOTRestdayHolidaySpecial.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalHoursOTRestdayHolidayRegular.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalOTRestdayHolidayRegular.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalSSS.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalPagibig.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalPhilhealth.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalSSSLoan.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalSSSCalamityLoan.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalPagibigLoan.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalPagibigCalamityLoan.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalCashAdvance.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalOtherCashAdvance.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        arrayList("otherCashAdvances", item.otherCashAdvances),
        item.totalCompanyLoan.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        arrayList("companyLoans", item.companyLoans),
        item.totalTax.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalAddition.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalDeduction.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalAdjustment.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalGrossPay.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        item.totalNetPay.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        formatDate(item.dateProcessed),
      ]);
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, "Payroll_data.xlsx");
  };

  return (
    <div>
      <Tabs
        selectedIndex={selectedTab}
        onSelect={(index) => handleSelectChange(index)}
      >
        <TabList>
          <Tab>
            <b>ADJUSTMENTS</b>
          </Tab>
          <Tab>
            <b>PROCESSED</b>
          </Tab>
        </TabList>
        <div className="payrollTab">
          <TabPanel>
            <div>
              <ShowAdjustmentButtons
                otherAdditionData={otherAdditionData}
                otherDeductionData={otherDeductionData}
                otherAdjustmentData={otherAdjustmentData}
                otherLateAdjustmentData={otherLateAdjustmentData}
                setOtherAdditionData={setOtherAdditionData}
                setOtherDeductionData={setOtherDeductionData}
                setOtherAdjustmentData={setOtherAdjustmentData}
                setOtherLateAdjustmentData={setOtherLateAdjustmentData}
                payrollData={payrollDataAdjustment}
                setPayrollData={setPayrollDataAdjustment}
                filterPayrollPeriodId={filterPayrollPeriodId}
                filterPayTypeId={filterPayTypeId}
                filterClassificationId={filterClassificationId}
                userAccess={userAccess}
                type={type}
                showPostMessage={showPostMessage}
                isGenerate={isGenerate}
                setIsGenerate={setIsGenerate}
                isRevert={isRevert}
                isProcess={isProcess}
                isPost={isPost}
                isUpload={isUpload}
                setIsUpload={setIsUpload}
                loadingOtherAddition={loadingOtherAddition}
                loadingOtherDedujction={loadingOtherDedujction}
                loadingAdjustment={loadingAdjustment}
                loadingLateAdjustment={loadingLateAdjustment}
                filterDataAddition={filterDataAddition}
                filterDataDeduction={filterDataDeduction}
                filterDataAdjustment={filterDataAdjustment}
                filterDataLateAdjustment={filterDataLateAdjustment}
                fetchAdditionData={fetchAdditionData}
                fetchDeductionData={fetchDeductionData}
                fetchAdjustmentData={fetchAdjustmentData}
                fetchLateAdjustmentData={fetchLateAdjustmentData}
                fetchDataProcessedPayroll={fetchDataProcessedPayroll}
                handleGenerateLateApprovedAdjustments={
                  handleGenerateLateApprovedAdjustments
                }
                openLateAdjustmentForm={openLateAdjustmentForm}
                user={user}
              />
            </div>
          </TabPanel>

          <TabPanel>
            <div className="mainte-body-top row">
              {CreateSearchBarWithPlaceHolder(
                "",
                "mainte-search row",
                "mainte-search-icon",
                "mainte-search-input",
                (e) => handleFilter(e.target.value),
                "Search by name",
                SearchIcon
              )}
            </div>
            <div className="payroll-tab-header row">
              <div className="payroll-tab-leftSide">
                <div className="leftSide-btn row" style={{ padding: "10px" }}>
                  {/* <button onClick={postHandleClick} className='post row' style={{marginRight:"5px"}}><PostAddIcon/> POST</button> */}
                  <button
                    onClick={exportToExcel}
                    className="extract row"
                    style={{ marginRight: "5px" }}
                  >
                    <FileOpenIcon /> EXTRACT
                  </button>
                  {/* <button onClick={addHandleClick} className='add row' style={{marginRight:"5px"}}><NoteAddIcon/> ADD</button> */}
                  <button onClick={deleteAllHandleClick} className="delete row">
                    <NoteAddIcon /> DELETE ALL
                  </button>
                </div>
              </div>
            </div>
            <div className="payroll-table2 container">
              <CreateTable
                dataList={payrollData}
                dataHeader={processedHeader}
                dataAccessor={processedAccessor}
                editHandleClick={editHandleClick}
                deleteHandleClick={deleteHandleClick}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
              />
              {payrollData.length > 0 ? (
                <div></div>
              ) : (
                <div>
                  {loading ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "10vh",
                      }}
                    >
                      <img src={loadingSpinner} alt="Loading..." />
                    </div>
                  ) : (
                    <div> {/*<p>No records to display</p>*/}</div>
                  )}
                </div>
              )}
            </div>
          </TabPanel>
        </div>
      </Tabs>
      <AddProcessForm
        isOpen={showAddForm}
        onClose={closeAddHandleClick}
        payrollPeriodId={payrollPeriodId}
        employeePersonalInformationId={employeePersonalInformationId}
        employeePersonalInformationFullName={
          employeePersonalInformationFullName
        }
        payTypeId={payTypeId}
        totalEcola={totalEcola}
        totalAllowance={totalAllowance}
        totalTax={totalTax}
        totalDays={totalDays}
        totalDaysAbsents={totalDaysAbsents}
        totalAbsents={totalAbsents}
        totalDaysLeaves={totalDaysLeaves}
        totalLeaves={totalLeaves}
        totalDeduction={totalDeduction}
        totalAddition={totalAddition}
        totalAdjustment={totalAdjustment}
        rate={rate}
        totalNighDiff={totalNighDiff}
        totalHoursOTRegular={totalHoursOTRegular}
        totalOTRegular={totalOTRegular}
        totalHoursOTRegularExceeded={totalHoursOTRegularExceeded}
        totalOTRegularExceeded={totalOTRegularExceeded}
        totalHoursOTRestday={totalHoursOTRestday}
        totalOTRestday={totalOTRestday}
        totalHoursOTRestdayExceeded={totalHoursOTRestdayExceeded}
        totalOTRestdayExceeded={totalOTRestdayExceeded}
        totalHoursOTHolidaySpecial={totalHoursOTHolidaySpecial}
        totalOTHolidaySpecial={totalOTHolidaySpecial}
        totalHoursOTHolidaySpecialExceeded={totalHoursOTHolidaySpecialExceeded}
        totalOTHolidaySpecialExceeded={totalOTHolidaySpecialExceeded}
        totalHoursOTHolidayRegular={totalHoursOTHolidayRegular}
        totalOTHolidayRegular={totalOTHolidayRegular}
        totalHoursOTHolidayRegularExceeded={totalHoursOTHolidayRegularExceeded}
        totalOTHolidayRegularExceeded={totalOTHolidayRegularExceeded}
        totalHoursOTRestdayHolidaySpecial={totalHoursOTRestdayHolidaySpecial}
        totalOTRestdayHolidaySpecial={totalOTRestdayHolidaySpecial}
        totalHoursOTRestdayHolidaySpecialExceeded={
          totalHoursOTRestdayHolidaySpecialExceeded
        }
        totalOTRestdayHolidaySpecialExceeded={
          totalOTRestdayHolidaySpecialExceeded
        }
        totalHoursOTRestdayHolidayRegular={totalHoursOTRestdayHolidayRegular}
        totalOTRestdayHolidayRegular={totalOTRestdayHolidayRegular}
        totalHoursOTRestdayHolidayRegularExceeded={
          totalHoursOTRestdayHolidayRegularExceeded
        }
        totalOTRestdayHolidayRegularExceeded={
          totalOTRestdayHolidayRegularExceeded
        }
        totalSSS={totalSSS}
        totalPagibig={totalPagibig}
        totalPhilhealth={totalPhilhealth}
        totalHoursUndertime={totalHoursUndertime}
        totalUndertime={totalUndertime}
        totalHoursLate={totalHoursLate}
        totalLate={totalLate}
        totalBasic={totalBasic}
        totalGrossPay={totalGrossPay}
        totalNetPay={totalNetPay}
        dateProcessed={dateProcessed}
        userId={userId}
        setPayrollPeriodId={setPayrollPeriodId}
        setEmployeePersonalInformationId={setEmployeePersonalInformationId}
        setPayTypeId={setPayTypeId}
        setTotalEcola={setTotalEcola}
        setTotalAllowance={setTotalAllowance}
        setTotalTax={setTotalTax}
        setTotalDays={setTotalDays}
        setTotalDaysAbsents={setTotalDaysAbsents}
        setTotalAbsents={setTotalAbsents}
        setTotalDaysLeaves={setTotalDaysLeaves}
        setTotalLeaves={setTotalLeaves}
        setTotalDeduction={setTotalDeduction}
        setTotalAddition={setTotalAddition}
        setTotalAdjustment={setTotalAdjustment}
        setRate={setRate}
        setTotalNighDiff={setTotalNighDiff}
        setTotalHoursOTRegular={setTotalHoursOTRegular}
        setTotalOTRegular={setTotalOTRegular}
        setTotalHoursOTRegularExceeded={setTotalHoursOTRegularExceeded}
        setTotalOTRegularExceeded={setTotalOTRegularExceeded}
        setTotalHoursOTRestday={setTotalHoursOTRestday}
        setTotalOTRestday={setTotalOTRestday}
        setTotalHoursOTRestdayExceeded={setTotalHoursOTRestdayExceeded}
        setTotalOTRestdayExceeded={setTotalOTRestdayExceeded}
        setTotalHoursOTHolidaySpecial={setTotalHoursOTHolidaySpecial}
        setTotalOTHolidaySpecial={setTotalOTHolidaySpecial}
        setTotalHoursOTHolidaySpecialExceeded={
          setTotalHoursOTHolidaySpecialExceeded
        }
        setTotalOTHolidaySpecialExceeded={setTotalOTHolidaySpecialExceeded}
        setTotalHoursOTHolidayRegular={setTotalHoursOTHolidayRegular}
        setTotalOTHolidayRegular={setTotalOTHolidayRegular}
        setTotalHoursOTHolidayRegularExceeded={
          setTotalHoursOTHolidayRegularExceeded
        }
        setTotalOTHolidayRegularExceeded={setTotalOTHolidayRegularExceeded}
        setTotalHoursOTRestdayHolidaySpecial={
          setTotalHoursOTRestdayHolidaySpecial
        }
        setTotalOTRestdayHolidaySpecial={setTotalOTRestdayHolidaySpecial}
        setTotalHoursOTRestdayHolidaySpecialExceeded={
          setTotalHoursOTRestdayHolidaySpecialExceeded
        }
        setTotalOTRestdayHolidaySpecialExceeded={
          setTotalOTRestdayHolidaySpecialExceeded
        }
        setTotalHoursOTRestdayHolidayRegular={
          setTotalHoursOTRestdayHolidayRegular
        }
        setTotalOTRestdayHolidayRegular={setTotalOTRestdayHolidayRegular}
        setTotalHoursOTRestdayHolidayRegularExceeded={
          setTotalHoursOTRestdayHolidayRegularExceeded
        }
        setTotalOTRestdayHolidayRegularExceeded={
          setTotalOTRestdayHolidayRegularExceeded
        }
        setTotalSSS={setTotalSSS}
        setTotalPagibig={setTotalPagibig}
        setTotalPhilhealth={setTotalPhilhealth}
        setTotalHoursUndertime={setTotalHoursUndertime}
        setTotalUndertime={setTotalUndertime}
        setTotalHoursLate={setTotalHoursLate}
        setTotalLate={setTotalLate}
        setTotalBasic={setTotalBasic}
        setTotalGrossPay={setTotalGrossPay}
        setTotalNetPay={setTotalNetPay}
        setDateProcessed={setDateProcessed}
        setUserId={setUserId}
        setShowEmployeeForm={setShowEmployeeForm}
        handleSubmit={handleSubmit}
      ></AddProcessForm>
      <EditProcessForm
        isOpen={showEditForm}
        onClose={closeEditHandleClick}
        payrollPeriodId={payrollPeriodId}
        employeePersonalInformationId={employeePersonalInformationId}
        employeePersonalInformationFullName={
          employeePersonalInformationFullName
        }
        payTypeId={payTypeId}
        totalEcola={totalEcola}
        totalAllowance={totalAllowance}
        totalTax={totalTax}
        totalDays={totalDays}
        totalDaysAbsents={totalDaysAbsents}
        totalAbsents={totalAbsents}
        totalDaysLeaves={totalDaysLeaves}
        totalLeaves={totalLeaves}
        totalDeduction={totalDeduction}
        totalAddition={totalAddition}
        totalAdjustment={totalAdjustment}
        rate={rate}
        totalNighDiff={totalNighDiff}
        totalHoursOTRegular={totalHoursOTRegular}
        totalOTRegular={totalOTRegular}
        totalHoursOTRegularExceeded={totalHoursOTRegularExceeded}
        totalOTRegularExceeded={totalOTRegularExceeded}
        totalHoursOTRestday={totalHoursOTRestday}
        totalOTRestday={totalOTRestday}
        totalHoursOTRestdayExceeded={totalHoursOTRestdayExceeded}
        totalOTRestdayExceeded={totalOTRestdayExceeded}
        totalHoursOTHolidaySpecial={totalHoursOTHolidaySpecial}
        totalOTHolidaySpecial={totalOTHolidaySpecial}
        totalHoursOTHolidaySpecialExceeded={totalHoursOTHolidaySpecialExceeded}
        totalOTHolidaySpecialExceeded={totalOTHolidaySpecialExceeded}
        totalHoursOTHolidayRegular={totalHoursOTHolidayRegular}
        totalOTHolidayRegular={totalOTHolidayRegular}
        totalHoursOTHolidayRegularExceeded={totalHoursOTHolidayRegularExceeded}
        totalOTHolidayRegularExceeded={totalOTHolidayRegularExceeded}
        totalHoursOTRestdayHolidaySpecial={totalHoursOTRestdayHolidaySpecial}
        totalOTRestdayHolidaySpecial={totalOTRestdayHolidaySpecial}
        totalHoursOTRestdayHolidaySpecialExceeded={
          totalHoursOTRestdayHolidaySpecialExceeded
        }
        totalOTRestdayHolidaySpecialExceeded={
          totalOTRestdayHolidaySpecialExceeded
        }
        totalHoursOTRestdayHolidayRegular={totalHoursOTRestdayHolidayRegular}
        totalOTRestdayHolidayRegular={totalOTRestdayHolidayRegular}
        totalHoursOTRestdayHolidayRegularExceeded={
          totalHoursOTRestdayHolidayRegularExceeded
        }
        totalOTRestdayHolidayRegularExceeded={
          totalOTRestdayHolidayRegularExceeded
        }
        totalSSS={totalSSS}
        totalPagibig={totalPagibig}
        totalPhilhealth={totalPhilhealth}
        totalHoursUndertime={totalHoursUndertime}
        totalUndertime={totalUndertime}
        totalHoursLate={totalHoursLate}
        totalLate={totalLate}
        totalBasic={totalBasic}
        totalGrossPay={totalGrossPay}
        totalNetPay={totalNetPay}
        dateProcessed={dateProcessed}
        userId={userId}
        setPayrollPeriodId={setPayrollPeriodId}
        setEmployeePersonalInformationId={setEmployeePersonalInformationId}
        setPayTypeId={setPayTypeId}
        setTotalEcola={setTotalEcola}
        setTotalAllowance={setTotalAllowance}
        setTotalTax={setTotalTax}
        setTotalDays={setTotalDays}
        setTotalDaysAbsents={setTotalDaysAbsents}
        setTotalAbsents={setTotalAbsents}
        setTotalDaysLeaves={setTotalDaysLeaves}
        setTotalLeaves={setTotalLeaves}
        setTotalDeduction={setTotalDeduction}
        setTotalAddition={setTotalAddition}
        setTotalAdjustment={setTotalAdjustment}
        setRate={setRate}
        setTotalNighDiff={setTotalNighDiff}
        setTotalHoursOTRegular={setTotalHoursOTRegular}
        setTotalOTRegular={setTotalOTRegular}
        setTotalHoursOTRegularExceeded={setTotalHoursOTRegularExceeded}
        setTotalOTRegularExceeded={setTotalOTRegularExceeded}
        setTotalHoursOTRestday={setTotalHoursOTRestday}
        setTotalOTRestday={setTotalOTRestday}
        setTotalHoursOTRestdayExceeded={setTotalHoursOTRestdayExceeded}
        setTotalOTRestdayExceeded={setTotalOTRestdayExceeded}
        setTotalHoursOTHolidaySpecial={setTotalHoursOTHolidaySpecial}
        setTotalOTHolidaySpecial={setTotalOTHolidaySpecial}
        setTotalHoursOTHolidaySpecialExceeded={
          setTotalHoursOTHolidaySpecialExceeded
        }
        setTotalOTHolidaySpecialExceeded={setTotalOTHolidaySpecialExceeded}
        setTotalHoursOTHolidayRegular={setTotalHoursOTHolidayRegular}
        setTotalOTHolidayRegular={setTotalOTHolidayRegular}
        setTotalHoursOTHolidayRegularExceeded={
          setTotalHoursOTHolidayRegularExceeded
        }
        setTotalOTHolidayRegularExceeded={setTotalOTHolidayRegularExceeded}
        setTotalHoursOTRestdayHolidaySpecial={
          setTotalHoursOTRestdayHolidaySpecial
        }
        setTotalOTRestdayHolidaySpecial={setTotalOTRestdayHolidaySpecial}
        setTotalHoursOTRestdayHolidaySpecialExceeded={
          setTotalHoursOTRestdayHolidaySpecialExceeded
        }
        setTotalOTRestdayHolidaySpecialExceeded={
          setTotalOTRestdayHolidaySpecialExceeded
        }
        setTotalHoursOTRestdayHolidayRegular={
          setTotalHoursOTRestdayHolidayRegular
        }
        setTotalOTRestdayHolidayRegular={setTotalOTRestdayHolidayRegular}
        setTotalHoursOTRestdayHolidayRegularExceeded={
          setTotalHoursOTRestdayHolidayRegularExceeded
        }
        setTotalOTRestdayHolidayRegularExceeded={
          setTotalOTRestdayHolidayRegularExceeded
        }
        setTotalSSS={setTotalSSS}
        setTotalPagibig={setTotalPagibig}
        setTotalPhilhealth={setTotalPhilhealth}
        setTotalHoursUndertime={setTotalHoursUndertime}
        setTotalUndertime={setTotalUndertime}
        setTotalHoursLate={setTotalHoursLate}
        setTotalLate={setTotalLate}
        setTotalBasic={setTotalBasic}
        setTotalGrossPay={setTotalGrossPay}
        setTotalNetPay={setTotalNetPay}
        setDateProcessed={setDateProcessed}
        setUserId={setUserId}
        handleUpdate={handleUpdate}
      ></EditProcessForm>
      <DeleteForm
        isOpen={showDeleteForm}
        onClose={closeDeleteHandleClick}
        handleDelete={handleDelete}
      ></DeleteForm>
      <DeleteAllPayrollSummaryForm
        isOpen={showDeleteAllForm}
        onClose={closeDeleteAllHandleClick}
        payrollPeriodId={payrollIdForDelete}
        setPayrollPeriodId={setPayrollIdForDelete}
        handleDelete={handleDeleteAll}
      ></DeleteAllPayrollSummaryForm>
      <EmployeeSelectForm
        isOpen={showEmployeeForm}
        onClose={closeEmployeeForm}
        setEmployeeId={setEmployeePersonalInformationId}
        setEmployee={setEmployeePersonalInformationFullName}
        userAccessData={userAccess}
      ></EmployeeSelectForm>
      <GenerateMessage
        form={successPostMessage}
        message={"Data posted!"}
        isSuccess={true}
      ></GenerateMessage>
      <GenerateMessage
        form={showRequestMessage}
        message={isSuccess ? "Request Success!" : requestMessage}
        isSuccess={isSuccess}
      ></GenerateMessage>
      {loadingRequest ? (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: "3005",
          }}
        >
          <img src={loadingSpinner} alt="Loading..." />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
function SettingInit({
  generateDownloadTemplate,
  generateDownloadAdjustmentTemplate,
  openUploadFormHandleClick,
  openRevertPayrollForm,
  openProcessPayrollForm,
  openPostPayrollForm,
  setSettingType,
}) {
  const handleUploadClick = (settingType) => {
    openUploadFormHandleClick();
    setSettingType(settingType);
  };
  return (
    <div id="payroll-setting" className="payroll-setting column">
      <div
        className="payroll-setting-item row"
        onClick={() => generateDownloadTemplate()}
      >
        <div style={{ margin: "10px 5px 0 5px", color: "#1a75ff" }}>
          <DownloadIcon />
        </div>
        Download Other Additions Template
      </div>
      <div
        className="payroll-setting-item row"
        onClick={() => generateDownloadTemplate()}
      >
        <div style={{ margin: "10px 5px 0 5px", color: "#1a75ff" }}>
          <DownloadIcon />
        </div>
        Download Other Deductions Template
      </div>
      <div
        className="payroll-setting-item row"
        onClick={() => generateDownloadAdjustmentTemplate()}
      >
        <div style={{ margin: "10px 5px 0 5px", color: "#1a75ff" }}>
          <DownloadIcon />
        </div>
        Download Other Adjustments Template
      </div>
      <div
        className="payroll-setting-item row"
        onClick={() => handleUploadClick("Other Additions")}
      >
        <div style={{ margin: "10px 5px 0 5px", color: "#47d147" }}>
          <FileUploadIcon />
        </div>
        Upload Other Additions
      </div>
      <div
        className="payroll-setting-item row"
        onClick={() => handleUploadClick("Other Deductions")}
      >
        <div style={{ margin: "10px 5px 0 5px", color: "#47d147" }}>
          <FileUploadIcon />
        </div>
        Upload Other Deductions
      </div>
      <div
        className="payroll-setting-item row"
        onClick={() => handleUploadClick("Other Adjustments")}
      >
        <div style={{ margin: "10px 5px 0 5px", color: "#47d147" }}>
          <FileUploadIcon />
        </div>
        Upload Other Adjustments
      </div>
      <div
        className="payroll-setting-item row"
        onClick={() => openRevertPayrollForm()}
      >
        <div style={{ margin: "10px 5px 0 5px", color: "#ff4d4d" }}>
          <SettingsBackupRestoreIcon />
        </div>
        Revert Payroll
      </div>
      <div
        className="payroll-setting-item row"
        onClick={() => openProcessPayrollForm()}
      >
        <div style={{ margin: "10px 5px 0 5px", color: "#ffaa00" }}>
          <AccountTreeIcon />
        </div>
        Process Payroll
      </div>
      <div
        className="payroll-setting-item row"
        onClick={() => openPostPayrollForm()}
      >
        <div style={{ margin: "10px 5px 0 5px", color: "#1a75ff" }}>
          <PostAddIcon />
        </div>
        Post Payroll
      </div>
    </div>
  );
}
function ShowAdjustmentButtons({
  payrollData,
  setPayrollData,
  otherAdditionData,
  otherDeductionData,
  otherAdjustmentData,
  otherLateAdjustmentData,
  setOtherAdditionData,
  setOtherDeductionData,
  setOtherAdjustmentData,
  setOtherLateAdjustmentData,
  filterPayrollPeriodId,
  filterPayTypeId,
  filterClassificationId,
  userAccess,
  type,
  showPostMessage,
  isGenerate,
  setIsGenerate,
  isRevert,
  isProcess,
  isPost,
  isUpload,
  setIsUpload,

  loadingOtherAddition,
  loadingOtherDedujction,
  loadingAdjustment,
  loadingLateAdjustment,
  filterDataAddition,
  filterDataDeduction,
  filterDataAdjustment,
  filterDataLateAdjustment,
  fetchAdditionData,
  fetchDeductionData,
  fetchAdjustmentData,
  fetchLateAdjustmentData,
  fetchDataProcessedPayroll,
  handleGenerateLateApprovedAdjustments,
  openLateAdjustmentForm,
  user,
}) {
  var adjustmentsHeader = ["Id", "Name", "Description", "Amount", ""];
  var adjustmentsAccesor = [
    "id",
    "employeePersonalInformationFullName",
    "description",
    "amount",
    "manage",
  ];

  const [currentPage_addition, setCurrentPage_addition] = useState(1);
  const [currentPage_deduction, setCurrentPage_deduction] = useState(1);
  const [currentPage_adjustment, setCurrentPage_adjustment] = useState(1);
  const [currentPage_lateAdjustment, setCurrentPage_lateAdjustment] = useState(1);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [adjustmentType, setAdjustmentType] = useState("OtherAdditionStaging");
  const [activeButton, setActiveButton] = useState("btn-tab-addition");
  //Add
  const [showAddForm, setShowAddForm] = useState(false);
  const [employeePersonalInformationId, setEmployeePersonalInformationId] =
    useState("");
  const [
    employeePersonalInformationFullName,
    setEmployeePersonalInformationFullName,
  ] = useState("");
  const [payrollPeriodId, setPayrollPeriodId] = useState("");
  const [payTypeId, setPayTypeId] = useState("");
  const [description, setDescription] = useState("");
  const [amount, setAmount] = useState("");
  const [noOfHours, setNoOfHours] = useState("");
  const [adjustmentDate, setAdjustmentDate] = useState("");
  const [reference, setReference] = useState(null);
  const [referenceId, setReferenceId] = useState("");
  //Old
  const [
    oldEmployeePersonalInformationId,
    setOldEmployeePersonalInformationId,
  ] = useState("");
  const [oldPayrollPeriodId, setOldPayrollPeriodId] = useState("");
  const [oldPayTypeId, setOldPayTypeId] = useState("");
  const [oldDescription, setOldDescription] = useState("");
  const [oldAmount, setOldAmount] = useState("");
  const [oldAdjustmentDate, setOldAdjustmentDate] = useState("");
  const [oldReferenceId, setOldReferenceId] = useState("");
  //Update
  const [showEditForm, setShowEditForm] = useState(false);
  const [editById, setEditById] = useState("");
  const [dataToEdit, setDataToEdit] = useState([]);
  // Delete
  const [showDeleteForm, setShowDeleteForm] = useState(false);
  const [deleteById, setDeleteById] = useState([]);
  const [deleteData, setDeleteData] = useState([]);
  // Delete All
  const [showDeleteAllForm, setShowDeleteAllForm] = useState(false);
  const [payrollIdForDelete, setPayrollIdForDelete] = useState("");
  const [payTypeIdForDelete, setPayTypeIdForDelete] = useState("");

  const [showEmployeeForm, setShowEmployeeForm] = useState(false);
  const [referenceIdForm, setReferenceIdForm] = useState(false);
  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
    if (showRequestMessage) {
      const timeoutId = setTimeout(() => {
        setShowRequestMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }
  }, [showRequestMessage]);

  const apiUrl = domain + "/api/";

  const handleFilter = (value) => {
    setCurrentPage_addition(1);
    setCurrentPage_deduction(1);
    setCurrentPage_adjustment(1);
    setCurrentPage_lateAdjustment(1);
    const lowercaseValue = value.toLowerCase();
    var res = [];
    if (adjustmentType === "OtherAdditionStaging") {
      res = filterDataAddition.filter((f) =>
        f.employeePersonalInformationFullName
          .toLowerCase()
          .includes(lowercaseValue)
      );

      setOtherAdditionData(res);
    } else if (adjustmentType === "OtherDeductionStaging") {
      res = filterDataDeduction.filter((f) =>
        f.employeePersonalInformationFullName
          .toLowerCase()
          .includes(lowercaseValue)
      );

      setOtherDeductionData(res);
    } else if (adjustmentType === "OtherAdjustmentStaging") {
      res = filterDataAdjustment.filter((f) =>
        f.employeePersonalInformationFullName
          .toLowerCase()
          .includes(lowercaseValue)
      );

      setOtherAdjustmentData(res);
    } else if (adjustmentType === "OtherLateAdjustmentStaging") {
      res = filterDataLateAdjustment.filter((f) =>
        f.employeePersonalInformationFullName
          .toLowerCase()
          .includes(lowercaseValue)
      );

      setOtherLateAdjustmentData(res);
    }
  };
  const handleClick = (id) => {
    setCurrentPage_addition(1);
    setCurrentPage_deduction(1);
    setCurrentPage_adjustment(1);
    setCurrentPage_lateAdjustment(1);
    if (id === "btn-tab-addition") {
      setAdjustmentType("OtherAdditionStaging");
    } else if (id === "btn-tab-deductions") {
      setAdjustmentType("OtherDeductionStaging");
    } else if (id === "btn-tab-adjustments") {
      setAdjustmentType("OtherAdjustmentStaging");
    } else if (id === "btn-tab-late-adjustments") {
      setAdjustmentType("OtherLateAdjustmentStaging");
    }
    setActiveButton(id);
    handleOtherFunction(id);
  };
  const handleOtherFunction = (id) => {
    const additionTable = document.getElementById("addition-table");
    const deductionTable = document.getElementById("deduction-table");
    const adjustmentTable = document.getElementById("adjustment-table");
    const lateAdjustmentTable = document.getElementById(
      "late-adjustment-table"
    );

    switch (id) {
      case "btn-tab-addition":
        additionTable.style.display = "block";
        deductionTable.style.display = "none";
        adjustmentTable.style.display = "none";
        lateAdjustmentTable.style.display = "none";
        break;
      case "btn-tab-deductions":
        additionTable.style.display = "none";
        deductionTable.style.display = "block";
        adjustmentTable.style.display = "none";
        lateAdjustmentTable.style.display = "none";
        break;
      case "btn-tab-adjustments":
        additionTable.style.display = "none";
        deductionTable.style.display = "none";
        adjustmentTable.style.display = "block";
        lateAdjustmentTable.style.display = "none";
        break;
      case "btn-tab-late-adjustments":
        additionTable.style.display = "none";
        deductionTable.style.display = "none";
        adjustmentTable.style.display = "none";
        lateAdjustmentTable.style.display = "block";
        break;
      default:
        break;
    }
  };
  const handleGenerate = useCallback(async () => {
    await fetchAdditionData();
    await fetchDeductionData();
    await fetchAdjustmentData();
    await fetchLateAdjustmentData();
    await fetchDataProcessedPayroll();
  }, [
    fetchAdditionData,
    fetchDeductionData,
    fetchAdjustmentData,
    fetchLateAdjustmentData,
    fetchDataProcessedPayroll,
  ]);

  useEffect(() => {
    fetchAdditionData();
    fetchDeductionData();
    fetchAdjustmentData();
    fetchLateAdjustmentData();
    fetchDataProcessedPayroll();
  }, [
    type,
    handleGenerate,
    showPostMessage,
    fetchAdditionData,
    fetchDeductionData,
    fetchAdjustmentData,
    fetchLateAdjustmentData,
    fetchDataProcessedPayroll,
    isGenerate,
    isRevert,
    isProcess,
    isPost,
    isUpload,
  ]);
  useEffect(() => {
    if (showEditForm) {
      setEmployeePersonalInformationId(
        dataToEdit.employeePersonalInformationId
      );
      setEmployeePersonalInformationFullName(
        dataToEdit.employeePersonalInformationFullName
      );
      setPayrollPeriodId(dataToEdit.payrollPeriodId);
      setPayTypeId(dataToEdit.payTypeId);
      setDescription(dataToEdit.description);
      setAmount(dataToEdit.amount);
      setAdjustmentDate(dataToEdit.adjustmentDate);
      setReferenceId(dataToEdit.referenceId);

      setOldEmployeePersonalInformationId(
        dataToEdit.employeePersonalInformationId
      );
      setOldPayrollPeriodId(dataToEdit.payrollPeriodId);
      setOldPayTypeId(dataToEdit.payTypeId);
      setOldDescription(dataToEdit.description);
      setOldAmount(dataToEdit.amount);
      setOldAdjustmentDate(dataToEdit.adjustmentDate);
      setOldReferenceId(dataToEdit.referenceId);
    }
  }, [showEditForm, dataToEdit]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    const data = {
      employeePersonalInformationId: employeePersonalInformationId,
      payrollPeriodId: payrollPeriodId,
      payTypeId: payTypeId,
      description: description,
      amount: amount,
      ...((adjustmentType === "OtherAdjustmentStaging" ||
        adjustmentType === "OtherLateAdjustmentStaging") && {
        noOfHours: noOfHours,
      }),
      ...((adjustmentType === "OtherAdjustmentStaging" ||
        adjustmentType === "OtherLateAdjustmentStaging") && {
        adjustmentDate: adjustmentDate,
      }),
      ...((adjustmentType === "OtherAdjustmentStaging" ||
        adjustmentType === "OtherLateAdjustmentStaging") && {
        referenceId: referenceId ? referenceId : 0,
      }),
      ...((adjustmentType === "OtherAdjustmentStaging" ||
        adjustmentType === "OtherLateAdjustmentStaging") && {
        transactionType: reference?.requestTypeId === 1 ? "Leave" : "Overtime",
      }),
      ...(adjustmentType === "OtherLateAdjustmentStaging" && {
        isLateAdjustment: true,
      }),
    };

    console.log("Final bulkData:", JSON.stringify(data, null, 2));

    // ...(adjustmentType !== "OtherAdjustmentStaging" ? { amount: amount } : {})

    var adjustmentTypeURL = adjustmentType;

    if (
      adjustmentType === "OtherAdjustmentStaging" ||
      adjustmentType === "OtherLateAdjustmentStaging"
    ) {
      adjustmentTypeURL = "OtherAdjustmentStaging";
    }

    try {
      setLoadingRequest(true);
      const response = await axios.post(apiUrl + `${adjustmentTypeURL}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      let field = "";

      if (adjustmentType === "OtherAdditionStaging") {
        field = "Other Addition Add";
      } else if (adjustmentType === "OtherDeductionStaging") {
        field = "Other Deduction Add";
      } else if (adjustmentType === "OtherAdjustmentStaging") {
        field = "Other Adjustment Add";
      } else if (adjustmentType === "OtherLateAdjustmentStaging") {
        field = "Other Late Adjustment Add";
      }

      await SetAuditTrail({
        setupArea: "Payroll",
        actionTaken: "insert",
        field: field,
        newValue: `${response.data.description}`,
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id,
      });

      await fetchAdditionData();
      await fetchDeductionData();
      await fetchAdjustmentData();
      await fetchLateAdjustmentData();
      await fetchDataProcessedPayroll();

      console.log("Data added successfully");
      setShowRequestMessage(true);
      setIsSuccess(true);

      // Reload table data and reset form fields
      setEmployeePersonalInformationId("");
      setPayrollPeriodId("");
      setPayTypeId("");
      setDescription("");
      setAmount("");
      setAdjustmentDate("");
      setReferenceId("");
      setReference(null);
      setNoOfHours("");
      setShowAddForm(false); // Hide the add form
      // fetchData(adjustmentType);
    } catch (error) {
      console.error("There was a problem adding data:", error);
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error("Error:", error);
      const errorMessage = JSON.parse(
        error.response.request.responseText
      ).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }

    setShowAddForm(false);
  };
  const handleUpdate = async (event) => {
    event.preventDefault();

    const data = {
      employeePersonalInformationId: employeePersonalInformationId,
      payrollPeriodId: payrollPeriodId,
      payTypeId: payTypeId,
      description: description,
      amount: amount,
      ...((adjustmentType === "OtherAdjustmentStaging" ||
        adjustmentType === "OtherLateAdjustmentStaging") && {
        noOfHours: noOfHours,
      }),
      ...((adjustmentType === "OtherAdjustmentStaging" ||
        adjustmentType === "OtherLateAdjustmentStaging") && {
        adjustmentDate: adjustmentDate,
      }),
      ...((adjustmentType === "OtherAdjustmentStaging" ||
        adjustmentType === "OtherLateAdjustmentStaging") && {
        referenceId: referenceId,
      }),
      ...((adjustmentType === "OtherAdjustmentStaging" ||
        adjustmentType === "OtherLateAdjustmentStaging") && {
        transactionType: reference?.requestTypeId === 1 ? "Leave" : "Overtime",
      }),
      ...(adjustmentType === "OtherLateAdjustmentStaging" && {
        isLateAdjustment: true,
      }),
    };

    var adjustmentTypeURL = adjustmentType;

    if (
      adjustmentType === "OtherAdjustmentStaging" ||
      adjustmentType === "OtherLateAdjustmentStaging"
    ) {
      adjustmentTypeURL = "OtherAdjustmentStaging";
    }

    try {
      setLoadingRequest(true);
      await axios.put(apiUrl + `${adjustmentTypeURL}/${editById}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      let field = "";

      if (adjustmentType === "OtherAdditionStaging") {
        field = "Other Addition Update";
      } else if (adjustmentType === "OtherDeductionStaging") {
        field = "Other Deduction Update";
      } else if (adjustmentType === "OtherAdjustmentStaging") {
        field = "Other Adjustment Update";
      } else if (adjustmentType === "OtherLateAdjustmentStaging") {
        field = "Other Late Adjustment Update";
      }

      let auditInfo = [];

      if (
        data.employeePersonalInformationId !== oldEmployeePersonalInformationId
      ) {
        auditInfo.push({
          setupArea: "Payroll",
          actionTaken: "update",
          field: field,
          newValue: `${data.employeePersonalInformationId}`,
          oldValue: `${oldEmployeePersonalInformationId}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }
      if (data.payrollPeriodId !== oldPayrollPeriodId) {
        auditInfo.push({
          setupArea: "Payroll",
          actionTaken: "update",
          field: field,
          newValue: `${data.payrollPeriodId}`,
          oldValue: `${oldPayrollPeriodId}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }
      if (data.payTypeId !== oldPayTypeId) {
        auditInfo.push({
          setupArea: "Payroll",
          actionTaken: "update",
          field: field,
          newValue: `${data.payTypeId}`,
          oldValue: `${oldPayTypeId}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }
      if (data.description !== oldDescription) {
        auditInfo.push({
          setupArea: "Payroll",
          actionTaken: "update",
          field: field,
          newValue: `${data.description}`,
          oldValue: `${oldDescription}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }
      if (data.amount !== oldAmount) {
        auditInfo.push({
          setupArea: "Payroll",
          actionTaken: "update",
          field: field,
          newValue: `${data.amount}`,
          oldValue: `${oldAmount}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }
      if (data.adjustmentDate !== oldAdjustmentDate) {
        auditInfo.push({
          setupArea: "Payroll",
          actionTaken: "update",
          field: field,
          newValue: `${data.adjustmentDate}`,
          oldValue: `${oldAdjustmentDate}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }
      if (data.referenceId !== oldReferenceId) {
        auditInfo.push({
          setupArea: "Payroll",
          actionTaken: "update",
          field: field,
          newValue: `${data.referenceId}`,
          oldValue: `${oldReferenceId}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }

      await SetAuditTrailBulk({ data: auditInfo });
      await fetchAdditionData();
      await fetchDeductionData();
      await fetchAdjustmentData();
      await fetchLateAdjustmentData();
      await fetchDataProcessedPayroll();

      console.log("Data added successfully");
      setShowRequestMessage(true);
      setIsSuccess(true);

      // Reload table data and reset form fields
      setEmployeePersonalInformationId("");
      setPayrollPeriodId("");
      setPayTypeId("");
      setDescription("");
      setAmount("");
      setAdjustmentDate("");
      setReferenceId("");
      setReference(null);
      setNoOfHours("");
      setShowEditForm(false); // Hide the add form
      // fetchData(adjustmentType);
    } catch (error) {
      console.error("There was a problem adding data:", error);
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error("Error:", error);
      const errorMessage = JSON.parse(
        error.response.request.responseText
      ).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }

    setShowEditForm(false);
  };
  const handleDelete = async () => {
    var adjustmentTypeURL = adjustmentType;

    if (
      adjustmentType === "OtherAdjustmentStaging" ||
      adjustmentType === "OtherLateAdjustmentStaging"
    ) {
      adjustmentTypeURL = "OtherAdjustmentStaging";
    }

    try {
      setLoadingRequest(true);
      await axios.delete(apiUrl + `${adjustmentTypeURL}/${deleteById}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      let field = "";

      if (adjustmentType === "OtherAdditionStaging") {
        field = "Other Addition";
      } else if (adjustmentType === "OtherDeductionStaging") {
        field = "Other Deduction";
      } else if (adjustmentType === "OtherAdjustmentStaging") {
        field = "Other Adjustment";
      } else if (adjustmentType === "OtherLateAdjustmentStaging") {
        field = "Other Late Adjustment";
      }

      await SetAuditTrail({
        setupArea: "Payroll",
        actionTaken: "delete",
        field: field,
        newValue: `-`,
        oldValue: `${deleteData.employeePersonalInformationFullName}`,
        dateSaved: new Date(),
        savedById: user.id,
      });
      await fetchAdditionData();
      await fetchDeductionData();
      await fetchAdjustmentData();
      await fetchLateAdjustmentData();
      await fetchDataProcessedPayroll();

      console.log("Deleted successfully");
      setShowRequestMessage(true);
      setIsSuccess(true);

      // Reload table data and reset state
      setShowDeleteForm(false);
      setDeleteById("");
      // fetchData(adjustmentType);
    } catch (error) {
      console.error("There was a problem deleting employee:", error);
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error("Error:", error);
      const errorMessage = JSON.parse(
        error.response.request.responseText
      ).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }

    setShowDeleteForm(false);
  };
  const handleDeleteAll = async () => {
    if (!payrollIdForDelete) {
      alert("Please select payroll period id");
      return; // Exit early if fields are empty
    }

    var adjustmentTypeURL = adjustmentType;

    if (
      adjustmentType === "OtherAdjustmentStaging" ||
      adjustmentType === "OtherLateAdjustmentStaging"
    ) {
      adjustmentTypeURL = "OtherAdjustmentStaging";
    }

    try {
      setLoadingRequest(true);
      await axios.delete(
        apiUrl +
          `${adjustmentTypeURL}/paytype/${payTypeIdForDelete}/payrollperiod/${payrollIdForDelete}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      let field = "";

      if (adjustmentType === "OtherAdditionStaging") {
        field = "Other Addition";
      } else if (adjustmentType === "OtherDeductionStaging") {
        field = "Other Deduction";
      } else if (adjustmentType === "OtherAdjustmentStaging") {
        field = "Other Adjustment";
      } else if (adjustmentType === "OtherLateAdjustmentStaging") {
        field = "Other Late Adjustment";
      }

      await SetAuditTrail({
        setupArea: "Payroll",
        actionTaken: "delete all",
        field: field,
        newValue: `-`,
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id,
      });
      await fetchAdditionData();
      await fetchDeductionData();
      await fetchAdjustmentData();
      await fetchLateAdjustmentData();
      await fetchDataProcessedPayroll();

      console.log("Deleted successfully");
      setShowRequestMessage(true);
      setIsSuccess(true);

      // Reload table data and reset state
      setShowDeleteAllForm(false);
      setPayrollIdForDelete("");
      // fetchData(adjustmentType);
    } catch (error) {
      console.error("There was a problem deleting employee:", error);
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error("Error:", error);
      const errorMessage = JSON.parse(
        error.response.request.responseText
      ).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }

    setShowDeleteAllForm(false);
  };

  const addHandleClick = () => {
    setShowAddForm(true);
  };
  const editHandleClick = (data) => {
    setEditById(data.id);
    setDataToEdit(data);
    setShowEditForm(true);
  };
  const deleteHandleClick = (data) => {
    setShowDeleteForm(true);
    setDeleteById(data.id);
    setDeleteData(data);
  };
  const deleteAllHandleClick = (data) => {
    setShowDeleteAllForm(true);
  };
  const closeAddHandleClick = () => {
    setShowAddForm(false);
  };
  const closeEditHandleClick = () => {
    setShowEditForm(false);
  };
  const closeDeleteHandleClick = () => {
    setShowDeleteForm(false);
  };
  const closeDeleteAllHandleClick = () => {
    setShowDeleteAllForm(false);
  };
  const closeEmployeeForm = () => {
    setShowEmployeeForm(false);
  };
  const closeReferenceIdForm = () => {
    setReferenceIdForm(false);
  };

  return (
    <div>
      <div className="mainte-body-top row">
        {CreateSearchBarWithPlaceHolder(
          "",
          "mainte-search row",
          "mainte-search-icon",
          "mainte-search-input",
          (e) => handleFilter(e.target.value),
          "Search by name",
          SearchIcon
        )}
      </div>
      <div className="payroll-tab-header row">
        <div className="payroll-tab-leftSide row">
          <div className="leftSide-btn">
            <button
              id={activeButton === "btn-tab-addition" ? "btn-tab-active" : ""}
              onClick={() => {
                handleClick("btn-tab-addition");
                handleOtherFunction("btn-tab-addition");
              }}
            >
              OTHER ADDITIONS
            </button>
          </div>
          <div className="leftSide-btn">
            <button
              id={activeButton === "btn-tab-deductions" ? "btn-tab-active" : ""}
              onClick={() => {
                handleClick("btn-tab-deductions");
                handleOtherFunction("btn-tab-deductions");
              }}
            >
              OTHER DEDUCTIONS
            </button>
          </div>
          <div className="leftSide-btn">
            <button
              id={
                activeButton === "btn-tab-adjustments" ? "btn-tab-active" : ""
              }
              onClick={() => {
                handleClick("btn-tab-adjustments");
                handleOtherFunction("btn-tab-adjustments");
              }}
            >
              ADJUSTMENTS
            </button>
          </div>
          {isGenerate && filterPayrollPeriodId && (
            <div className="leftSide-btn">
              <button
                id={
                  activeButton === "btn-tab-late-adjustments"
                    ? "btn-tab-active"
                    : ""
                }
                onClick={() => {
                  handleClick("btn-tab-late-adjustments");
                  handleOtherFunction("btn-tab-late-adjustments");
                }}
              >
                LATE ADJUSTMENTS
              </button>
            </div>
          )}
        </div>
        <div className="payroll-tab-rightSide row">
          <div className="rightSide-btn">
            {CreateButton("", "add row", addHandleClick, "NEW", NoteAddIcon)}
          </div>
          <div className="rightSide-btn">
            {CreateButton(
              "",
              "delete row",
              deleteAllHandleClick,
              "DELETE ALL",
              DeleteSweepIcon
            )}
          </div>
        </div>
      </div>
      <div className="payroll-tables">
        <div
          id="addition-table"
          className="payroll-table container"
          style={{ display: "block" }}
        >
          <CreateTable
            dataList={otherAdditionData}
            dataHeader={adjustmentsHeader}
            dataAccessor={adjustmentsAccesor}
            editHandleClick={editHandleClick}
            deleteHandleClick={deleteHandleClick}
            currentPage={currentPage_addition}
            setCurrentPage={setCurrentPage_addition}
          />
          {otherAdditionData.length > 0 ? (
            <div></div>
          ) : (
            <div>
              {loadingOtherAddition ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "10vh",
                  }}
                >
                  <img src={loadingSpinner} alt="Loading..." />
                </div>
              ) : (
                <div> {/*<p>No records to display</p>*/}</div>
              )}
            </div>
          )}
        </div>
        <div id="deduction-table" className="payroll-table container">
          <CreateTable
            dataList={otherDeductionData}
            dataHeader={adjustmentsHeader}
            dataAccessor={adjustmentsAccesor}
            editHandleClick={editHandleClick}
            deleteHandleClick={deleteHandleClick}
            currentPage={currentPage_deduction}
            setCurrentPage={setCurrentPage_deduction}
          />
          {otherDeductionData.length > 0 ? (
            <div></div>
          ) : (
            <div>
              {loadingOtherDedujction ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "10vh",
                  }}
                >
                  <img src={loadingSpinner} alt="Loading..." />
                </div>
              ) : (
                <div> {/*<p>No records to display</p>*/}</div>
              )}
            </div>
          )}
        </div>
        <div id="adjustment-table" className="payroll-table container">
          <div
            className="rightSide-btn"
            style={{ margin: "10px 5px", display: "none" }}
          >
            {CreateButton(
              "",
              "add row",
              handleGenerateLateApprovedAdjustments,
              "SYNC ADJUSTMENTS",
              SyncIcon
            )}
          </div>
          <CreateTable
            dataList={otherAdjustmentData}
            dataHeader={adjustmentsHeader}
            dataAccessor={adjustmentsAccesor}
            editHandleClick={editHandleClick}
            deleteHandleClick={deleteHandleClick}
            currentPage={currentPage_adjustment}
            setCurrentPage={setCurrentPage_adjustment}
          />
          {otherAdjustmentData.length > 0 ? (
            <div></div>
          ) : (
            <div>
              {loadingAdjustment ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "10vh",
                  }}
                >
                  <img src={loadingSpinner} alt="Loading..." />
                </div>
              ) : (
                <div> {/*<p>No records to display</p>*/}</div>
              )}
            </div>
          )}
        </div>
        <div id="late-adjustment-table" className="payroll-table container">
          <div className="rightSide-btn" style={{ margin: "10px 5px" }}>
            {CreateButton(
              "",
              "sync-adjustments add row",
              openLateAdjustmentForm,
              "SYNC ADJUSTMENTS",
              SyncIcon
            )}
          </div>
          <CreateTable
            dataList={otherLateAdjustmentData}
            dataHeader={adjustmentsHeader}
            dataAccessor={adjustmentsAccesor}
            editHandleClick={editHandleClick}
            deleteHandleClick={deleteHandleClick}
            currentPage={currentPage_lateAdjustment}
            setCurrentPage={setCurrentPage_lateAdjustment}
          />
          {otherLateAdjustmentData.length > 0 ? (
            <div></div>
          ) : (
            <div>
              {loadingLateAdjustment ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "10vh",
                  }}
                >
                  <img src={loadingSpinner} alt="Loading..." />
                </div>
              ) : (
                <div> {/*<p>No records to display</p>*/}</div>
              )}
            </div>
          )}
        </div>
      </div>
      <AddForm
        isOpen={showAddForm}
        onClose={closeAddHandleClick}
        employeePersonalInformationId={employeePersonalInformationId}
        employeePersonalInformationFullName={
          employeePersonalInformationFullName
        }
        payrollPeriodId={payrollPeriodId}
        payTypeId={payTypeId}
        description={description}
        amount={amount}
        noOfHours={noOfHours}
        adjustmentDate={adjustmentDate}
        reference={reference}
        referenceId={referenceId}
        setEployeePersonalInformationId={setEmployeePersonalInformationId}
        setPayrollPeriodId={setPayrollPeriodId}
        setPayTypeId={setPayTypeId}
        setDescription={setDescription}
        setAmount={setAmount}
        setNoOfHours={setNoOfHours}
        setAdjustmentDate={setAdjustmentDate}
        setReferenceId={setReferenceId}
        setShowEmployeeForm={setShowEmployeeForm}
        setReferenceIdForm={setReferenceIdForm}
        adjustmentType={adjustmentType}
        handleSubmit={handleSubmit}
      ></AddForm>
      <EditForm
        isOpen={showEditForm}
        onClose={closeEditHandleClick}
        employeePersonalInformationId={employeePersonalInformationId}
        employeePersonalInformationFullName={
          employeePersonalInformationFullName
        }
        payrollPeriodId={payrollPeriodId}
        payTypeId={payTypeId}
        description={description}
        amount={amount}
        noOfHours={noOfHours}
        adjustmentDate={adjustmentDate}
        reference={reference}
        referenceId={referenceId}
        setEployeePersonalInformationId={setEmployeePersonalInformationId}
        setPayrollPeriodId={setPayrollPeriodId}
        setPayTypeId={setPayTypeId}
        setDescription={setDescription}
        setAmount={setAmount}
        setNoOfHours={setNoOfHours}
        setAdjustmentDate={setAdjustmentDate}
        setReferenceId={setReferenceId}
        setShowEmployeeForm={setShowEmployeeForm}
        setReferenceIdForm={setReferenceIdForm}
        adjustmentType={adjustmentType}
        handleUpdate={handleUpdate}
      ></EditForm>
      <DeleteForm
        isOpen={showDeleteForm}
        onClose={closeDeleteHandleClick}
        handleDelete={handleDelete}
      ></DeleteForm>
      <DeleteAllForm
        isOpen={showDeleteAllForm}
        onClose={closeDeleteAllHandleClick}
        payrollPeriodId={payrollIdForDelete}
        payTypeId={payTypeIdForDelete}
        setPayrollPeriodId={setPayrollIdForDelete}
        setPayTypeId={setPayTypeIdForDelete}
        handleDelete={handleDeleteAll}
      ></DeleteAllForm>
      <EmployeeSelectForm
        isOpen={showEmployeeForm}
        onClose={closeEmployeeForm}
        setEmployeeId={setEmployeePersonalInformationId}
        setEmployee={setEmployeePersonalInformationFullName}
        userAccessData={userAccess}
        user={user}
      ></EmployeeSelectForm>
      <ReferenceSelectForm
        isOpen={referenceIdForm}
        onClose={closeReferenceIdForm}
        setReference={setReference}
        setReferenceId={setReferenceId}
        setAdjustmentDate={setAdjustmentDate}
      ></ReferenceSelectForm>
      <GenerateMessage
        form={showRequestMessage}
        message={isSuccess ? "Request Success!" : requestMessage}
        isSuccess={isSuccess}
      ></GenerateMessage>
      {loadingRequest ? (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: "3005",
          }}
        >
          <img src={loadingSpinner} alt="Loading..." />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
function AddProcessForm({
  isOpen,
  onClose,
  payrollPeriodId,
  employeePersonalInformationId,
  employeePersonalInformationFullName,
  payTypeId,
  totalEcola,
  totalAllowance,
  totalTax,
  totalDays,
  totalDaysAbsents,
  totalAbsents,
  totalDaysLeaves,
  totalLeaves,
  totalDeduction,
  totalAddition,
  totalAdjustment,
  rate,
  totalNighDiff,
  totalHoursOTRegular,
  totalOTRegular,
  totalHoursOTRegularExceeded,
  totalOTRegularExceeded,
  totalHoursOTRestday,
  totalOTRestday,
  totalHoursOTRestdayExceeded,
  totalOTRestdayExceeded,
  totalHoursOTHolidaySpecial,
  totalOTHolidaySpecial,
  totalHoursOTHolidaySpecialExceeded,
  totalOTHolidaySpecialExceeded,
  totalHoursOTHolidayRegular,
  totalOTHolidayRegular,
  totalHoursOTHolidayRegularExceeded,
  totalOTHolidayRegularExceeded,
  totalHoursOTRestdayHolidaySpecial,
  totalOTRestdayHolidaySpecial,
  totalHoursOTRestdayHolidaySpecialExceeded,
  totalOTRestdayHolidaySpecialExceeded,
  totalHoursOTRestdayHolidayRegular,
  totalOTRestdayHolidayRegular,
  totalHoursOTRestdayHolidayRegularExceeded,
  totalOTRestdayHolidayRegularExceeded,
  totalSSS,
  totalPagibig,
  totalPhilhealth,
  totalHoursUndertime,
  totalUndertime,
  totalHoursLate,
  totalLate,
  totalBasic,
  totalGrossPay,
  totalNetPay,
  dateProcessed,
  userId,
  setPayrollPeriodId,
  setEmployeePersonalInformationId,
  setPayTypeId,
  setTotalEcola,
  setTotalAllowance,
  setTotalTax,
  setTotalDays,
  setTotalDaysAbsents,
  setTotalAbsents,
  setTotalDaysLeaves,
  setTotalLeaves,
  setTotalDeduction,
  setTotalAddition,
  setTotalAdjustment,
  setRate,
  setTotalNighDiff,
  setTotalHoursOTRegular,
  setTotalOTRegular,
  setTotalHoursOTRegularExceeded,
  setTotalOTRegularExceeded,
  setTotalHoursOTRestday,
  setTotalOTRestday,
  setTotalHoursOTRestdayExceeded,
  setTotalOTRestdayExceeded,
  setTotalHoursOTHolidaySpecial,
  setTotalOTHolidaySpecial,
  setTotalHoursOTHolidaySpecialExceeded,
  setTotalOTHolidaySpecialExceeded,
  setTotalHoursOTHolidayRegular,
  setTotalOTHolidayRegular,
  setTotalHoursOTHolidayRegularExceeded,
  setTotalOTHolidayRegularExceeded,
  setTotalHoursOTRestdayHolidaySpecial,
  setTotalOTRestdayHolidaySpecial,
  setTotalHoursOTRestdayHolidaySpecialExceeded,
  setTotalOTRestdayHolidaySpecialExceeded,
  setTotalHoursOTRestdayHolidayRegular,
  setTotalOTRestdayHolidayRegular,
  setTotalHoursOTRestdayHolidayRegularExceeded,
  setTotalOTRestdayHolidayRegularExceeded,
  setTotalSSS,
  setTotalPagibig,
  setTotalPhilhealth,
  setTotalHoursUndertime,
  setTotalUndertime,
  setTotalHoursLate,
  setTotalLate,
  setTotalBasic,
  setTotalGrossPay,
  setTotalNetPay,
  setDateProcessed,
  setUserId,
  setShowEmployeeForm,
  handleSubmit,
}) {
  const [errorState, setErrorState] = useState(false);

  const submit = (e) => {
    if (!payrollPeriodId || !employeePersonalInformationId || !payTypeId) {
      setErrorState(true);
      return;
    }
    handleSubmit(e);
    setErrorState(false);
  };

  const handleClose = () => {
    onClose();
    setPayrollPeriodId("");
    setEmployeePersonalInformationId("");
    setPayTypeId("");
    setTotalEcola("");
    setTotalAllowance("");
    setTotalTax("");
    setTotalDays("");
    setTotalDaysAbsents("");
    setTotalAbsents("");
    setTotalDaysLeaves("");
    setTotalLeaves("");
    setTotalDeduction("");
    setTotalAddition("");
    setTotalAdjustment("");
    setRate("");
    setTotalNighDiff("");
    setTotalHoursOTRegular("");
    setTotalOTRegular("");
    setTotalHoursOTRegularExceeded("");
    setTotalOTRegularExceeded("");
    setTotalHoursOTRestday("");
    setTotalOTRestday("");
    setTotalHoursOTRestdayExceeded("");
    setTotalOTRestdayExceeded("");
    setTotalHoursOTHolidaySpecial("");
    setTotalOTHolidaySpecial("");
    setTotalHoursOTHolidaySpecialExceeded("");
    setTotalOTHolidaySpecialExceeded("");
    setTotalHoursOTHolidayRegular("");
    setTotalOTHolidayRegular("");
    setTotalHoursOTHolidayRegularExceeded("");
    setTotalOTHolidayRegularExceeded("");
    setTotalHoursOTRestdayHolidaySpecial("");
    setTotalOTRestdayHolidaySpecial("");
    setTotalHoursOTRestdayHolidaySpecialExceeded("");
    setTotalOTRestdayHolidaySpecialExceeded("");
    setTotalHoursOTRestdayHolidayRegular("");
    setTotalOTRestdayHolidayRegular("");
    setTotalHoursOTRestdayHolidayRegularExceeded("");
    setTotalOTRestdayHolidayRegularExceeded("");
    setTotalSSS("");
    setTotalPagibig("");
    setTotalPhilhealth("");
    setTotalHoursUndertime("");
    setTotalUndertime("");
    setTotalHoursLate("");
    setTotalLate("");
    setTotalBasic("");
    setTotalGrossPay("");
    setTotalNetPay("");
    setDateProcessed("");
    setUserId("");
    setErrorState(false);
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Add Processed Payroll</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Employee</div>
                <div className="info-item-input">
                  <div
                    className="info-item-holder employee-select row"
                    style={{ flexDirection: "row", justifyContent: "normal" }}
                  >
                    <input
                      readOnly
                      className="employeeInput-select"
                      placeholder="Employee"
                      value={
                        employeePersonalInformationId
                          ? employeePersonalInformationFullName
                          : employeePersonalInformationId
                      }
                    />
                    <button
                      className="select row"
                      onClick={() => setShowEmployeeForm(true)}
                    >
                      <SearchIcon />
                    </button>
                  </div>
                  <span
                    style={{
                      visibility:
                        !employeePersonalInformationId && errorState
                          ? "visible"
                          : "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Payroll Period</div>
                  <div className="info-item-input">
                    <PayrollPeriodIdSelect
                      payrollPeriodId={payrollPeriodId}
                      setPayrollPeriodId={setPayrollPeriodId}
                    />
                  </div>
                  <span
                    style={{
                      visibility:
                        !payrollPeriodId && errorState ? "visible" : "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Pay Type</div>
                  <div className="info-item-input">
                    <PayTypeIdSelect
                      payTypeId={payTypeId}
                      setPayTypeId={setPayTypeId}
                    />
                  </div>
                  <span
                    style={{
                      visibility:
                        !payTypeId && errorState ? "visible" : "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Ecola</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Ecola"
                      value={totalEcola}
                      onChange={(e) => setTotalEcola(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Allowance</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Allowance"
                      value={totalAllowance}
                      onChange={(e) => setTotalAllowance(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Tax</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Tax"
                      value={totalTax}
                      onChange={(e) => setTotalTax(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Days</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Days"
                      value={totalDays}
                      onChange={(e) => setTotalDays(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Days Absents</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Days Absents"
                      value={totalDaysAbsents}
                      onChange={(e) => setTotalDaysAbsents(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Absents</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Absents"
                      value={totalAbsents}
                      onChange={(e) => setTotalAbsents(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Days Leaves</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Days Leaves"
                      value={totalDaysLeaves}
                      onChange={(e) => setTotalDaysLeaves(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Leaves</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Leaves"
                      value={totalLeaves}
                      onChange={(e) => setTotalLeaves(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Deduction</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Deduction"
                      value={totalDeduction}
                      onChange={(e) => setTotalDeduction(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Addition</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Addition"
                      value={totalAddition}
                      onChange={(e) => setTotalAddition(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Adjustment</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Adjustment"
                      value={totalAdjustment}
                      onChange={(e) => setTotalAdjustment(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Rate</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Rate"
                      value={rate}
                      onChange={(e) => setRate(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Night Diff</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Night Diff"
                      value={totalNighDiff}
                      onChange={(e) => setTotalNighDiff(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Hours OT Regular</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Hours OT Regular"
                      value={totalHoursOTRegular}
                      onChange={(e) => setTotalHoursOTRegular(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total OT Regular</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total OT Regular"
                      value={totalOTRegular}
                      onChange={(e) => setTotalOTRegular(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total Hours OT Regular Exceeded
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Hours OT Regular Exceeded"
                      value={totalHoursOTRegularExceeded}
                      onChange={(e) =>
                        setTotalHoursOTRegularExceeded(e.target.value)
                      }
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total OT Regular Exceeded
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total OT Regular Exceeded"
                      value={totalOTRegularExceeded}
                      onChange={(e) =>
                        setTotalOTRegularExceeded(e.target.value)
                      }
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Hours OT Restday</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Hours OT Restday"
                      value={totalHoursOTRestday}
                      onChange={(e) => setTotalHoursOTRestday(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total OT Restday</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total OT Restday"
                      value={totalOTRestday}
                      onChange={(e) => setTotalOTRestday(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total Hours OT Restday Exceeded
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Hours OT Restday Exceeded"
                      value={totalHoursOTRestdayExceeded}
                      onChange={(e) =>
                        setTotalHoursOTRestdayExceeded(e.target.value)
                      }
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total OT Restday Exceeded
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total OT Restday Exceeded"
                      value={totalOTRestdayExceeded}
                      onChange={(e) =>
                        setTotalOTRestdayExceeded(e.target.value)
                      }
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total Hours OT Holiday Special
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Hours OT Holiday Special"
                      value={totalHoursOTHolidaySpecial}
                      onChange={(e) =>
                        setTotalHoursOTHolidaySpecial(e.target.value)
                      }
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total OT Holiday Special
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total OT Holiday Special"
                      value={totalOTHolidaySpecial}
                      onChange={(e) => setTotalOTHolidaySpecial(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total Hours OT Holiday Special Exceeded
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Hours OT Holiday Special Exceeded"
                      value={totalHoursOTHolidaySpecialExceeded}
                      onChange={(e) =>
                        setTotalHoursOTHolidaySpecialExceeded(e.target.value)
                      }
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total OT Holiday Special Exceeded
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total OT Holiday Special Exceeded"
                      value={totalOTHolidaySpecialExceeded}
                      onChange={(e) =>
                        setTotalOTHolidaySpecialExceeded(e.target.value)
                      }
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total Hours OT Holiday Regular
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Hours OT Holiday Regular"
                      value={totalHoursOTHolidayRegular}
                      onChange={(e) =>
                        setTotalHoursOTHolidayRegular(e.target.value)
                      }
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total OT Holiday Regular
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total OT Holiday Regular"
                      value={totalOTHolidayRegular}
                      onChange={(e) => setTotalOTHolidayRegular(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total Hours OT Holiday Regular Exceeded
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Hours OT Holiday Regular Exceeded"
                      value={totalHoursOTHolidayRegularExceeded}
                      onChange={(e) =>
                        setTotalHoursOTHolidayRegularExceeded(e.target.value)
                      }
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total OT Holiday Regular Exceeded
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total OT Holiday Regular Exceeded"
                      value={totalOTHolidayRegularExceeded}
                      onChange={(e) =>
                        setTotalOTHolidayRegularExceeded(e.target.value)
                      }
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total Hours OT Restday Holiday Special
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Hours OT Restday Holiday Special"
                      value={totalHoursOTRestdayHolidaySpecial}
                      onChange={(e) =>
                        setTotalHoursOTRestdayHolidaySpecial(e.target.value)
                      }
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total OT Restday Holiday Special
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total OT Restday Holiday Special"
                      value={totalOTRestdayHolidaySpecial}
                      onChange={(e) =>
                        setTotalOTRestdayHolidaySpecial(e.target.value)
                      }
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total Hours OT Restday Holiday Special Exceeded
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Hours OT Restday Holiday Special Exceeded"
                      value={totalHoursOTRestdayHolidaySpecialExceeded}
                      onChange={(e) =>
                        setTotalHoursOTRestdayHolidaySpecialExceeded(
                          e.target.value
                        )
                      }
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total OT Restday Holiday Special Exceeded
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total OT Restday Holiday Special Exceeded"
                      value={totalOTRestdayHolidaySpecialExceeded}
                      onChange={(e) =>
                        setTotalOTRestdayHolidaySpecialExceeded(e.target.value)
                      }
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total Hours OT Restday Holiday Regular
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Hours OT Restday Holiday Regular"
                      value={totalHoursOTRestdayHolidayRegular}
                      onChange={(e) =>
                        setTotalHoursOTRestdayHolidayRegular(e.target.value)
                      }
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total OT Restday Holiday Regular
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total OT Restday Holiday Regular"
                      value={totalOTRestdayHolidayRegular}
                      onChange={(e) =>
                        setTotalOTRestdayHolidayRegular(e.target.value)
                      }
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total Hours OT Restday Holiday Regular Exceeded
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Hours OT Restday Holiday Regular Exceeded"
                      value={totalHoursOTRestdayHolidayRegularExceeded}
                      onChange={(e) =>
                        setTotalHoursOTRestdayHolidayRegularExceeded(
                          e.target.value
                        )
                      }
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total OT Restday Holiday Regular Exceeded
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total OT Restday Holiday Regular Exceeded"
                      value={totalOTRestdayHolidayRegularExceeded}
                      onChange={(e) =>
                        setTotalOTRestdayHolidayRegularExceeded(e.target.value)
                      }
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total SSS</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total SSS"
                      value={totalSSS}
                      onChange={(e) => setTotalSSS(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Pagibig</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Pagibig"
                      value={totalPagibig}
                      onChange={(e) => setTotalPagibig(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Philhealth</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Philhealth"
                      value={totalPhilhealth}
                      onChange={(e) => setTotalPhilhealth(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Hours Undertime</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Hours Undertime"
                      value={totalHoursUndertime}
                      onChange={(e) => setTotalHoursUndertime(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Undertime</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Undertime"
                      value={totalUndertime}
                      onChange={(e) => setTotalUndertime(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Hours Late</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Hours Late"
                      value={totalHoursLate}
                      onChange={(e) => setTotalHoursLate(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Late</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Late"
                      value={totalLate}
                      onChange={(e) => setTotalLate(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Basic</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Basic"
                      value={totalBasic}
                      onChange={(e) => setTotalBasic(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Gross Pay</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Gross Pay"
                      value={totalGrossPay}
                      onChange={(e) => setTotalGrossPay(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Net Pay</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Net Pay"
                      value={totalNetPay}
                      onChange={(e) => setTotalNetPay(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">User ID</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="User ID"
                      value={userId}
                      onChange={(e) => setUserId(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={(e) => submit(e)}
              >
                SAVE
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function EditProcessForm({
  isOpen,
  onClose,
  payrollPeriodId,
  employeePersonalInformationId,
  employeePersonalInformationFullName,
  payTypeId,
  totalEcola,
  totalAllowance,
  totalTax,
  totalDays,
  totalDaysAbsents,
  totalAbsents,
  totalDaysLeaves,
  totalLeaves,
  totalDeduction,
  totalAddition,
  totalAdjustment,
  rate,
  totalNighDiff,
  totalHoursOTRegular,
  totalOTRegular,
  totalHoursOTRegularExceeded,
  totalOTRegularExceeded,
  totalHoursOTRestday,
  totalOTRestday,
  totalHoursOTRestdayExceeded,
  totalOTRestdayExceeded,
  totalHoursOTHolidaySpecial,
  totalOTHolidaySpecial,
  totalHoursOTHolidaySpecialExceeded,
  totalOTHolidaySpecialExceeded,
  totalHoursOTHolidayRegular,
  totalOTHolidayRegular,
  totalHoursOTHolidayRegularExceeded,
  totalOTHolidayRegularExceeded,
  totalHoursOTRestdayHolidaySpecial,
  totalOTRestdayHolidaySpecial,
  totalHoursOTRestdayHolidaySpecialExceeded,
  totalOTRestdayHolidaySpecialExceeded,
  totalHoursOTRestdayHolidayRegular,
  totalOTRestdayHolidayRegular,
  totalHoursOTRestdayHolidayRegularExceeded,
  totalOTRestdayHolidayRegularExceeded,
  totalSSS,
  totalPagibig,
  totalPhilhealth,
  totalHoursUndertime,
  totalUndertime,
  totalHoursLate,
  totalLate,
  totalBasic,
  totalGrossPay,
  totalNetPay,
  dateProcessed,
  userId,
  setPayrollPeriodId,
  setEmployeePersonalInformationId,
  setPayTypeId,
  setTotalEcola,
  setTotalAllowance,
  setTotalTax,
  setTotalDays,
  setTotalDaysAbsents,
  setTotalAbsents,
  setTotalDaysLeaves,
  setTotalLeaves,
  setTotalDeduction,
  setTotalAddition,
  setTotalAdjustment,
  setRate,
  setTotalNighDiff,
  setTotalHoursOTRegular,
  setTotalOTRegular,
  setTotalHoursOTRegularExceeded,
  setTotalOTRegularExceeded,
  setTotalHoursOTRestday,
  setTotalOTRestday,
  setTotalHoursOTRestdayExceeded,
  setTotalOTRestdayExceeded,
  setTotalHoursOTHolidaySpecial,
  setTotalOTHolidaySpecial,
  setTotalHoursOTHolidaySpecialExceeded,
  setTotalOTHolidaySpecialExceeded,
  setTotalHoursOTHolidayRegular,
  setTotalOTHolidayRegular,
  setTotalHoursOTHolidayRegularExceeded,
  setTotalOTHolidayRegularExceeded,
  setTotalHoursOTRestdayHolidaySpecial,
  setTotalOTRestdayHolidaySpecial,
  setTotalHoursOTRestdayHolidaySpecialExceeded,
  setTotalOTRestdayHolidaySpecialExceeded,
  setTotalHoursOTRestdayHolidayRegular,
  setTotalOTRestdayHolidayRegular,
  setTotalHoursOTRestdayHolidayRegularExceeded,
  setTotalOTRestdayHolidayRegularExceeded,
  setTotalSSS,
  setTotalPagibig,
  setTotalPhilhealth,
  setTotalHoursUndertime,
  setTotalUndertime,
  setTotalHoursLate,
  setTotalLate,
  setTotalBasic,
  setTotalGrossPay,
  setTotalNetPay,
  setDateProcessed,
  setUserId,
  setShowEmployeeForm,
  handleUpdate,
}) {
  const [errorState, setErrorState] = useState(false);

  const submit = (e) => {
    if (!payrollPeriodId || !employeePersonalInformationId || !payTypeId) {
      setErrorState(true);
      return;
    }
    handleUpdate(e);
    setErrorState(false);
  };

  const handleClose = () => {
    setErrorState(false);
    onClose();
    setPayrollPeriodId("");
    setEmployeePersonalInformationId("");
    setPayTypeId("");
    setTotalEcola("");
    setTotalAllowance("");
    setTotalTax("");
    setTotalDays("");
    setTotalDaysAbsents("");
    setTotalAbsents("");
    setTotalDaysLeaves("");
    setTotalLeaves("");
    setTotalDeduction("");
    setTotalAddition("");
    setTotalAdjustment("");
    setRate("");
    setTotalNighDiff("");
    setTotalHoursOTRegular("");
    setTotalOTRegular("");
    setTotalHoursOTRegularExceeded("");
    setTotalOTRegularExceeded("");
    setTotalHoursOTRestday("");
    setTotalOTRestday("");
    setTotalHoursOTRestdayExceeded("");
    setTotalOTRestdayExceeded("");
    setTotalHoursOTHolidaySpecial("");
    setTotalOTHolidaySpecial("");
    setTotalHoursOTHolidaySpecialExceeded("");
    setTotalOTHolidaySpecialExceeded("");
    setTotalHoursOTHolidayRegular("");
    setTotalOTHolidayRegular("");
    setTotalHoursOTHolidayRegularExceeded("");
    setTotalOTHolidayRegularExceeded("");
    setTotalHoursOTRestdayHolidaySpecial("");
    setTotalOTRestdayHolidaySpecial("");
    setTotalHoursOTRestdayHolidaySpecialExceeded("");
    setTotalOTRestdayHolidaySpecialExceeded("");
    setTotalHoursOTRestdayHolidayRegular("");
    setTotalOTRestdayHolidayRegular("");
    setTotalHoursOTRestdayHolidayRegularExceeded("");
    setTotalOTRestdayHolidayRegularExceeded("");
    setTotalSSS("");
    setTotalPagibig("");
    setTotalPhilhealth("");
    setTotalHoursUndertime("");
    setTotalUndertime("");
    setTotalHoursLate("");
    setTotalLate("");
    setTotalBasic("");
    setTotalGrossPay("");
    setTotalNetPay("");
    setDateProcessed("");
    setUserId("");
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Update Processed Payroll</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Employee</div>
                <div className="info-item-input">
                  <div
                    className="info-item-holder employee-select row"
                    style={{ flexDirection: "row", justifyContent: "normal" }}
                  >
                    <input
                      readOnly
                      className="employeeInput-select"
                      placeholder="Employee"
                      style={{ cursor: "not-allowed" }}
                      value={
                        employeePersonalInformationId
                          ? employeePersonalInformationFullName
                          : employeePersonalInformationId
                      }
                    />
                  </div>
                  <span
                    style={{
                      visibility:
                        !employeePersonalInformationId && errorState
                          ? "visible"
                          : "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Payroll Period</div>
                  <div className="info-item-input">
                    <PayrollPeriodIdSelect
                      payrollPeriodId={payrollPeriodId}
                      setPayrollPeriodId={setPayrollPeriodId}
                    />
                  </div>
                  <span
                    style={{
                      visibility:
                        !payrollPeriodId && errorState ? "visible" : "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Pay Type</div>
                  <div className="info-item-input">
                    <PayTypeIdSelect
                      payTypeId={payTypeId}
                      setPayTypeId={setPayTypeId}
                    />
                  </div>
                  <span
                    style={{
                      visibility:
                        !payTypeId && errorState ? "visible" : "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Ecola</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Ecola"
                      value={totalEcola}
                      onChange={(e) => setTotalEcola(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Allowance</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Allowance"
                      value={totalAllowance}
                      onChange={(e) => setTotalAllowance(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Tax</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Tax"
                      value={totalTax}
                      onChange={(e) => setTotalTax(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Days</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Days"
                      value={totalDays}
                      onChange={(e) => setTotalDays(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Days Absents</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Days Absents"
                      value={totalDaysAbsents}
                      onChange={(e) => setTotalDaysAbsents(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Absents</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Absents"
                      value={totalAbsents}
                      onChange={(e) => setTotalAbsents(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Days Leaves</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Days Leaves"
                      value={totalDaysLeaves}
                      onChange={(e) => setTotalDaysLeaves(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Leaves</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Leaves"
                      value={totalLeaves}
                      onChange={(e) => setTotalLeaves(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Deduction</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Deduction"
                      value={totalDeduction}
                      onChange={(e) => setTotalDeduction(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Addition</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Addition"
                      value={totalAddition}
                      onChange={(e) => setTotalAddition(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Adjustment</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Adjustment"
                      value={totalAdjustment}
                      onChange={(e) => setTotalAdjustment(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Rate</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Rate"
                      value={rate}
                      onChange={(e) => setRate(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Night Diff</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Night Diff"
                      value={totalNighDiff}
                      onChange={(e) => setTotalNighDiff(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Hours OT Regular</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Hours OT Regular"
                      value={totalHoursOTRegular}
                      onChange={(e) => setTotalHoursOTRegular(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total OT Regular</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total OT Regular"
                      value={totalOTRegular}
                      onChange={(e) => setTotalOTRegular(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total Hours OT Regular Exceeded
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Hours OT Regular Exceeded"
                      value={totalHoursOTRegularExceeded}
                      onChange={(e) =>
                        setTotalHoursOTRegularExceeded(e.target.value)
                      }
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total OT Regular Exceeded
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total OT Regular Exceeded"
                      value={totalOTRegularExceeded}
                      onChange={(e) =>
                        setTotalOTRegularExceeded(e.target.value)
                      }
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Hours OT Restday</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Hours OT Restday"
                      value={totalHoursOTRestday}
                      onChange={(e) => setTotalHoursOTRestday(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total OT Restday</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total OT Restday"
                      value={totalOTRestday}
                      onChange={(e) => setTotalOTRestday(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total Hours OT Restday Exceeded
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Hours OT Restday Exceeded"
                      value={totalHoursOTRestdayExceeded}
                      onChange={(e) =>
                        setTotalHoursOTRestdayExceeded(e.target.value)
                      }
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total OT Restday Exceeded
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total OT Restday Exceeded"
                      value={totalOTRestdayExceeded}
                      onChange={(e) =>
                        setTotalOTRestdayExceeded(e.target.value)
                      }
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total Hours OT Holiday Special
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Hours OT Holiday Special"
                      value={totalHoursOTHolidaySpecial}
                      onChange={(e) =>
                        setTotalHoursOTHolidaySpecial(e.target.value)
                      }
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total OT Holiday Special
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total OT Holiday Special"
                      value={totalOTHolidaySpecial}
                      onChange={(e) => setTotalOTHolidaySpecial(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total Hours OT Holiday Special Exceeded
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Hours OT Holiday Special Exceeded"
                      value={totalHoursOTHolidaySpecialExceeded}
                      onChange={(e) =>
                        setTotalHoursOTHolidaySpecialExceeded(e.target.value)
                      }
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total OT Holiday Special Exceeded
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total OT Holiday Special Exceeded"
                      value={totalOTHolidaySpecialExceeded}
                      onChange={(e) =>
                        setTotalOTHolidaySpecialExceeded(e.target.value)
                      }
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total Hours OT Holiday Regular
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Hours OT Holiday Regular"
                      value={totalHoursOTHolidayRegular}
                      onChange={(e) =>
                        setTotalHoursOTHolidayRegular(e.target.value)
                      }
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total OT Holiday Regular
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total OT Holiday Regular"
                      value={totalOTHolidayRegular}
                      onChange={(e) => setTotalOTHolidayRegular(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total Hours OT Holiday Regular Exceeded
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Hours OT Holiday Regular Exceeded"
                      value={totalHoursOTHolidayRegularExceeded}
                      onChange={(e) =>
                        setTotalHoursOTHolidayRegularExceeded(e.target.value)
                      }
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total OT Holiday Regular Exceeded
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total OT Holiday Regular Exceeded"
                      value={totalOTHolidayRegularExceeded}
                      onChange={(e) =>
                        setTotalOTHolidayRegularExceeded(e.target.value)
                      }
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total Hours OT Restday Holiday Special
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Hours OT Restday Holiday Special"
                      value={totalHoursOTRestdayHolidaySpecial}
                      onChange={(e) =>
                        setTotalHoursOTRestdayHolidaySpecial(e.target.value)
                      }
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total OT Restday Holiday Special
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total OT Restday Holiday Special"
                      value={totalOTRestdayHolidaySpecial}
                      onChange={(e) =>
                        setTotalOTRestdayHolidaySpecial(e.target.value)
                      }
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total Hours OT Restday Holiday Special Exceeded
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Hours OT Restday Holiday Special Exceeded"
                      value={totalHoursOTRestdayHolidaySpecialExceeded}
                      onChange={(e) =>
                        setTotalHoursOTRestdayHolidaySpecialExceeded(
                          e.target.value
                        )
                      }
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total OT Restday Holiday Special Exceeded
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total OT Restday Holiday Special Exceeded"
                      value={totalOTRestdayHolidaySpecialExceeded}
                      onChange={(e) =>
                        setTotalOTRestdayHolidaySpecialExceeded(e.target.value)
                      }
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total Hours OT Restday Holiday Regular
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Hours OT Restday Holiday Regular"
                      value={totalHoursOTRestdayHolidayRegular}
                      onChange={(e) =>
                        setTotalHoursOTRestdayHolidayRegular(e.target.value)
                      }
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total OT Restday Holiday Regular
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total OT Restday Holiday Regular"
                      value={totalOTRestdayHolidayRegular}
                      onChange={(e) =>
                        setTotalOTRestdayHolidayRegular(e.target.value)
                      }
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total Hours OT Restday Holiday Regular Exceeded
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Hours OT Restday Holiday Regular Exceeded"
                      value={totalHoursOTRestdayHolidayRegularExceeded}
                      onChange={(e) =>
                        setTotalHoursOTRestdayHolidayRegularExceeded(
                          e.target.value
                        )
                      }
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">
                    Total OT Restday Holiday Regular Exceeded
                  </div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total OT Restday Holiday Regular Exceeded"
                      value={totalOTRestdayHolidayRegularExceeded}
                      onChange={(e) =>
                        setTotalOTRestdayHolidayRegularExceeded(e.target.value)
                      }
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total SSS</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total SSS"
                      value={totalSSS}
                      onChange={(e) => setTotalSSS(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Pagibig</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Pagibig"
                      value={totalPagibig}
                      onChange={(e) => setTotalPagibig(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Philhealth</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Philhealth"
                      value={totalPhilhealth}
                      onChange={(e) => setTotalPhilhealth(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Hours Undertime</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Hours Undertime"
                      value={totalHoursUndertime}
                      onChange={(e) => setTotalHoursUndertime(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Undertime</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Undertime"
                      value={totalUndertime}
                      onChange={(e) => setTotalUndertime(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Hours Late</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Hours Late"
                      value={totalHoursLate}
                      onChange={(e) => setTotalHoursLate(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Late</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Late"
                      value={totalLate}
                      onChange={(e) => setTotalLate(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Basic</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Basic"
                      value={totalBasic}
                      onChange={(e) => setTotalBasic(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Gross Pay</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Gross Pay"
                      value={totalGrossPay}
                      onChange={(e) => setTotalGrossPay(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Total Net Pay</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="Total Net Pay"
                      value={totalNetPay}
                      onChange={(e) => setTotalNetPay(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">User ID</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      placeholder="User ID"
                      value={userId}
                      onChange={(e) => setUserId(e.target.value)}
                    />
                  </div>
                  <span
                    style={{
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={(e) => submit(e)}
              >
                UPDATE
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function AddForm({
  isOpen,
  onClose,
  employeePersonalInformationId,
  employeePersonalInformationFullName,
  payrollPeriodId,
  payTypeId,
  description,
  amount,
  noOfHours,
  adjustmentDate,
  reference,
  referenceId,
  setEployeePersonalInformationId,
  setPayrollPeriodId,
  setPayTypeId,
  setDescription,
  setAmount,
  setNoOfHours,
  setAdjustmentDate,
  setReferenceId,
  setShowEmployeeForm,
  setReferenceIdForm,
  adjustmentType,
  handleSubmit,
}) {
  const [errorState, setErrorState] = useState(false);

  const submit = (e) => {
    if (
      !employeePersonalInformationId ||
      !payrollPeriodId ||
      !payTypeId ||
      !description ||
      !amount
    ) {
      if (adjustmentType === "OtherAdjustmentStaging") {
        if (!adjustmentDate && !referenceId && !noOfHours) {
          setErrorState(true);
          return;
        }
      }
      setErrorState(true);
      return;
    }
    handleSubmit(e);
    setErrorState(false);
  };

  const handleClose = () => {
    onClose();
    setEployeePersonalInformationId("");
    setPayrollPeriodId("");
    setPayTypeId("");
    setDescription("");
    setAmount("");
    setAdjustmentDate("");
    setReferenceId("");
    setErrorState(false);
  };

  var formType = "";

  if (adjustmentType === "OtherAdditionStaging") {
    formType = "Add Other Addition Payroll";
  } else if (adjustmentType === "OtherDeductionStaging") {
    formType = "Add Other Deduction Payroll";
  } else if (adjustmentType === "OtherAdjustmentStaging") {
    formType = "Add Other Adjustment Payroll";
  }

  var refValue = "";
  if (
    referenceId !== undefined &&
    referenceId !== null &&
    referenceId !== "" &&
    referenceId !== 0
  ) {
    const value = referenceId;
    const formattedNumber = value.toString().padStart(6, "0");
    refValue =
      reference?.requestTypeId === 1
        ? `${formattedNumber}`
        : `${formattedNumber}`;
  }

  const [currentPayTypeId, setCurrentPayTypeId] = useState("");
  useEffect(() => {
    if (isOpen && currentPayTypeId !== payTypeId) {
      setCurrentPayTypeId(payTypeId);
      setPayrollPeriodId("");
    }
  }, [currentPayTypeId, payTypeId, setPayrollPeriodId, isOpen]);

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>{formType}</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Employee</div>
                <div className="info-item-input">
                  <div
                    className="info-item-holder employee-select row"
                    style={{ flexDirection: "row", justifyContent: "normal" }}
                  >
                    <input
                      readOnly
                      className="employeeInput-select"
                      placeholder="Employee"
                      value={
                        employeePersonalInformationId
                          ? employeePersonalInformationFullName
                          : employeePersonalInformationId
                      }
                    />
                    <button
                      className="select row"
                      onClick={() => setShowEmployeeForm(true)}
                    >
                      <SearchIcon />
                    </button>
                  </div>
                  <span
                    style={{
                      visibility:
                        !employeePersonalInformationId && errorState
                          ? "visible"
                          : "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Pay Type</div>
                <div className="info-item-input">
                  <PayTypeIdSelect
                    payTypeId={payTypeId}
                    setPayTypeId={setPayTypeId}
                  />
                </div>
                <span
                  style={{
                    visibility: !payTypeId && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Payroll Period</div>
                <div className="info-item-input">
                  <PayrollPeriodIdSelectFilter
                    payrollPeriodId={payrollPeriodId}
                    setPayrollPeriodId={setPayrollPeriodId}
                    payTypeId={payTypeId}
                  />
                </div>
                <span
                  style={{
                    visibility:
                      (!payrollPeriodId && errorState) || !payTypeId
                        ? "visible"
                        : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  {!payTypeId
                    ? "Please select Pay Type first"
                    : "Please fill up this field"}
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Description</div>
                <div className="info-item-input">
                  <input
                    placeholder="Description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </div>
                <span
                  style={{
                    visibility:
                      !description && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Amount</div>
                <div className="info-item-input">
                  <input
                    type="number"
                    placeholder="Amount"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                  />
                </div>
                <span
                  style={{
                    visibility: !amount && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  Please fill up this field
                </span>
              </div>
              {adjustmentType === "OtherAdjustmentStaging" ||
              adjustmentType === "OtherLateAdjustmentStaging" ? (
                <div>
                  <div
                    className="popUp-item info-item column"
                    style={{ display: "none" }}
                  >
                    <div className="info-item-label">Number of Hours</div>
                    <div className="info-item-input">
                      <input
                        type="number"
                        placeholder="Number of Hours"
                        value={noOfHours}
                        onChange={(e) => setNoOfHours(e.target.value)}
                      />
                    </div>
                    <span
                      style={{
                        visibility:
                          !noOfHours && errorState ? "visible" : "hidden",
                        color: "#ff6565",
                        fontSize: "12px",
                      }}
                    >
                      Please fill up this field
                    </span>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Adjustment Date</div>
                    <div className="info-item-input">
                      <DateTimeInput
                        date={adjustmentDate}
                        setDate={setAdjustmentDate}
                      />
                    </div>
                    <span
                      style={{
                        visibility:
                          !adjustmentDate && errorState ? "visible" : "hidden",
                        color: "#ff6565",
                        fontSize: "12px",
                      }}
                    >
                      Please fill up this field
                    </span>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Reference Id</div>
                    <div className="info-item-input">
                      <div
                        className="info-item-holder employee-select row"
                        style={{
                          flexDirection: "row",
                          justifyContent: "normal",
                        }}
                      >
                        <input
                          readOnly
                          className="employeeInput-select"
                          placeholder="Reference Id"
                          value={refValue}
                        />
                        <button
                          className="select row"
                          onClick={() => setReferenceIdForm(true)}
                        >
                          <SearchIcon />
                        </button>
                      </div>
                      <span
                        style={{
                          visibility:
                            !referenceId && errorState ? "visible" : "hidden",
                          color: "#ff6565",
                          fontSize: "12px",
                        }}
                      >
                        Please fill up this field
                      </span>
                    </div>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={(e) => submit(e)}
              >
                SAVE
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function EditForm({
  isOpen,
  onClose,
  employeePersonalInformationId,
  employeePersonalInformationFullName,
  payrollPeriodId,
  payTypeId,
  description,
  amount,
  noOfHours,
  adjustmentDate,
  reference,
  referenceId,
  setEployeePersonalInformationId,
  setPayrollPeriodId,
  setPayTypeId,
  setDescription,
  setAmount,
  setAdjustmentDate,
  setReferenceId,
  setShowEmployeeForm,
  setNoOfHours,
  setReferenceIdForm,
  adjustmentType,
  handleUpdate,
}) {
  const [errorState, setErrorState] = useState(false);

  const submit = (e) => {
    if (
      !employeePersonalInformationId ||
      !payrollPeriodId ||
      !payTypeId ||
      !description ||
      !amount
    ) {
      if (adjustmentType === "OtherAdjustmentStaging") {
        if (!adjustmentDate && !referenceId && !noOfHours) {
          setErrorState(true);
          return;
        }
      }
      setErrorState(true);
      return;
    }
    handleUpdate(e);
    setErrorState(false);
  };

  const handleClose = () => {
    onClose();
    setEployeePersonalInformationId("");
    setPayrollPeriodId("");
    setPayTypeId("");
    setDescription("");
    setAmount("");
    setAdjustmentDate("");
    setReferenceId("");
    setErrorState(false);
  };

  var formType = "";

  if (adjustmentType === "OtherAddition") {
    formType = "Update Other Addition Payroll";
  } else if (adjustmentType === "OtherDeduction") {
    formType = "Update Other Deduction Payroll";
  } else if (adjustmentType === "OtherAdjustment") {
    formType = "Update Other Adjustment Payroll";
  }

  var refValue = "";
  if (
    referenceId !== undefined &&
    referenceId !== null &&
    referenceId !== "" &&
    referenceId !== 0
  ) {
    const value = referenceId;
    const formattedNumber = value.toString().padStart(6, "0");
    refValue =
      reference?.requestTypeId === 1
        ? `${formattedNumber}`
        : `${formattedNumber}`;
  }

  const [currentPayTypeId, setCurrentPayTypeId] = useState("");
  useEffect(() => {
    if (isOpen && currentPayTypeId !== payTypeId) {
      setCurrentPayTypeId(payTypeId);

      if (currentPayTypeId) {
        setPayrollPeriodId("");
      }
    }
  }, [currentPayTypeId, payTypeId, setPayrollPeriodId, isOpen]);

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>{formType}</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Employee</div>
                <div className="info-item-input">
                  <div
                    className="info-item-holder employee-select row"
                    style={{ flexDirection: "row", justifyContent: "normal" }}
                  >
                    <input
                      readOnly
                      className="employeeInput-select"
                      placeholder="Employee"
                      style={{ cursor: "not-allowed" }}
                      value={
                        employeePersonalInformationId
                          ? employeePersonalInformationFullName
                          : employeePersonalInformationId
                      }
                    />
                  </div>
                </div>
                <span
                  style={{
                    visibility:
                      !employeePersonalInformationId && errorState
                        ? "visible"
                        : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Pay Type</div>
                <div className="info-item-input">
                  <PayTypeIdSelect
                    payTypeId={payTypeId}
                    setPayTypeId={setPayTypeId}
                  />
                </div>
                <span
                  style={{
                    visibility: !payTypeId && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Payroll Period</div>
                <div className="info-item-input">
                  <PayrollPeriodIdSelectFilter
                    payrollPeriodId={payrollPeriodId}
                    setPayrollPeriodId={setPayrollPeriodId}
                    payTypeId={payTypeId}
                  />
                </div>
                <span
                  style={{
                    visibility:
                      (!payrollPeriodId && errorState) || !payTypeId
                        ? "visible"
                        : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  {!payTypeId
                    ? "Please select Pay Type first"
                    : "Please fill up this field"}
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Description</div>
                <div className="info-item-input">
                  <input
                    placeholder="Description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </div>
                <span
                  style={{
                    visibility:
                      !description && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Amount</div>
                <div className="info-item-input">
                  <input
                    type="number"
                    placeholder="Amount"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                  />
                </div>
                <span
                  style={{
                    visibility: !amount && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  Please fill up this field
                </span>
              </div>
              {adjustmentType === "OtherAdjustmentStaging" ||
              adjustmentType === "OtherLateAdjustmentStaging" ? (
                <div>
                  <div
                    className="popUp-item info-item column"
                    style={{ display: "none" }}
                  >
                    <div className="info-item-label">Number of Hours</div>
                    <div className="info-item-input">
                      <input
                        type="number"
                        placeholder="Number of Hours"
                        value={noOfHours}
                        onChange={(e) => setNoOfHours(e.target.value)}
                      />
                    </div>
                    <span
                      style={{
                        visibility:
                          !noOfHours && errorState ? "visible" : "hidden",
                        color: "#ff6565",
                        fontSize: "12px",
                      }}
                    >
                      Please fill up this field
                    </span>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Adjustment Date</div>
                    <div className="info-item-input">
                      <DateTimeInput
                        date={adjustmentDate}
                        setDate={setAdjustmentDate}
                      />
                    </div>
                    <span
                      style={{
                        visibility:
                          !adjustmentDate && errorState ? "visible" : "hidden",
                        color: "#ff6565",
                        fontSize: "12px",
                      }}
                    >
                      Please fill up this field
                    </span>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Reference Id</div>
                    <div className="info-item-input">
                      <div
                        className="info-item-holder employee-select row"
                        style={{
                          flexDirection: "row",
                          justifyContent: "normal",
                        }}
                      >
                        <input
                          readOnly
                          className="employeeInput-select"
                          placeholder="Reference Id"
                          value={refValue}
                        />
                        <button
                          className="select row"
                          onClick={() => setReferenceIdForm(true)}
                        >
                          <SearchIcon />
                        </button>
                      </div>
                      <span
                        style={{
                          visibility:
                            !referenceId && errorState ? "visible" : "hidden",
                          color: "#ff6565",
                          fontSize: "12px",
                        }}
                      >
                        Please fill up this field
                      </span>
                    </div>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={(e) => submit(e)}
              >
                UPDATE
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function DeleteForm({ isOpen, onClose, handleDelete }) {
  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Delete!</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div
              className="popUp-body"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <span>Are you sure you want to delete this?</span>
            </div>
            <div
              className="buttons row"
              style={{
                justifyContent: "center",
                padding: "40px 40px 20px 40px",
              }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={handleDelete}
                style={{ marginRight: "5px" }}
              >
                DELETE
              </button>
              <button
                id="add-family"
                className="cancel row"
                onClick={() => handleClose()}
              >
                CANCEL
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function PostMessage({ isOpen, onClose, handlePost }) {
  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Post Data!</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div
              className="popUp-body"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <span>Are you sure you want to post this payroll?</span>
            </div>
            <div
              className="buttons row"
              style={{
                justifyContent: "center",
                padding: "40px 40px 20px 40px",
              }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={handlePost}
                style={{ marginRight: "5px" }}
              >
                POST
              </button>
              <button
                id="add-family"
                className="cancel row"
                onClick={() => handleClose()}
              >
                CANCEL
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function DeleteAllForm({
  isOpen,
  onClose,
  payrollPeriodId,
  payTypeId,
  setPayrollPeriodId,
  setPayTypeId,
  handleDelete,
}) {
  const [errorState, setErrorState] = useState(false);

  const submit = (e) => {
    if (!payrollPeriodId || !payTypeId) {
      setErrorState(true);
      return;
    }
    handleClose();
    handleDelete(e);
    setErrorState(false);
  };

  const handleClose = () => {
    onClose();
    setPayrollPeriodId("");
    setPayTypeId("");
    setErrorState(false);
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Delete!</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div
              className="popUp-body"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div className="popUp-item info-item column">
                <div className="info-item-label">Payroll Period</div>
                <div className="info-item-input">
                  <PayrollPeriodIdSelect
                    payrollPeriodId={payrollPeriodId}
                    setPayrollPeriodId={setPayrollPeriodId}
                  />
                </div>
                <span
                  style={{
                    visibility:
                      !payrollPeriodId && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Pay Type</div>
                <div className="info-item-input">
                  <PayTypeIdSelect
                    payTypeId={payTypeId}
                    setPayTypeId={setPayTypeId}
                  />
                </div>
                <span
                  style={{
                    visibility: !payTypeId && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  Please fill up this field
                </span>
              </div>
            </div>
            <div
              className="buttons row"
              style={{
                justifyContent: "center",
                padding: "40px 40px 20px 40px",
              }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={(e) => submit(e)}
                style={{ marginRight: "5px" }}
              >
                DELETE
              </button>
              <button
                id="add-family"
                className="cancel row"
                onClick={() => handleClose()}
              >
                CANCEL
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function DeleteAllPayrollSummaryForm({
  isOpen,
  onClose,
  payrollPeriodId,
  setPayrollPeriodId,
  handleDelete,
}) {
  const [errorState, setErrorState] = useState(false);

  const submit = (e) => {
    if (!payrollPeriodId) {
      setErrorState(true);
      return;
    }
    handleDelete(e);
    handleClose();
    setErrorState(false);
  };

  const handleClose = () => {
    onClose();
    setPayrollPeriodId("");
    setErrorState(false);
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Delete!</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div
              className="popUp-body"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div className="popUp-item info-item column">
                <div className="info-item-label">Payroll Period</div>
                <div className="info-item-input">
                  <PayrollPeriodIdSelect
                    payrollPeriodId={payrollPeriodId}
                    setPayrollPeriodId={setPayrollPeriodId}
                  />
                </div>
                <span
                  style={{
                    visibility:
                      !payrollPeriodId && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  Please fill up this field
                </span>
              </div>
            </div>
            <div
              className="buttons row"
              style={{
                justifyContent: "center",
                padding: "40px 40px 20px 40px",
              }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={(e) => submit(e)}
                style={{ marginRight: "5px" }}
              >
                DELETE
              </button>
              <button
                id="add-family"
                className="cancel row"
                onClick={() => handleClose()}
              >
                CANCEL
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function UploadForm({
  isOpen,
  onClose,
  payrollPeriodId,
  payTypeId,
  setPayrollPeriodId,
  setPayTypeId,
  type,
  data_temp,
  setData_temp,
  handleFileUpload,
  handleFinalFileUpload,
}) {
  const handleClose = () => {
    onClose();
    setPayrollPeriodId("");
    setPayTypeId("");
    setFiles("");
    setData_temp([]);
  };

  const [files, setFiles] = useState([]);
  const [currentFiles, setCurrentFiles] = useState([]);
  const [hasNoError, setHasNoError] = useState(false);

  useEffect(() => {
    if (data_temp.length > 0) {
      const _errorData = data_temp.filter((i) => i.errors.length > 0);

      if (_errorData.length <= 0) {
        setHasNoError(true);
      } else {
        setHasNoError(false);
      }
    }
  }, [data_temp]);

  const handleBrowse = (e) => {
    const fileList = Array.from(e.target.files);
    setFiles(fileList);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    const fileList = Array.from(e.dataTransfer.files);
    setFiles(fileList);
    e.currentTarget.style.backgroundColor = "white";
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "#bdbdbd7d";
  };
  const handleDragOut = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "white";
  };
  const clearFiles = () => {
    // Clear the files state
    setFiles([]);
    // Reset the value of the file input
    document.getElementById("fileInput").value = "";
    setData_temp([]);
  };

  useEffect(() => {
    if (currentFiles !== files) {
      setCurrentFiles(files);
      handleFileUpload(files, type, payrollPeriodId, payTypeId);
    }
  }, [files, handleFileUpload, currentFiles, type, payrollPeriodId, payTypeId]);

  const [errorState, setErrorState] = useState(false);

  const submit = (e) => {
    if (!payrollPeriodId || !payTypeId) {
      setErrorState(true);
      return;
    }
    handleFinalFileUpload(data_temp, type);
    handleClose();
    setErrorState(false);
  };

  const [currentPage, setCurrentPage] = useState(1);
  var header = [
    "Employee Id",
    "Employee Name",
    "Description",
    "Amount",
    "Error",
  ];
  var accessor = [
    "employeePersonalInformationEmployeeId",
    "employeePersonalInformationFullName",
    "description",
    "amount",
    "errors",
  ];
  var headerAdjustment = [
    "Employee Id",
    "Employee Name",
    "Description",
    "Amount",
    "Number Of Hours",
    "Adjustment Date",
    "Reference Id",
    "Error",
  ];
  var accessorAdjustment = [
    "employeePersonalInformationEmployeeId",
    "employeePersonalInformationFullName",
    "description",
    "amount",
    "noOfHours",
    "adjustmentDate",
    "referenceId",
    "errors",
  ];

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>{"Upload " + type}</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div
              className="popUp-body user-template-body"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div className="popUp-item info-item column">
                <div className="info-item-label">Pay Type</div>
                <div className="info-item-input">
                  <PayTypeIdSelect
                    payTypeId={payTypeId}
                    setPayTypeId={setPayTypeId}
                  />
                </div>
                <span
                  style={{
                    visibility: !payTypeId && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Payroll Period</div>
                <div className="info-item-input">
                  <PayrollPeriodIdSelectFilter
                    payrollPeriodId={payrollPeriodId}
                    setPayrollPeriodId={setPayrollPeriodId}
                    payTypeId={payTypeId}
                  />
                </div>
                <span
                  style={{
                    visibility:
                      (!payrollPeriodId && errorState) || !payTypeId
                        ? "visible"
                        : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  {!payTypeId
                    ? "Please select Pay Type first"
                    : "Please fill up this field"}
                </span>
              </div>
            </div>
            <div>
              <label htmlFor="fileInput" className="browse">
                Browse...
              </label>
              <input
                type="file"
                id="fileInput"
                onChange={(e) => handleBrowse(e)}
                style={{ display: "none" }}
              />
              <div
                id="drop-files-here"
                onDrop={(e) => handleDrop(e)}
                onDragOver={(e) => handleDragOver(e)}
                onDragLeave={(e) => handleDragOut(e)}
                style={{
                  border: "2px dashed #ccc",
                  borderRadius: "5px",
                  padding: "20px",
                  marginTop: "10px",
                  textAlign: "center",
                }}
              >
                Drop files here
              </div>
              {files.length > 0 && (
                <div style={{ border: "1px solid #97979745", padding: "10px" }}>
                  <span>Uploaded File:</span>
                  <ul>
                    {files.map((file, index) => (
                      <span key={index}>{file.name}</span>
                    ))}
                  </ul>
                  <div
                    className="buttons row"
                    style={{ display: "flex", justifyContent: "end" }}
                  >
                    <button
                      id="add-family"
                      className="cancel row"
                      onClick={() => clearFiles()}
                      style={{ marginRight: "5px" }}
                    >
                      CLEAR
                    </button>
                  </div>
                </div>
              )}
            </div>
            {files.length > 0 && (
              <>
                {hasNoError ? (
                  <>
                    <div
                      style={{
                        marginTop: "10px",
                        padding: "10px",
                        backgroundColor: "#4cc92a",
                        color: "white",
                      }}
                    >
                      Data is valid.
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      style={{
                        marginTop: "10px",
                        padding: "10px",
                        backgroundColor: "#ce3434",
                        color: "white",
                      }}
                    >
                      Cannot upload with error.
                    </div>
                  </>
                )}
                <div
                  className="employeesTab-tab upload-preview-tab"
                  style={{ marginTop: "10px" }}
                >
                  <div
                    id="container1 table-uploads"
                    className="employeesTab-table container"
                  >
                    <CreateTableForUpload
                      dataList={data_temp}
                      dataHeader={
                        type === "Other Adjustments" ? headerAdjustment : header
                      }
                      dataAccessor={
                        type === "Other Adjustments"
                          ? accessorAdjustment
                          : accessor
                      }
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
                <div
                  className="buttons row"
                  style={{
                    justifyContent: "end",
                    padding: "40px 40px 20px 40px",
                  }}
                >
                  {hasNoError && (
                    <button
                      id="add-family"
                      className="save row"
                      onClick={(e) => submit(e)}
                      style={{ marginRight: "5px" }}
                    >
                      UPLOAD
                    </button>
                  )}
                  <button
                    id="add-family"
                    className="cancel row"
                    style={{
                      marginRight: "5px",
                      height: "34px",
                      borderRadius: "3px",
                    }}
                    onClick={() => handleClose()}
                  >
                    CANCEL
                  </button>
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </>
  );
}
function RevertPayrollForm({
  isOpen,
  onClose,
  fetchOtherAddition,
  fetchOtherDeduction,
  fetchOtherAdjustment,
  fetchLateAdjustmentData,
  fetchProcess,
  setIsRevert,
  isGenerate,
  user,
}) {
  const [loadingPercentage, setLoadingPercentage] = useState(0);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [errorState, setErrorState] = useState(false);
  const [payrollPeriodId, setPayrollPeriodId] = useState("");
  const [payTypeId, setPayTypeId] = useState("");
  const [classificationId, setClassificationId] = useState("");
  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
    if (showRequestMessage) {
      const timeoutId = setTimeout(() => {
        setShowRequestMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }
  }, [showRequestMessage]);
  function GenerateMessage({ form, message, isSuccess }) {
    return (
      <>
        <div
          className={`modal-overlay toggleMessage-overlay ${
            form ? "open" : ""
          }`}
        >
          {form && (
            <div
              className="modal toggleMessage"
              style={{ backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5" }}
            >
              <div className="column">
                {isSuccess ? (
                  <div
                    className="request_title row"
                    style={{
                      fontWeight: "bold",
                      color: "green",
                      alignItems: "center",
                    }}
                  >
                    <CheckCircleIcon />
                    <span>{"SUCCESS MESSAGE"}</span>
                  </div>
                ) : (
                  <div
                    className="request_title row"
                    style={{
                      fontWeight: "bold",
                      color: "#DD5746",
                      alignItems: "center",
                    }}
                  >
                    <ErrorIcon />
                    <span>{"ERROR MESSAGE"}</span>
                  </div>
                )}
                <span
                  style={{
                    textAlign: "center",
                    padding: "10px 0",
                    color: isSuccess ? "green" : "#DD5746",
                  }}
                >
                  {message}
                </span>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
  //Request Messages -end

  const submit = (e) => {
    if (!payrollPeriodId || !payTypeId || !classificationId) {
      setErrorState(true);
      return;
    }
    handleClose();
    handleRevert(e);
    setErrorState(false);
    setIsRevert(true);
  };

  const handleClose = () => {
    onClose();
    setPayrollPeriodId("");
    setPayTypeId("");
    setClassificationId("");
    setErrorState(false);
  };
  const apiUrlRef = useRef(domain + `/api/PayrollSummaryStaging`);

  const handleRevert = async (event) => {
    event.preventDefault();
    const apiUrl =
      apiUrlRef.current +
      `/revert/${payTypeId}/${payrollPeriodId}/${classificationId}`;
    let progress = 10; // Start progress at 10%

    // Gradually increase progress while waiting for long API calls
    const simulateLoading = (targetPercentage, intervalTime = 500) => {
      return new Promise((resolve) => {
        const interval = setInterval(() => {
          if (progress < targetPercentage) {
            progress += 1; // Increase by 1% every interval
            setLoadingPercentage(progress);
          } else {
            clearInterval(interval);
            resolve(); // Stop when reaching the target percentage
          }
        }, intervalTime); // Adjust interval time for smoother/slower increments
      });
    };

    try {
      setLoadingPercentage(10); // Initial 10%
      setLoadingRequest(true);

      // Simulate gradual loading progress while waiting for axios.post
      simulateLoading(30, 200); // Simulate increase to 30% slowly over 200ms per step

      // Actual axios call
      await axios.post(apiUrl, null, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      setLoadingPercentage(30);

      await SetAuditTrail({
        setupArea: "Payroll",
        actionTaken: "revert",
        field: "Revert Payroll",
        newValue: `-`,
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id,
      });

      await simulateLoading(60, 100);

      await fetchOtherAddition();

      // Simulate gradual progress to 70%
      await simulateLoading(70, 100);

      await fetchOtherDeduction();

      // Simulate gradual progress to 80%
      await simulateLoading(80, 100);

      await fetchOtherAdjustment();
      await fetchLateAdjustmentData();

      // Simulate gradual progress to 90%
      await simulateLoading(90, 100);

      await fetchProcess();

      setShowRequestMessage(true);
      setIsSuccess(true);

      // Final smooth increase to 95%
      simulateLoading(95, 100);
      handleClose();
    } catch (error) {
      // Stop any ongoing simulation
      setLoadingPercentage(progress); // Stop at the current percentage
      setLoadingRequest(false); // Set the loading state to false

      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error("Error:", error);
      const errorMessage = JSON.parse(
        error.response.request.responseText
      ).message;
      setRequestMessage(errorMessage); // Optionally simulate slow reset to 0 to show failure state

      await simulateLoading(0, 100); // Gradually decrease to 0 for a smoother UX
    } finally {
      // Finalize loading process and reset
      await simulateLoading(100, 100); // Gradually increment to 100% before closing
      setTimeout(() => {
        setLoadingPercentage(0);
        setLoadingRequest(false);
      }, 500); // Delay to show full completion before resetting
    }
  };

  const [currentPayTypeId, setCurrentPayTypeId] = useState("");
  useEffect(() => {
    if (currentPayTypeId !== payTypeId) {
      setCurrentPayTypeId(payTypeId);
      setClassificationId("");
      setPayrollPeriodId("");
    }
  }, [currentPayTypeId, payTypeId]);

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Revert Payroll</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div
              className="popUp-body column"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div className="popUp-item info-item column">
                <div className="info-item-label">Pay Type</div>
                <div className="info-item-input">
                  <PayTypeIdSelect
                    payTypeId={payTypeId}
                    setPayTypeId={setPayTypeId}
                  />
                </div>
                <span
                  style={{
                    visibility: !payTypeId && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Payroll Period</div>
                <div className="info-item-input">
                  <PayrollPeriodIdSelectFilter
                    payrollPeriodId={payrollPeriodId}
                    setPayrollPeriodId={setPayrollPeriodId}
                    payTypeId={payTypeId}
                  />
                </div>
                <span
                  style={{
                    visibility:
                      (!payrollPeriodId && errorState) || !payTypeId
                        ? "visible"
                        : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  {!payTypeId
                    ? "Please select Pay Type first"
                    : "Please fill up this field"}
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Classification Type</div>
                <div className="info-item-input">
                  <ClassificationIdSelectFilter
                    user={user}
                    classificationId={classificationId}
                    setClassificationId={setClassificationId}
                    payTypeId={payTypeId}
                  />
                </div>
                <span
                  style={{
                    visibility:
                      (!classificationId && errorState) || !payTypeId
                        ? "visible"
                        : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  {!payTypeId
                    ? "Please select Pay Type first"
                    : "Please fill up this field"}
                </span>
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "40px 40px 20px 40px" }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={(e) => submit(e)}
                style={{ marginRight: "5px" }}
              >
                REVERT
              </button>
            </div>
          </div>
        )}
      </div>
      <GenerateMessage
        form={showRequestMessage}
        message={isSuccess ? "Request Success!" : requestMessage}
        isSuccess={isSuccess}
      ></GenerateMessage>
      {loadingRequest ? (
        <CustomLoader loadingPercentage={loadingPercentage} />
      ) : (
        <></>
      )}
    </>
  );
}
function ProcessPayrollForm({
  isOpen,
  onClose,
  fetchOtherAddition,
  fetchOtherDeduction,
  fetchOtherAdjustment,
  fetchLateAdjustmentData,
  fetchProcess,
  setIsProcess,
  isGenerate,
  user,
}) {
  const [loadingPercentage, setLoadingPercentage] = useState(0);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [errorState, setErrorState] = useState(false);
  const [payrollPeriodId, setPayrollPeriodId] = useState("");
  const [payTypeId, setPayTypeId] = useState("");
  const [classificationId, setClassificationId] = useState("");

  const [isAllowanceCredited, setIsAllowanceCredited] = useState(false);
  const [isBenefitCredited, setIsBenefitCredited] = useState(false);
  const [isTaxDeductionPeriod, setIsTaxDeductionPeriod] = useState(false);
  const [isGovernmentPremiumsPeriod, setIsGovernmentPremiumsPeriod] =
    useState(false);
  const [isLoanDeductionPeriod, setIsLoanDeductionPeriod] = useState(false);
  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
    if (showRequestMessage) {
      const timeoutId = setTimeout(() => {
        setShowRequestMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }
  }, [showRequestMessage]);
  function GenerateMessage({ form, message, isSuccess }) {
    return (
      <>
        <div
          className={`modal-overlay toggleMessage-overlay ${
            form ? "open" : ""
          }`}
        >
          {form && (
            <div
              className="modal toggleMessage"
              style={{ backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5" }}
            >
              <div className="column">
                {isSuccess ? (
                  <div
                    className="request_title row"
                    style={{
                      fontWeight: "bold",
                      color: "green",
                      alignItems: "center",
                    }}
                  >
                    <CheckCircleIcon />
                    <span>{"SUCCESS MESSAGE"}</span>
                  </div>
                ) : (
                  <div
                    className="request_title row"
                    style={{
                      fontWeight: "bold",
                      color: "#DD5746",
                      alignItems: "center",
                    }}
                  >
                    <ErrorIcon />
                    <span>{"ERROR MESSAGE"}</span>
                  </div>
                )}
                <span
                  style={{
                    textAlign: "center",
                    padding: "10px 0",
                    color: isSuccess ? "green" : "#DD5746",
                  }}
                >
                  {message}
                </span>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
  //Request Messages -end

  const submit = (e) => {
    if (!payrollPeriodId || !payTypeId || !classificationId) {
      setErrorState(true);
      return;
    }
    handleClose();
    handleProcess(e);
    setErrorState(false);
    setIsProcess(true);
  };

  const handleClose = () => {
    onClose();
    setPayrollPeriodId("");
    setPayTypeId("");
    setClassificationId("");
    setIsAllowanceCredited(false);
    setIsBenefitCredited(false);
    setIsGovernmentPremiumsPeriod(false);
    setIsTaxDeductionPeriod(false);
    setIsLoanDeductionPeriod(false);
    setErrorState(false);
  };

  const apiUrlRef = useRef(domain + `/api/PayrollSummaryStaging`);

  const handleProcess = async (event) => {
    event.preventDefault();
    // const apiUrl = apiUrlRef.current + `/process/${payTypeId}/${payrollPeriodId}/classification/${classificationId}`;
    const apiUrl =
      apiUrlRef.current +
      `/process/${payTypeId}/${payrollPeriodId}/classification/${classificationId}/isAllowance/${isAllowanceCredited}/isBenefit/${isBenefitCredited}/isGovtPremium/${isGovernmentPremiumsPeriod}/isTax/${isTaxDeductionPeriod}/isLoan/${isLoanDeductionPeriod}`;
    let progress = 10; // Start progress at 10%

    // Gradually increase progress while waiting for long API calls
    const simulateLoading = (targetPercentage, intervalTime = 500) => {
      return new Promise((resolve) => {
        const interval = setInterval(() => {
          if (progress < targetPercentage) {
            progress += 1; // Increase by 1% every interval
            setLoadingPercentage(progress);
          } else {
            clearInterval(interval);
            resolve(); // Stop when reaching the target percentage
          }
        }, intervalTime); // Adjust interval time for smoother/slower increments
      });
    };

    try {
      setLoadingPercentage(10); // Initial 10%
      setLoadingRequest(true);

      // Simulate gradual loading progress while waiting for axios.post
      simulateLoading(30, 200); // Simulate increase to 30% slowly over 200ms per step

      // Actual axios call
      await axios.post(apiUrl, null, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      setLoadingPercentage(30); // Set immediate jump to 40% after axios call finishes

      await SetAuditTrail({
        setupArea: "Payroll",
        actionTaken: "process",
        field: "Process Payroll",
        newValue: `-`,
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id,
      });

      await simulateLoading(60, 100);

      await fetchOtherAddition();

      // Simulate gradual progress to 70%
      await simulateLoading(70, 100);

      await fetchOtherDeduction();

      // Simulate gradual progress to 80%
      await simulateLoading(80, 100);

      await fetchOtherAdjustment();
      await fetchLateAdjustmentData();

      // Simulate gradual progress to 90%
      await simulateLoading(90, 100);

      await fetchProcess();

      setShowRequestMessage(true);
      setIsSuccess(true);

      // Final smooth increase to 95%
      simulateLoading(95, 100);
      handleClose();
    } catch (error) {
      // Stop any ongoing simulation
      setLoadingPercentage(progress); // Stop at the current percentage
      setLoadingRequest(false); // Set the loading state to false

      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error("Error:", error);
      const errorMessage = JSON.parse(
        error.response.request.responseText
      ).message;
      setRequestMessage(errorMessage); // Optionally simulate slow reset to 0 to show failure state

      await simulateLoading(0, 100); // Gradually decrease to 0 for a smoother UX
    } finally {
      // Finalize loading process and reset
      await simulateLoading(100, 100); // Gradually increment to 100% before closing
      setTimeout(() => {
        setLoadingPercentage(0);
        setLoadingRequest(false);
      }, 500); // Delay to show full completion before resetting
    }
  };

  const [currentPayTypeId, setCurrentPayTypeId] = useState("");
  useEffect(() => {
    if (currentPayTypeId !== payTypeId) {
      setCurrentPayTypeId(payTypeId);
      setClassificationId("");
      setPayrollPeriodId("");
    }
  }, [currentPayTypeId, payTypeId]);

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Process Payroll</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div
              className="popUp-body column"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div className="popUp-item info-item column">
                <div className="info-item-label">Pay Type</div>
                <div className="info-item-input">
                  <PayTypeIdSelect
                    payTypeId={payTypeId}
                    setPayTypeId={setPayTypeId}
                  />
                </div>
                <span
                  style={{
                    visibility: !payTypeId && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Payroll Period</div>
                <div className="info-item-input">
                  <PayrollPeriodIdSelectFilter
                    payrollPeriodId={payrollPeriodId}
                    setPayrollPeriodId={setPayrollPeriodId}
                    payTypeId={payTypeId}
                  />
                </div>
                <span
                  style={{
                    visibility:
                      (!payrollPeriodId && errorState) || !payTypeId
                        ? "visible"
                        : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  {!payTypeId
                    ? "Please select Pay Type first"
                    : "Please fill up this field"}
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Classification Type</div>
                <div className="info-item-input">
                  <ClassificationIdSelectFilter
                    user={user}
                    classificationId={classificationId}
                    setClassificationId={setClassificationId}
                    payTypeId={payTypeId}
                  />
                </div>
                <span
                  style={{
                    visibility:
                      (!classificationId && errorState) || !payTypeId
                        ? "visible"
                        : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  {!payTypeId
                    ? "Please select Pay Type first"
                    : "Please fill up this field"}
                </span>
              </div>
              <div
                className="popUp-item info-item row"
                style={{ alignItems: "center" }}
              >
                <div
                  className="info-item-label"
                  style={{ paddingRight: "10px" }}
                >
                  Is Allowance Credited?
                </div>
                <div className="info-item-input">
                  <input
                    type="checkbox"
                    id="isActive-checkbox"
                    className="checkbox"
                    name=""
                    checked={isAllowanceCredited}
                    onChange={(e) => setIsAllowanceCredited(e.target.checked)}
                  />
                </div>
              </div>
              <div
                className="popUp-item info-item row"
                style={{ alignItems: "center" }}
              >
                <div
                  className="info-item-label"
                  style={{ paddingRight: "10px" }}
                >
                  Is Benefits Credited?
                </div>
                <div className="info-item-input">
                  <input
                    type="checkbox"
                    id="isActive-checkbox"
                    className="checkbox"
                    name=""
                    checked={isBenefitCredited}
                    onChange={(e) => setIsBenefitCredited(e.target.checked)}
                  />
                </div>
              </div>
              <div
                className="popUp-item info-item row"
                style={{ alignItems: "center" }}
              >
                <div
                  className="info-item-label"
                  style={{ paddingRight: "10px" }}
                >
                  Is Government Premiums Period?
                </div>
                <div className="info-item-input">
                  <input
                    type="checkbox"
                    id="isActive-checkbox"
                    className="checkbox"
                    name=""
                    checked={isGovernmentPremiumsPeriod}
                    onChange={(e) =>
                      setIsGovernmentPremiumsPeriod(e.target.checked)
                    }
                  />
                </div>
              </div>
              <div
                className="popUp-item info-item row"
                style={{ alignItems: "center" }}
              >
                <div
                  className="info-item-label"
                  style={{ paddingRight: "10px" }}
                >
                  Is Tax Deduction Period?
                </div>
                <div className="info-item-input">
                  <input
                    type="checkbox"
                    id="isActive-checkbox"
                    className="checkbox"
                    name=""
                    checked={isTaxDeductionPeriod}
                    onChange={(e) => setIsTaxDeductionPeriod(e.target.checked)}
                  />
                </div>
              </div>
              <div
                className="popUp-item info-item row"
                style={{ alignItems: "center" }}
              >
                <div
                  className="info-item-label"
                  style={{ paddingRight: "10px" }}
                >
                  Is Loan Deduction Period?
                </div>
                <div className="info-item-input">
                  <input
                    type="checkbox"
                    id="isActive-checkbox"
                    className="checkbox"
                    name=""
                    checked={isLoanDeductionPeriod}
                    onChange={(e) => setIsLoanDeductionPeriod(e.target.checked)}
                  />
                </div>
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "40px 40px 20px 40px" }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={(e) => submit(e)}
                style={{ marginRight: "5px" }}
              >
                PROCESS
              </button>
            </div>
          </div>
        )}
      </div>
      <GenerateMessage
        form={showRequestMessage}
        message={isSuccess ? "Request Success!" : requestMessage}
        isSuccess={isSuccess}
      ></GenerateMessage>
      {loadingRequest ? (
        <CustomLoader loadingPercentage={loadingPercentage} />
      ) : (
        <></>
      )}
    </>
  );
}
function PostPayrollForm({
  isOpen,
  onClose,
  fetchOtherAddition,
  fetchOtherDeduction,
  fetchOtherAdjustment,
  fetchLateAdjustmentData,
  fetchProcess,
  setIsPost,
  isGenerate,
  user,
}) {
  const [loadingPercentage, setLoadingPercentage] = useState(0);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [errorState, setErrorState] = useState(false);
  const [payrollPeriodId, setPayrollPeriodId] = useState("");
  const [payTypeId, setPayTypeId] = useState("");
  const [classificationId, setClassificationId] = useState("");
  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
    if (showRequestMessage) {
      const timeoutId = setTimeout(() => {
        setShowRequestMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }
  }, [showRequestMessage]);
  function GenerateMessage({ form, message, isSuccess }) {
    return (
      <>
        <div
          className={`modal-overlay toggleMessage-overlay ${
            form ? "open" : ""
          }`}
        >
          {form && (
            <div
              className="modal toggleMessage"
              style={{ backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5" }}
            >
              <div className="column">
                {isSuccess ? (
                  <div
                    className="request_title row"
                    style={{
                      fontWeight: "bold",
                      color: "green",
                      alignItems: "center",
                    }}
                  >
                    <CheckCircleIcon />
                    <span>{"SUCCESS MESSAGE"}</span>
                  </div>
                ) : (
                  <div
                    className="request_title row"
                    style={{
                      fontWeight: "bold",
                      color: "#DD5746",
                      alignItems: "center",
                    }}
                  >
                    <ErrorIcon />
                    <span>{"ERROR MESSAGE"}</span>
                  </div>
                )}
                <span
                  style={{
                    textAlign: "center",
                    padding: "10px 0",
                    color: isSuccess ? "green" : "#DD5746",
                  }}
                >
                  {message}
                </span>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
  //Request Messages -end

  const submit = (e) => {
    if (!payrollPeriodId || !payTypeId || !classificationId) {
      setErrorState(true);
      return;
    }
    handleClose();
    handlePost(e);
    setErrorState(false);
    setIsPost(true);
  };

  const handleClose = () => {
    onClose();
    setPayrollPeriodId("");
    setPayTypeId("");
    setClassificationId("");
    setErrorState(false);
  };
  const apiUrlRef = useRef(domain + `/api/PayrollSummaryStaging`);

  const handlePost = async (event) => {
    event.preventDefault();
    const apiUrl =
      apiUrlRef.current +
      `/post/${payTypeId}/${payrollPeriodId}/classification/${classificationId}`;
    let progress = 10; // Start progress at 10%

    // Gradually increase progress while waiting for long API calls
    const simulateLoading = (targetPercentage, intervalTime = 500) => {
      return new Promise((resolve) => {
        const interval = setInterval(() => {
          if (progress < targetPercentage) {
            progress += 1; // Increase by 1% every interval
            setLoadingPercentage(progress);
          } else {
            clearInterval(interval);
            resolve(); // Stop when reaching the target percentage
          }
        }, intervalTime); // Adjust interval time for smoother/slower increments
      });
    };

    try {
      setLoadingPercentage(10); // Initial 10%
      setLoadingRequest(true);

      // Simulate gradual loading progress while waiting for axios.post
      simulateLoading(30, 200); // Simulate increase to 30% slowly over 200ms per step

      // Actual axios call
      await axios.post(apiUrl, null, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      setLoadingPercentage(30);

      await SetAuditTrail({
        setupArea: "Payroll",
        actionTaken: "post",
        field: "Post Payroll",
        newValue: `-`,
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id,
      });

      await simulateLoading(60, 100);

      await fetchOtherAddition();

      // Simulate gradual progress to 70%
      await simulateLoading(70, 100);

      await fetchOtherDeduction();

      // Simulate gradual progress to 80%
      await simulateLoading(80, 100);

      await fetchOtherAdjustment();
      await fetchLateAdjustmentData();

      // Simulate gradual progress to 90%
      await simulateLoading(90, 100);

      await fetchProcess();

      setShowRequestMessage(true);
      setIsSuccess(true);

      // Final smooth increase to 95%
      simulateLoading(95, 100);
      handleClose();
    } catch (error) {
      // Stop any ongoing simulation
      setLoadingPercentage(progress); // Stop at the current percentage
      setLoadingRequest(false); // Set the loading state to false

      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error("Error:", error);
      const errorMessage = JSON.parse(
        error.response.request.responseText
      ).message;
      setRequestMessage(errorMessage); // Optionally simulate slow reset to 0 to show failure state

      await simulateLoading(0, 100); // Gradually decrease to 0 for a smoother UX
    } finally {
      // Finalize loading process and reset
      await simulateLoading(100, 100); // Gradually increment to 100% before closing
      setTimeout(() => {
        setLoadingPercentage(0);
        setLoadingRequest(false);
      }, 0); // Delay to show full completion before resetting
    }
  };

  const [currentPayTypeId, setCurrentPayTypeId] = useState("");
  useEffect(() => {
    if (currentPayTypeId !== payTypeId) {
      setCurrentPayTypeId(payTypeId);
      setClassificationId("");
      setPayrollPeriodId("");
    }
  }, [currentPayTypeId, payTypeId]);

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Post Payroll</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div
              className="popUp-body column"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div className="popUp-item info-item column">
                <div className="info-item-label">Pay Type</div>
                <div className="info-item-input">
                  <PayTypeIdSelect
                    payTypeId={payTypeId}
                    setPayTypeId={setPayTypeId}
                  />
                </div>
                <span
                  style={{
                    visibility: !payTypeId && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Payroll Period</div>
                <div className="info-item-input">
                  <PayrollPeriodIdSelectFilter
                    payrollPeriodId={payrollPeriodId}
                    setPayrollPeriodId={setPayrollPeriodId}
                    payTypeId={payTypeId}
                  />
                </div>
                <span
                  style={{
                    visibility:
                      (!payrollPeriodId && errorState) || !payTypeId
                        ? "visible"
                        : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  {!payTypeId
                    ? "Please select Pay Type first"
                    : "Please fill up this field"}
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Classification Type</div>
                <div className="info-item-input">
                  <ClassificationIdSelectFilter
                    user={user}
                    classificationId={classificationId}
                    setClassificationId={setClassificationId}
                    payTypeId={payTypeId}
                  />
                </div>
                <span
                  style={{
                    visibility:
                      (!classificationId && errorState) || !payTypeId
                        ? "visible"
                        : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  {!payTypeId
                    ? "Please select Pay Type first"
                    : "Please fill up this field"}
                </span>
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "40px 40px 20px 40px" }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={(e) => submit(e)}
                style={{ marginRight: "5px" }}
              >
                POST
              </button>
            </div>
          </div>
        )}
      </div>
      <GenerateMessage
        form={showRequestMessage}
        message={isSuccess ? "Request Success!" : requestMessage}
        isSuccess={isSuccess}
      ></GenerateMessage>
      {loadingRequest ? (
        <CustomLoader loadingPercentage={loadingPercentage} />
      ) : (
        <></>
      )}
      {/* {loadingRequest ? (
                <div style={{
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    zIndex: "2000",
                    display: "flex",
                    flexDirection: "column", // Stacks items vertically
                    alignItems: "center", // Centers items horizontally
                    textAlign: "center" // Ensures text is centered
                }}>
                    <img src={loadingSpinner} alt="Loading..." />
                    {loadingPercentage !== 0 && <p style={{color: "rgb(104, 104, 104)"}}>{`Loading: ${loadingPercentage}%`}</p>}
                </div>
            ) : (
                <></>
                )
            } */}
    </>
  );
}
function SyncLateAdjustment({
  isOpen,
  onClose,
  fetchOtherAddition,
  fetchOtherDeduction,
  fetchOtherAdjustment,
  fetchLateAdjustmentData,
  fetchProcess,
  setIsProcess,
  isGenerate,
  mainPayrollPeriod,
  user,
}) {
  const [loadingPercentage, setLoadingPercentage] = useState(0);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [errorState, setErrorState] = useState(false);
  const [payrollPeriodId, setPayrollPeriodId] = useState("");
  const [payTypeId, setPayTypeId] = useState("");
  const [classificationId, setClassificationId] = useState("");
  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
    if (showRequestMessage) {
      const timeoutId = setTimeout(() => {
        setShowRequestMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }
  }, [showRequestMessage]);
  function GenerateMessage({ form, message, isSuccess }) {
    return (
      <>
        <div
          className={`modal-overlay toggleMessage-overlay ${
            form ? "open" : ""
          }`}
        >
          {form && (
            <div
              className="modal toggleMessage"
              style={{ backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5" }}
            >
              <div className="column">
                {isSuccess ? (
                  <div
                    className="request_title row"
                    style={{
                      fontWeight: "bold",
                      color: "green",
                      alignItems: "center",
                    }}
                  >
                    <CheckCircleIcon />
                    <span>{"SUCCESS MESSAGE"}</span>
                  </div>
                ) : (
                  <div
                    className="request_title row"
                    style={{
                      fontWeight: "bold",
                      color: "#DD5746",
                      alignItems: "center",
                    }}
                  >
                    <ErrorIcon />
                    <span>{"ERROR MESSAGE"}</span>
                  </div>
                )}
                <span
                  style={{
                    textAlign: "center",
                    padding: "10px 0",
                    color: isSuccess ? "green" : "#DD5746",
                  }}
                >
                  {message}
                </span>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
  //Request Messages -end

  const submit = (e) => {
    if (!payrollPeriodId || !payTypeId || !classificationId) {
      setErrorState(true);
      return;
    }
    handleClose();
    handleProcess(e);
    setErrorState(false);
    // setIsProcess(true);
  };

  const handleClose = () => {
    onClose();
    setPayrollPeriodId("");
    setPayTypeId("");
    setClassificationId("");
    setErrorState(false);
  };

  const apiUrlRef = useRef(domain + `/api/OtherAdjustmentStaging`);

  const handleProcess = async (event) => {
    event.preventDefault();
    // const apiUrl = apiUrlRef.current + `/process/${payTypeId}/${payrollPeriodId}/classification/${classificationId}`;
    const apiUrl =
      apiUrlRef.current +
      `/generate-late-approval-adjustments/paytype/${payTypeId}/payrollperiod/${payrollPeriodId}/classification/${classificationId}/main-payrollperiod/${mainPayrollPeriod}`;
    let progress = 10; // Start progress at 10%

    // Gradually increase progress while waiting for long API calls
    const simulateLoading = (targetPercentage, intervalTime = 500) => {
      return new Promise((resolve) => {
        const interval = setInterval(() => {
          if (progress < targetPercentage) {
            progress += 1; // Increase by 1% every interval
            setLoadingPercentage(progress);
          } else {
            clearInterval(interval);
            resolve(); // Stop when reaching the target percentage
          }
        }, intervalTime); // Adjust interval time for smoother/slower increments
      });
    };

    try {
      setLoadingPercentage(10); // Initial 10%
      setLoadingRequest(true);

      // Simulate gradual loading progress while waiting for axios.post
      simulateLoading(30, 200); // Simulate increase to 30% slowly over 200ms per step

      // Actual axios call
      await axios.post(apiUrl, null, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      setLoadingPercentage(30); // Set immediate jump to 40% after axios call finishes

      await SetAuditTrail({
        setupArea: "Payroll",
        actionTaken: "process",
        field: "Process Payroll",
        newValue: `-`,
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id,
      });

      await simulateLoading(60, 100);

      await fetchOtherAddition();

      // Simulate gradual progress to 70%
      await simulateLoading(70, 100);

      await fetchOtherDeduction();

      // Simulate gradual progress to 80%
      await simulateLoading(80, 100);

      await fetchOtherAdjustment();
      await fetchLateAdjustmentData();

      // Simulate gradual progress to 90%
      await simulateLoading(90, 100);

      await fetchProcess();

      setShowRequestMessage(true);
      setIsSuccess(true);

      // Final smooth increase to 95%
      simulateLoading(95, 100);
      handleClose();
    } catch (error) {
      // Stop any ongoing simulation
      setLoadingPercentage(progress); // Stop at the current percentage
      setLoadingRequest(false); // Set the loading state to false

      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error("Error:", error);
      const errorMessage = JSON.parse(
        error.response.request.responseText
      ).message;
      setRequestMessage(errorMessage); // Optionally simulate slow reset to 0 to show failure state

      await simulateLoading(0, 100); // Gradually decrease to 0 for a smoother UX
    } finally {
      // Finalize loading process and reset
      await simulateLoading(100, 100); // Gradually increment to 100% before closing
      setTimeout(() => {
        setLoadingPercentage(0);
        setLoadingRequest(false);
      }, 500); // Delay to show full completion before resetting
    }
  };

  const [currentPayTypeId, setCurrentPayTypeId] = useState("");
  useEffect(() => {
    if (currentPayTypeId !== payTypeId) {
      setCurrentPayTypeId(payTypeId);
      setClassificationId("");
      setPayrollPeriodId("");
    }
  }, [currentPayTypeId, payTypeId]);

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Sync Adjustment</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div
              className="popUp-body column"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div className="popUp-item info-item column">
                <div className="info-item-label">Pay Type</div>
                <div className="info-item-input">
                  <PayTypeIdSelect
                    payTypeId={payTypeId}
                    setPayTypeId={setPayTypeId}
                  />
                </div>
                <span
                  style={{
                    visibility: !payTypeId && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Late Payroll Period</div>
                <div className="info-item-input">
                  <PayrollPeriodIdSelectFilter2
                    payrollPeriodId={payrollPeriodId}
                    setPayrollPeriodId={setPayrollPeriodId}
                    payTypeId={payTypeId}
                    mainPayrollPeriod={mainPayrollPeriod}
                  />
                </div>
                <span
                  style={{
                    visibility:
                      (!payrollPeriodId && errorState) || !payTypeId
                        ? "visible"
                        : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  {!payTypeId
                    ? "Please select Pay Type first"
                    : "Please fill up this field"}
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Classification Type</div>
                <div className="info-item-input">
                  <ClassificationIdSelectFilter
                    user={user}
                    classificationId={classificationId}
                    setClassificationId={setClassificationId}
                    payTypeId={payTypeId}
                  />
                </div>
                <span
                  style={{
                    visibility:
                      (!classificationId && errorState) || !payTypeId
                        ? "visible"
                        : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  {!payTypeId
                    ? "Please select Pay Type first"
                    : "Please fill up this field"}
                </span>
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "40px 40px 20px 40px" }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={(e) => submit(e)}
                style={{ marginRight: "5px" }}
              >
                SYNC
              </button>
            </div>
          </div>
        )}
      </div>
      <GenerateMessage
        form={showRequestMessage}
        message={isSuccess ? "Request Success!" : requestMessage}
        isSuccess={isSuccess}
      ></GenerateMessage>
      {loadingRequest ? (
        <CustomLoader loadingPercentage={loadingPercentage} />
      ) : (
        <></>
      )}
    </>
  );
}
function EmployeeSelectForm({
  isOpen,
  onClose,
  setEmployeeId,
  setEmployee,
  userAccessData,
  user,
}) {
  var header = ["Id", "Name"];
  var accessor = ["employeeId", "fullName"];

  const handleClose = () => {
    onClose();
    fetchData();
  };
  const handleProceed = () => {
    onClose();
    setEmployeeId(selectedEmployee.id);
    setEmployee(selectedEmployee.fullName);
    fetchData();
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [employeesInfo, setEmployeesInfo] = useState([]);
  const [allEmployeesBasicInfo, setAllEmployeesBasicInfo] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [filterDataIndex, setFilterDataIndex] = useState(0);
  const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");

  const [
    classificationFilterForAdminHRHead,
    setClassificationFilterForAdminHRHead,
  ] = useState("0");
  const [currentClassificationFilter, setCurrentClassificationFilter] =
    useState("");

  /* const fetchDataAllData = useCallback(async () => {
        const apiUrl =  domain + "/api/Employee";
        try {
            const response = await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
                return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []); */

  const fetchData = useCallback(async () => {
    const apiUrl = domain + "/api/Employee/active";

    try {
      setLoading(true);
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      });
      // const employeeAllData = await fetchDataAllData();
      setEmployeesInfo(response.data);
      setAllEmployeesBasicInfo(response.data);
      setEmployees(response.data);
      setFilterData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false); // Set loading state to false after data fetching is complete
    }
  }, []);

  const handleFilter = (value) => {
    setCurrentPage(1);
    const lowercaseValue = value.toLowerCase();
    var res = [];

    switch (filterDataIndex) {
      case 0:
        res = filterData.filter((f) =>
          f.fullName.toLowerCase().includes(lowercaseValue)
        );
        break;
      case 1:
        res = filterData.filter((f) =>
          f.employeeId.toString().startsWith(lowercaseValue)
        );
        break;
      default:
        res = filterData.filter((f) =>
          f.fullName.toLowerCase().includes(lowercaseValue)
        );

        break;
    }

    setEmployees(res);
  };

  useEffect(() => {
    let classifiedData = allEmployeesBasicInfo;
    let classificiationFilter = classificationFilterForAdminHRHead;

    setCurrentClassificationFilter(classificiationFilter);

    if (classificiationFilter !== "0" && classificiationFilter !== "All") {
      const _classified = allEmployeesBasicInfo.filter((employee) => {
        const foundEmployee = employeesInfo.find(
          (_employee) => _employee.employeeId === employee.employeeId
        );

        if (
          foundEmployee.employeeInformation &&
          foundEmployee.employeeInformation.classificationId
        ) {
          return (
            foundEmployee.employeeInformation.classificationId.toString() ===
            classificiationFilter
          );
        }
        return false;
      });

      classifiedData = _classified;
    }

    if (classificiationFilter !== currentClassificationFilter) {
      setEmployees(classifiedData);
      setFilterData(classifiedData);
    }
  }, [
    classificationFilterForAdminHRHead,
    currentClassificationFilter,
    employees,
    employeesInfo,
    allEmployeesBasicInfo,
  ]);

  useEffect(() => {
    switch (filterDataIndex) {
      case 0:
        setSearchPlaceholder("Search by name");
        break;
      case 1:
        setSearchPlaceholder("Search by id");
        break;
      default:
        setSearchPlaceholder("Search by name");
        break;
    }
    fetchData();
  }, [fetchData, filterDataIndex]);

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Select Employee</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="transaction-body">
                <div className="filters-payroll">
                  <span>Filter</span>
                  <div
                    className="payroll-item-holder info-item-holder row"
                    style={{
                      padding: "0 10px 20px 10px",
                      justifyContent: "normal",
                    }}
                  >
                    <div className="filter-item-payroll popUp-item info-item column">
                      <div className="info-item-label">Filter</div>
                      <div className="info-item-input">
                        <EmployeeFilter
                          setFilterDataIndex={setFilterDataIndex}
                        />
                      </div>
                    </div>
                    {userAccessData.length <= 0 && (
                      <div className="filter-item-payroll popUp-item info-item column">
                        <div className="info-item-label">
                          Classification Type
                        </div>
                        <div className="info-item-input">
                          <ClassificationIdSelectWithAllDummy />
                        </div>
                      </div>
                    )}
                    <div className="filter-item-payroll popUp-item info-item column">
                      <div className="info-item-label">Classification Type</div>
                      <div className="info-item-input">
                        <ClassificationIdSelectWithAll1
                          user={user}
                          classificationId={classificationFilterForAdminHRHead}
                          setClassificationId={
                            setClassificationFilterForAdminHRHead
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="transaction-body-top row">
                  {CreateSearchBarWithPlaceHolder(
                    "",
                    "transaction-search row",
                    "transaction-search-icon",
                    "transaction-search-input",
                    (e) => handleFilter(e.target.value),
                    searchPlaceholder,
                    SearchIcon
                  )}
                </div>
              </div>
              <div className="select-employee-table">
                <CreateTableForEmployeeSelect
                  dataList={employees}
                  dataHeader={header}
                  dataAccessor={accessor}
                  setSelectedEmployee={setSelectedEmployee}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                />
                {employees.length > 0 ? (
                  <div></div>
                ) : (
                  <div>
                    {loading ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "10vh",
                        }}
                      >
                        <img src={loadingSpinner} alt="Loading..." />
                      </div>
                    ) : (
                      <div> {/*<p>No records to display</p>*/}</div>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "50px 20px 0 20px" }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={handleProceed}
              >
                PROCEED
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function EmployeeFilter({ setFilterDataIndex }) {
  const [selectedOption, setSelectedOption] = useState("All");

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);

    switch (event.target.value) {
      case "All":
        setFilterDataIndex(0);
        break;
      case "EmployeeId":
        setFilterDataIndex(1);
        break;
      default:
        setFilterDataIndex(0);
        break;
    }
  };

  return (
    <select
      id=""
      className="filterSelect"
      value={selectedOption}
      onChange={handleSelectChange}
    >
      <option value="All">All</option>
      <option value="EmployeeId">Employee Id</option>
    </select>
  );
}
function ReferenceSelectForm({
  isOpen,
  onClose,
  setReference,
  setReferenceId,
  setAdjustmentDate,
}) {
  var header = [
    "Reference No.",
    "Employee",
    "Request Date",
    "Request",
    "Status",
    "",
  ];
  var accessor = [
    "referenceNumber",
    "employeePersonalInformationFullName",
    "dateRequested",
    "requestTypeDescription",
    "status",
    "manage",
  ];

  const [viewData, setViewData] = useState([]);
  const [showViewData, setShowViewData] = useState(false);
  const [data, setData] = useState([]);
  const [selectedReference, setSelectedReference] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [filterDataIndex, setFilterDataIndex] = useState(0);
  const [searchPlaceholder, setSearchPlaceholder] = useState(
    "Search by reference id"
  );

  const handleClose = () => {
    onClose();
    fetchData();
  };
  const handleProceed = () => {
    onClose();
    if (selectedReference.length !== 0) {
      setReference(selectedReference);
      setReferenceId(selectedReference.referenceNumber);
      setAdjustmentDate(selectedReference.dateRequested);
    }
    fetchData();
  };
  const viewHandleClick = (data) => {
    setViewData(data);
    setShowViewData(true);
  };
  const closeViewHandleClick = () => {
    setShowViewData(false);
  };

  const fetchData = useCallback(async () => {
    const leaves = await fetchDataLeave();
    const ot = await fetchDataOvertime();

    const combinedData = [...leaves, ...ot];

    setData(combinedData);
    setFilterData(combinedData);
  }, []);

  const fetchDataLeave = async () => {
    const apiUrl = `${domain}/api/LeaveRequest/days-range/30`;

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const filteredDatas = response.data.filter(
        (filteredData) => filteredData.status === "Approved"
      );

      return filteredDatas;
    } catch (error) {
      console.error("Error fetching leave data:", error);

      return [];
    }
  };

  const fetchDataOvertime = async () => {
    const apiUrl = `${domain}/api/OvertimeRequest/days-range/30`;

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const filteredDatas = response.data.filter(
        (filteredData) => filteredData.status === "Approved"
      );
      return filteredDatas;
    } catch (error) {
      console.error("Error fetching leave data:", error);

      return [];
    }
  };

  const handleFilter = (value) => {
    const lowercaseValue = value.toLowerCase();
    var res = [];

    switch (filterDataIndex) {
      case 0:
        res = filterData.filter((f) =>
          f.referenceNumber.toString().startsWith(lowercaseValue)
        );
        break;
      case 1:
        res = filterData.filter((f) =>
          f.employeePersonalInformationFullName
            .toLowerCase()
            .includes(lowercaseValue)
        );
        break;
      default:
        res = filterData.filter((f) =>
          f.referenceNumber.toString().startsWith(lowercaseValue)
        );
        break;
    }

    setData(res);
  };

  useEffect(() => {
    switch (filterDataIndex) {
      case 0:
        setSearchPlaceholder("Search by reference id");
        break;
      case 1:
        setSearchPlaceholder("Search by employee");
        break;
      default:
        setSearchPlaceholder("Search by reference id");
        break;
    }
    fetchData();
  }, [fetchData, filterDataIndex]);

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Select Reference Id</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="transaction-body">
              <ReferenceFilter setFilterDataIndex={setFilterDataIndex} />
              <div className="transaction-body-top row">
                {CreateSearchBarWithPlaceHolder(
                  "",
                  "transaction-search row",
                  "transaction-search-icon",
                  "transaction-search-input",
                  (e) => handleFilter(e.target.value),
                  searchPlaceholder,
                  SearchIcon
                )}
              </div>
            </div>
            <div className="popUp-body selectModal">
              <div className="select-employee-table">
                <CreateTableForReferenceSelect
                  dataList={data}
                  dataHeader={header}
                  dataAccessor={accessor}
                  setSelectedReference={setSelectedReference}
                  viewHandleClick={viewHandleClick}
                />
                {data.length > 0 ? (
                  <div></div>
                ) : (
                  <div> {/*<p>No records to display</p>*/}</div>
                )}
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "50px 20px 0 20px" }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={handleProceed}
              >
                PROCEED
              </button>
            </div>
          </div>
        )}
      </div>
      <ViewLeaveForm
        isOpen={showViewData}
        onClose={closeViewHandleClick}
        viewData={viewData}
      ></ViewLeaveForm>
    </>
  );
}
function ReferenceFilter({ setFilterDataIndex }) {
  const [selectedOption, setSelectedOption] = useState("All");

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);

    switch (event.target.value) {
      case "All":
        setFilterDataIndex(0);
        break;
      case "Employee":
        setFilterDataIndex(1);
        break;
      default:
        setFilterDataIndex(0);
        break;
    }
  };

  return (
    <div className="filters row" style={{ alignItems: "center" }}>
      <span style={{ marginRight: "10px" }}>Filter</span>
      <select
        id=""
        className="filterSelect"
        value={selectedOption}
        onChange={handleSelectChange}
      >
        <option value="All">All</option>
        <option value="Employee">Employee</option>
      </select>
    </div>
  );
}
function ViewLeaveForm({ isOpen, onClose, viewData }) {
  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Reference Details</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Employee</div>
                <div className="info-item-input">
                  <input
                    readOnly={true}
                    id="employeePersonalInformationFullNameLeave"
                    placeholder="Employee"
                    value={viewData.employeePersonalInformationFullName}
                  />
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Leave Type</div>
                <div className="info-item-input">
                  <input
                    readOnly={true}
                    id="employeePersonalInformationFullNameLeave"
                    placeholder="Employee"
                    value={viewData.leaveTypeDescription}
                  />
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date From</div>
                  <div className="info-item-input">
                    <input
                      readOnly={true}
                      id="employeePersonalInformationFullNameLeave"
                      placeholder="Employee"
                      value={viewData.dateFrom}
                    />
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date To</div>
                  <div className="info-item-input">
                    <input
                      readOnly={true}
                      id="employeePersonalInformationFullNameLeave"
                      placeholder="Employee"
                      value={viewData.dateTo}
                    />
                  </div>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Days</div>
                  <div className="info-item-input">
                    <input
                      readOnly
                      type="number"
                      id="daysLeave"
                      placeholder="Days"
                      value={viewData.days}
                    />
                  </div>
                </div>
              </div>
              <div className="transaction-from-splitItem row">
                <div className="transaction-form-item row">
                  <div
                    className="transaction-form-input"
                    style={{ width: "auto" }}
                  >
                    <input
                      type="checkbox"
                      readOnly
                      id="overtime-allowance"
                      className="checkbox"
                      name=""
                      checked={viewData.isHalfDay}
                    />
                  </div>
                  <div
                    className="transaction-form-category"
                    style={{ padding: "0 10px" }}
                  >
                    <h5 style={{ fontWeight: "normal" }}>Half Day?</h5>
                  </div>
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Reason</div>
                <div className="info-item-input">
                  <textarea
                    id="tamper"
                    className="filterSelect"
                    style={{
                      width: "100%",
                      minHeight: "50px",
                      borderRadius: "3px",
                      border: "1px solid #80808080",
                      color: "rgb(104, 104, 104)",
                    }}
                    value={viewData.reason}
                    readOnly
                  />
                </div>
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="cancel row"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function PayrollPeriodIdSelect({ payrollPeriodId, setPayrollPeriodId }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setPayrollPeriodId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    //const currentYear = new Date().getFullYear();
    //const apiUrl =  domain + `/api/PayrollPeriod/year/${currentYear}`;
    const apiUrl = domain + `/api/PayrollPeriod/active`; // changed

    await axios
      .get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      })
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    fetchData();
    if (payrollPeriodId !== "" && payrollPeriodId !== 0) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [payrollPeriodId]);

  return (
    <div>
      <select
        id="employee-select-PagibigReport"
        value={payrollPeriodId}
        onChange={handleSelectChange}
        style={{
          color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
        }}
      >
        <option value="" disabled hidden>
          Choose payroll period
        </option>
        {data.map((payrollPeriodId) => SetPayrollPeriodId(payrollPeriodId))}
      </select>
    </div>
  );
}
function PayrollPeriodIdSelectFilter({
  payrollPeriodId,
  setPayrollPeriodId,
  payTypeId,
}) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setPayrollPeriodId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = useCallback(async () => {
    if (!payTypeId) {
      return;
    }
    // const currentYear = new Date().getFullYear();
    // const apiUrl =  domain + `/api/PayrollPeriod/year/${currentYear}`;
    const apiUrl = domain + `/api/PayrollPeriod/active/paytype/${payTypeId}`; // changed

    await axios
      .get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      })
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [payTypeId]);

  useEffect(() => {
    fetchData();
    if (payrollPeriodId !== "" && payrollPeriodId !== 0) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [fetchData, payrollPeriodId]);

  return (
    <div>
      <select
        id="employee-select-PagibigReport"
        disabled={!payTypeId}
        value={payrollPeriodId || ""}
        onChange={handleSelectChange}
        style={{
          color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
        }}
      >
        <option value="" disabled hidden>
          Choose payroll period
        </option>
        {data.map((payrollPeriodId) => SetPayrollPeriodId(payrollPeriodId))}
      </select>
    </div>
  );
}
function PayrollPeriodIdSelectFilter2({
  payrollPeriodId,
  setPayrollPeriodId,
  payTypeId,
  mainPayrollPeriod,
}) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setPayrollPeriodId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = useCallback(async () => {
    if (!payTypeId) {
      return;
    }
    // const currentYear = new Date().getFullYear();
    // const apiUrl =  domain + `/api/PayrollPeriod/year/${currentYear}`;
    const apiUrl =
      domain +
      `/api/PayrollPeriod/active/paytype/${payTypeId}/before/main-payrollperiod/${mainPayrollPeriod}`; // changed

    await axios
      .get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      })
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [payTypeId, mainPayrollPeriod]);

  useEffect(() => {
    fetchData();
    if (payrollPeriodId !== "" && payrollPeriodId !== 0) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [fetchData, payrollPeriodId]);

  return (
    <div>
      <select
        id="employee-select-PagibigReport"
        disabled={!payTypeId}
        value={payrollPeriodId || ""}
        onChange={handleSelectChange}
        style={{
          color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
        }}
      >
        <option value="" disabled hidden>
          Choose payroll period
        </option>
        {data.map((payrollPeriodId) => SetPayrollPeriodId(payrollPeriodId))}
      </select>
    </div>
  );
}
function SetPayrollPeriodId(payrollPeriodId) {
  const formattedDateFrom = format(payrollPeriodId.dateFrom, "MM/dd/yyyy");
  const formattedDateTo = format(payrollPeriodId.dateTo, "MM/dd/yyyy");

  return (
    <option value={payrollPeriodId.id}>
      {`${formattedDateFrom} - ${formattedDateTo} ${
        payrollPeriodId.payTypeDescription
          ? payrollPeriodId.payTypeDescription
          : ""
      }`}
    </option>
  );
}
function PayTypeIdSelect({ payTypeId, setPayTypeId }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setPayTypeId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/PayType/active";

    await axios
      .get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      })
      .then((response) => {
        setData(response.data); // Set the response data to the state
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    fetchData();
    if (payTypeId !== "" && payTypeId !== 0) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [payTypeId]);

  return (
    <div>
      <select
        id="employee-select-PagibigReport"
        value={payTypeId}
        onChange={handleSelectChange}
        style={{
          color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
        }}
      >
        <option value="" disabled hidden>
          Choose pay type
        </option>
        {data.map((payTypeId) => SetPayTypeId(payTypeId))}
      </select>
    </div>
  );
}
function SetPayTypeId(payTypeId) {
  return <option value={payTypeId.id}>{payTypeId.description}</option>;
}
function ClassificationIdSelectDummy() {
  return (
    <div>
      <select id="employee-select-PagibigReport"></select>
    </div>
  );
}
function ClassificationIdSelectFilter({
  classificationId,
  setClassificationId,
  payTypeId,
  user,
}) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setClassificationId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = useCallback(async () => {
    if (!payTypeId) {
      return;
    }

    const apiUrl =
      domain + `/api/Classification/active/username/${user.username}`;

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      });

      let finalData = response.data;

      if (parseInt(payTypeId) === 1) {
        finalData = response.data.filter((i) => i.id === 1);
      } else if (parseInt(payTypeId) === 3) {
        finalData = response.data.filter(
          (i) => i.id === 2 || i.id === 3 || i.id === 4
        );
      }

      setData(finalData); // Set the response data to the state
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, [payTypeId, user]);

  useEffect(() => {
    fetchData();
    if (classificationId !== "" && classificationId !== 0) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [fetchData, classificationId]);

  return (
    <div>
      <select
        id="employee-select-PagibigReport"
        disabled={!payTypeId}
        value={classificationId}
        onChange={handleSelectChange}
        style={{
          color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
        }}
      >
        <option value="" disabled hidden>
          Choose classification
        </option>
        {data.map((classificationId) => SetClassificationId(classificationId))}
      </select>
    </div>
  );
}
function ClassificationIdSelectWithAllDummy() {
  return (
    <div>
      <select id="employee-select-PagibigReport"></select>
    </div>
  );
}
function ClassificationIdSelectWithAll1({
  classificationId,
  setClassificationId,
  user,
}) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setClassificationId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = useCallback(async () => {
    const apiUrl =
      domain + `/api/Classification/active/username/${user.username}`;

    await axios
      .get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      })
      .then((response) => {
        setData(response.data); // Set the response data to the state
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [user]);

  useEffect(() => {
    fetchData();
    if (classificationId !== "" && classificationId !== 0) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [classificationId, fetchData]);

  return (
    <div>
      <select
        id="employee-select-PagibigReport"
        value={classificationId}
        onChange={handleSelectChange}
        style={{
          color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
        }}
      >
        <option value="" disabled hidden>
          Choose classification
        </option>
        {data.length > 0 && <option value="All">All</option>}
        {data.map((classificationId) => SetClassificationId(classificationId))}
      </select>
    </div>
  );
}
function SetClassificationId(classificationId) {
  return (
    <option value={classificationId.id}>{classificationId.description}</option>
  );
}
function GenerateMessage({ form, message, isSuccess }) {
  return (
    <>
      <div
        className={`modal-overlay toggleMessage-overlay ${form ? "open" : ""}`}
      >
        {form && (
          <div
            className="modal toggleMessage"
            style={{ backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5" }}
          >
            <div className="column">
              {isSuccess ? (
                <div
                  className="request_title row"
                  style={{
                    fontWeight: "bold",
                    color: "green",
                    alignItems: "center",
                  }}
                >
                  <CheckCircleIcon />
                  <span>{"SUCCESS MESSAGE"}</span>
                </div>
              ) : (
                <div
                  className="request_title row"
                  style={{
                    fontWeight: "bold",
                    color: "#DD5746",
                    alignItems: "center",
                  }}
                >
                  <ErrorIcon />
                  <span>{"ERROR MESSAGE"}</span>
                </div>
              )}
              <span
                style={{
                  textAlign: "center",
                  padding: "10px 0",
                  color: isSuccess ? "green" : "#DD5746",
                }}
              >
                {message}
              </span>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function DateTimeInput({ date, setDate }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleDateTimeChange = (event) => {
    setDate(event.target.value);
    setIsSelected(true);
  };

  useEffect(() => {
    if (date !== undefined && date !== "") {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [date]);

  let formattedDate = "";

  if (date) {
    formattedDate = date.split("T")[0];
  }

  return (
    <div>
      <input
        type="date"
        id={"datetime-"}
        name="datetime"
        value={formattedDate} // Exclude milliseconds
        onChange={handleDateTimeChange}
        style={{
          width: "90%",
          height: "30px",
          borderRadius: "3px",
          border: "1px solid #80808080",
          color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
          fontFamily:
            "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif",
        }}
      />
    </div>
  );
}
export function CreateTable({
  dataList = [],
  dataHeader = [],
  dataAccessor = [],
  currentPage,
  setCurrentPage,
  editHandleClick,
  deleteHandleClick,
}) {
  const itemsPerPage = 10;

  const columns = React.useMemo(
    () =>
      dataHeader.map((header, index) => ({
        Header: header,
        accessor: dataAccessor[index],
      })),
    [dataHeader, dataAccessor]
  );

  const [sortHeaderValue, setSortHeaderValue] = useState({
    id: "",
    desc: false,
    isDefault: true,
  });

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setSortBy,
  } = useTable(
    {
      columns,
      data: dataList,
      initialState: {
        sortBy: sortHeaderValue.isDefault
          ? [] // No sorting if it's default
          : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }], // Apply sorting if not default
      },
    },
    useSortBy
  );

  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
  const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
  const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(rows.length / itemsPerPage);
  const isLastPage = currentPage === totalPages;

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  //Sorting Feature
  const sortState = [
    { id: 0, state: "default", textValue: "" },
    { id: 1, state: "ascending", textValue: "↑" },
    { id: 2, state: "descending", textValue: "↓" },
  ];

  const headerClick = (column) => {
    if (sortHeaderValue.id !== column.id) {
      // New column selected, start with ascending order
      setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
      setSortBy([{ id: column.id, desc: false }]);
    } else {
      // Toggle between sorting states (default -> ascending -> descending -> default)
      if (sortHeaderValue.isDefault) {
        setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
        setSortBy([{ id: column.id, desc: false }]);
      } else if (!sortHeaderValue.desc) {
        setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
        setSortBy([{ id: column.id, desc: true }]);
      } else {
        setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
        setSortBy([]); // Clear sorting
      }
    }
  };

  // Ensure sorting is reapplied on dataList reload
  useEffect(() => {
    if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
      setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
    }
  }, [dataList, setSortBy, sortHeaderValue]);

  return (
    <>
      <table {...getTableProps()} className='border-collapse'>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps()}
                  onClick={() => headerClick(column)}
                  className="sortable-header"
                >
                  {`${column.render("Header")} ${
                    sortHeaderValue.id === column.id
                      ? sortState[
                          sortHeaderValue.isDefault
                            ? 0
                            : sortHeaderValue.desc
                            ? 2
                            : 1
                        ].textValue
                      : ""
                  }`}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {dataList.length <= 0 && (
            <tr>
              <td colSpan={columns.length} style={{ textAlign: "center" }}>
                No data to display
              </td>
            </tr>
          )}
          {currentItems.map((row) => {
            prepareRow(row);
            return (
              <tr key={row.original.id} {...row.getRowProps()}>
                {row.cells.map((cell) =>
                  SetInfoMain(
                    cell.render("Cell").props.column.Header,
                    cell,
                    editHandleClick,
                    deleteHandleClick
                  )
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
      {rows.length > itemsPerPage ? (
        <>
          <div
            className="table-page row"
            style={{
              alignItems: "center",
              justifyContent: "end",
              padding: "20px 0 0 0",
            }}
          >
            <button
              className="prev row"
              onClick={() => paginate(1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
                height: "26px",
              }}
            >
              &lt;&lt;
            </button>
            <button
              className="prev row"
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
                height: "26px",
              }}
            >
              <NavigateBeforeIcon style={{ marginRight: "5px" }} /> PREVIOUS
            </button>
            <button
              className="next row"
              onClick={() => paginate(currentPage + 1)}
              disabled={indexOfLastItem >= rows.length}
              style={{
                visibility:
                  rows.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                marginRight: "5px",
                height: "26px",
              }}
            >
              NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
            </button>
            <button
              className="next row"
              onClick={() => paginate(totalPages)}
              disabled={indexOfLastItem >= rows.length}
              style={{
                visibility:
                  rows.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                height: "26px",
              }}
            >
              &gt;&gt;
            </button>
          </div>
          <div
            className="table-page row"
            style={{
              alignItems: "center",
              justifyContent: "center",
              padding: "20px 0 0 0",
            }}
          >
            {`${currentPage}/${totalPages}`}
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
}
function SetInfoMain(header, _cell, editHandleClick, deleteHandleClick) {
  const data = _cell.render("Cell").props.row.original;
  const tdValue = _cell.render("Cell").props.value;

  if (header === "") {
    return (
      <td>
        <div
          className="row"
          style={{ alignItems: "center", justifyContent: "center" }}
        >
          <Tooltip text="Update">
            <div
              style={{ padding: "0 5px" }}
              onClick={() => editHandleClick(data)}
            >
              <ModeEditIcon />
            </div>
          </Tooltip>
          {deleteHandleClick ? (
            <Tooltip text="Delete">
              <div
                style={{ padding: "0 5px" }}
                onClick={() => deleteHandleClick(data)}
              >
                <DeleteForeverIcon />
              </div>
            </Tooltip>
          ) : (
            <></>
          )}
        </div>
      </td>
    );
  }

  if (header === "Benefits List") {
    return (
      <td>
        {tdValue.map((value, index) => (
          <div style={{ margin: "20px 0" }}>
            {" "}
            {`${
              value.name ? value.name : "No description"
            }: ${value.amount.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`}{" "}
          </div>
        ))}
      </td>
    );
  }

  if (header === "Other Cash Advance List") {
    return (
      <td>
        {tdValue.map((value, index) => (
          <div style={{ margin: "20px 0" }}>
            {" "}
            {`${
              value.description ? value.description : "No description"
            }: ${value.defaultDeduction.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`}{" "}
          </div>
        ))}
      </td>
    );
  }
  if (header === "Company Loans List") {
    return (
      <td>
        {tdValue.map((value, index) => (
          <div style={{ margin: "20px 0" }}>
            {" "}
            {`${
              value.description ? value.description : "No description"
            }: ${value.defaultDeduction.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`}{" "}
          </div>
        ))}
      </td>
    );
  }

  if (header === "Status") {
    if (data.isActive) {
      return <td>Active</td>;
    } else {
      return <td>InActive</td>;
    }
  }

  if (header === "Approved?") {
    return (
      <td>
        <input
          type="checkbox"
          id="overtime-allowance"
          className="checkbox"
          name=""
          checked={data.isApproved}
          disabled={true}
        />
      </td>
    );
  }

  if (header === "Enabled?") {
    return (
      <td>
        <input
          type="checkbox"
          id="overtime-allowance"
          className="checkbox"
          name=""
          checked={data.idEnabled}
          disabled={true}
        />
      </td>
    );
  }

  if (
    header === "Time From" ||
    header === "Time To" ||
    header === "Time In" ||
    header === "Time Out"
  ) {
    const time = _cell.render("Cell").props.value;
    if (!time) {
      return <td></td>;
    }

    let timeParts;
    let formattedTime;

    if (globalTimeFormat === "Standard Time") {
      const timeSplit = time.split("T");
      if (timeSplit.length > 1) {
        timeParts = timeSplit[1].substr(0, 5).split(":");
      } else {
        timeParts = [];
      }
      let hours = parseInt(timeParts[0], 10);
      const minutes = timeParts[1];

      // Convert 24-hour format to 12-hour format and determine AM or PM
      const amPm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

      formattedTime = `${hours}:${minutes} ${amPm}`;
    } else if (globalTimeFormat === "Military Time") {
      const timeSplit = time.split("T");
      if (timeSplit.length > 1) {
        timeParts = timeSplit[1].substr(0, 5).split(":");
      } else {
        timeParts = [];
      }
      let hours = parseInt(timeParts[0], 10);
      const minutes = timeParts[1];

      formattedTime = `${hours}:${minutes}`;
    }

    return <td>{formattedTime}</td>;
  }

  if (header === "Request Date") {
    
    const value = _cell.render("Cell").props.value;
    if (!value) {
      return <td>-</td>;
    }

    let date;
    let timeSource;

    if (String(value).includes("T")) {
      // ISO date-time, e.g. 2026-10-23T14:30:00
      date = new Date(value);
      timeSource = date;
    } else if (String(value).includes(":")) {
      // Time only, e.g. 14:30
      date = new Date();

      const [hours, minutes] = String(value)
        .split(":")
        .map((part) => parseInt(part, 10));

      if (
        Number.isNaN(hours) ||
        Number.isNaN(minutes) ||
        hours < 0 ||
        hours > 23 ||
        minutes < 0 ||
        minutes > 59
      ) {
        return <td>-</td>;
      }

      timeSource = new Date();
      timeSource.setHours(hours, minutes, 0, 0);
    } else {
      // Date only
      date = new Date(value);
      timeSource = null;
    }

    if (Number.isNaN(date.getTime())) {
      return <td>-</td>;
    }

    const formattedDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;

    let formattedTime = "";

    if (timeSource) {
      const hours = timeSource.getHours();
      const minutes = String(timeSource.getMinutes()).padStart(2, "0");

      if (globalTimeFormat === "Standard Time") {
        const standardHours = hours % 12 || 12;
        const amPm = hours >= 12 ? "PM" : "AM";

        formattedTime = `${standardHours}:${minutes} ${amPm}`;
      } else if (globalTimeFormat === "Military Time") {
        formattedTime = `${String(hours).padStart(2, "0")}:${minutes}`;
      }
    }

    return (
      <td>
        {formattedDate}
        {formattedTime && ` ${formattedTime}`}
      </td>
    );
  }

  if (
    header === "Date" ||
    header === "Date From" ||
    header === "Date To" ||
    header === "Date Processed" ||
    header === "Date Requested"
  ) {
    const date = new Date(_cell.render("Cell").props.value);
    if (!date) {
      return <td></td>;
    }

    const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
    const dd = date.getDate();
    const yyyy = date.getFullYear();

    const formattedDateFrom = `${mm}/${dd}/${yyyy}`;

    return <td>{formattedDateFrom}</td>;
  }

  //Double type data
  if (
    header === "Over Percentage" ||
    header === "Deduction" ||
    header === "Salary" ||
    header === "Employee" ||
    header === "Employer" ||
    header === "Range From" ||
    header === "Range To" ||
    header === "Monthly Salary" ||
    header === "SSS ER" ||
    header === "SSS EE" ||
    header === "SSS Total" ||
    header === "ECER" ||
    header === "Total Contribution ER" ||
    header === "Total Contribution EE" ||
    header === "Total Contribution Total" ||
    header === "SE Total Contribution" ||
    header === "Salary Range From" ||
    header === "Salary Range To" ||
    header === "Total Monthly Premium" ||
    header === "Percentage" ||
    header === "Amount" ||
    header === "Total Loan" ||
    header === "Total Balance" ||
    header === "Default Deduction" ||
    header === "Allowance" ||
    header === "Total Days" ||
    header === "Daily Salary" ||
    header === "Benefits" ||
    header === "Allowance" ||
    header === "Cash Advance" ||
    header === "Other Cash Advance" ||
    header === "Company Loans" ||
    header === "Total Basic" ||
    header === "Rate" ||
    header === "Hours OT Regular" ||
    header === "Total OT Regular" ||
    header === "Hours OT Exceeded" ||
    header === "Total OT Exceeded" ||
    header === "Hours OT Restday" ||
    header === "Total OT Restday" ||
    header === "Hours Holiday Special" ||
    header === "Total Holiday Special" ||
    header === "Hours Holiday Regular" ||
    header === "Total Holiday Regular" ||
    header === "Hours Restday Holiday Special" ||
    header === "Total Restday Holiday Special" ||
    header === "Hours Restday Holiday Regular" ||
    header === "Total Restday Holiday Regular" ||
    header === "Additions" ||
    header === "SSS" ||
    header === "Pagibig" ||
    header === "Philhealth" ||
    header === "SSS Loan" ||
    header === "SSS Calamity Loan" ||
    header === "Pagibig Loan" ||
    header === "Pagibig Calamity Loan" ||
    header === "Tax" ||
    header === "Deductions" ||
    header === "Adjustments" ||
    header === "Total Net Pay" ||
    header === "Total Gross Pay" ||
    header === "Days Absent" ||
    header === "Absent/s" ||
    header === "Days Leave" ||
    header === "Leave/s" ||
    header === "Hours Exceeded" ||
    header === "Total Exceeded" ||
    header === "Hours Undertime" ||
    header === "Undertime" ||
    header === "Hours Late" ||
    header === "Late" ||
    header === "Night Diff" ||
    header === "OT Regular" ||
    header === "OT Restday" ||
    header === "Holiday Special" ||
    header === "Holiday Regular" ||
    header === "Restday Holiday Special" ||
    header === "Restday Holiday Regular" ||
    header === "Total Absents" ||
    header === "Total Late" ||
    header === "Total Undertime" ||
    header === "Total Leaves" ||
    header === "Total Night Diff" ||
    header === "Total Exceed" ||
    header === "Exceed" ||
    header === "Total Days Regular Holidays" ||
    header === "Total Regular Holiday Worked" ||
    header === "Total Regular Holidays" ||
    header === "Total Days Special Non-Working Holidays" ||
    header === "Total Special Non-Working Holidays"
  ) {
    const value = _cell.render("Cell").props.value;

    // Check if value is a number
    const isNumber = typeof value === "number";

    const numberWithCommasAndDecimal = (number) => {
      return number.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };

    if (!isNumber) {
      return <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>;
    }

    const formattedNumber = numberWithCommasAndDecimal(value);

    return <td>{formattedNumber}</td>;
  }

  return <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>;
}
export function CreateTableForReferenceSelect({
  dataList = [],
  dataHeader = [],
  dataAccessor = [],
  viewHandleClick,
  setSelectedReference,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [activeRowId, setActiveRowId] = useState(null);
  const itemsPerPage = 10;

  const columns = React.useMemo(
    () =>
      dataHeader.map((header, index) => ({
        Header: header,
        accessor: dataAccessor[index],
      })),
    [dataHeader, dataAccessor]
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data: dataList });

  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
  const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
  const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(rows.length / itemsPerPage);
  const isLastPage = currentPage === totalPages;

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const handleRowClick = (rowData) => {
    setSelectedReference(rowData); // Pass the clicked row data to the setSelectedEmployee function
    setActiveRowId(rowData.id);
  };

  return (
    <div>
      <table {...getTableProps()} className='border-collapse'>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {dataList.length <= 0 && (
            <tr>
              <td colSpan={columns.length} style={{ textAlign: "center" }}>
                No data to display
              </td>
            </tr>
          )}
          {currentItems.map((row) => {
            prepareRow(row);
            return (
              <tr
                key={row.original.id}
                {...row.getRowProps()}
                onClick={() => handleRowClick(row.original)} // Attach onClick event handler to the row
                className={row.original.id === activeRowId ? "active" : ""}
              >
                {row.cells.map((cell) =>
                  SetInfo(
                    cell.render("Cell").props.column.Header,
                    cell,
                    viewHandleClick
                  )
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
      {rows.length > itemsPerPage ? (
        <div>
          <div
            className="table-page row"
            style={{
              alignItems: "center",
              justifyContent: "end",
              padding: "20px 0 0 0",
            }}
          >
            <button
              className="prev row"
              onClick={() => paginate(1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
                height: "26px",
              }}
            >
              &lt;&lt;
            </button>
            <button
              className="prev row"
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
                height: "26px",
              }}
            >
              <NavigateBeforeIcon style={{ marginRight: "5px" }} /> PREVIOUS
            </button>
            <button
              className="next row"
              onClick={() => paginate(currentPage + 1)}
              disabled={indexOfLastItem >= rows.length}
              style={{
                visibility:
                  rows.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                marginRight: "5px",
                height: "26px",
              }}
            >
              NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
            </button>
            <button
              className="next row"
              onClick={() => paginate(totalPages)}
              disabled={indexOfLastItem >= rows.length}
              style={{
                visibility:
                  rows.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                height: "26px",
              }}
            >
              &gt;&gt;
            </button>
          </div>
          <div
            style={{ textAlign: "center" }}
          >{`${currentPage}/${totalPages}`}</div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
function SetInfo(header, _cell, viewHandleClick, deleteHandleClick) {
  const data = _cell.render("Cell").props.row.original;

  if (header === "") {
    return (
      <td>
        <div
          className="row"
          style={{ alignItems: "center", justifyContent: "center" }}
        >
          <Tooltip text="View">
            <div
              style={{ padding: "0 5px" }}
              onClick={() => viewHandleClick(data)}
            >
              <RemoveRedEyeIcon />
            </div>
          </Tooltip>
          {deleteHandleClick ? (
            <Tooltip text="Delete">
              <div
                style={{ padding: "0 5px" }}
                onClick={() => deleteHandleClick(data)}
              >
                <DeleteForeverIcon />
              </div>
            </Tooltip>
          ) : (
            <></>
          )}
        </div>
      </td>
    );
  }

  if (header === "Reference No.") {
    const value = _cell.render("Cell").props.value;

    const formattedNumber = value.toString().padStart(6, "0");

    if (data.requestTypeId === 1) {
      return <td>LV-{formattedNumber}</td>;
    } else if (data.requestTypeId === 2) {
      return <td>CS-{formattedNumber}</td>;
    } else if (data.requestTypeId === 3) {
      return <td>OT-{formattedNumber}</td>;
    } else if (data.requestTypeId === 4) {
      return <td>CH-{formattedNumber}</td>;
    } else if (data.requestTypeId === 5) {
      return <td>OS-{formattedNumber}</td>;
    }
  }

  if (header === "Request Date") {
    
    const value = _cell.render("Cell").props.value;
    if (!value) {
      return <td>-</td>;
    }

    let date;
    let timeSource;

    if (String(value).includes("T")) {
      // ISO date-time, e.g. 2026-10-23T14:30:00
      date = new Date(value);
      timeSource = date;
    } else if (String(value).includes(":")) {
      // Time only, e.g. 14:30
      date = new Date();

      const [hours, minutes] = String(value)
        .split(":")
        .map((part) => parseInt(part, 10));

      if (
        Number.isNaN(hours) ||
        Number.isNaN(minutes) ||
        hours < 0 ||
        hours > 23 ||
        minutes < 0 ||
        minutes > 59
      ) {
        return <td>-</td>;
      }

      timeSource = new Date();
      timeSource.setHours(hours, minutes, 0, 0);
    } else {
      // Date only
      date = new Date(value);
      timeSource = null;
    }

    if (Number.isNaN(date.getTime())) {
      return <td>-</td>;
    }

    const formattedDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;

    let formattedTime = "";

    if (timeSource) {
      const hours = timeSource.getHours();
      const minutes = String(timeSource.getMinutes()).padStart(2, "0");

      if (globalTimeFormat === "Standard Time") {
        const standardHours = hours % 12 || 12;
        const amPm = hours >= 12 ? "PM" : "AM";

        formattedTime = `${standardHours}:${minutes} ${amPm}`;
      } else if (globalTimeFormat === "Military Time") {
        formattedTime = `${String(hours).padStart(2, "0")}:${minutes}`;
      }
    }

    return (
      <td>
        {formattedDate}
        {formattedTime && ` ${formattedTime}`}
      </td>
    );
  }

  return <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>;
}
const Tooltip = ({ text, children }) => {
  const [show, setShow] = useState(false);

  const handleMouseEnter = () => {
    setShow(true);
  };

  const handleMouseLeave = () => {
    setShow(false);
  };

  return (
    <div style={{ position: "relative", display: "inline-block", zIndex: "1" }}>
      <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        {children}
      </div>
      {show && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "-50%",
            transform: "translateX(-50%)",
            backgroundColor: "white",
            color: "gray",
            padding: "5px",
            borderRadius: "5px",
            pointerEvents: "none",
            boxShadow:
              "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
          }}
        >
          {text}
        </div>
      )}
    </div>
  );
};
function CustomLoader({ loadingPercentage }) {
  return (
    <div
      style={{
        position: "fixed",
        top: "0",
        left: "0",
        width: "100vw",
        height: "100vh",
        backgroundColor: "#ffffff59", // Overlay effect
        zIndex: "2000",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {loadingPercentage !== 0 && (
        <p
          style={{ color: "rgb(104, 104, 104)" }}
        >{`Loading: ${loadingPercentage}%`}</p>
      )}

      <div className="custom-loader">
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            height: "100%",
            width: `${loadingPercentage}%`, // Foreground loader showing progress
            backgroundColor: "rgba(255, 255, 255, 0.8)", // Semi-transparent to let the animation show behind it
            borderRadius: "inherit",
          }}
        />
      </div>
    </div>
  );
}
function CreateTableForUpload({
  dataList = [],
  dataHeader = [],
  dataAccessor = [],
  currentPage,
  setCurrentPage,
}) {
  const itemsPerPage = 7;

  const columns = React.useMemo(
    () =>
      dataHeader.map((header, index) => ({
        Header: header,
        accessor: dataAccessor[index],
      })),
    [dataHeader, dataAccessor]
  );

  const [sortHeaderValue, setSortHeaderValue] = useState({
    id: "",
    desc: false,
    isDefault: true,
  });

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setSortBy,
  } = useTable(
    {
      columns,
      data: dataList,
      initialState: {
        sortBy: sortHeaderValue.isDefault
          ? [] // No sorting if it's default
          : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }], // Apply sorting if not default
      },
    },
    useSortBy
  );

  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
  const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
  const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(rows.length / itemsPerPage);
  const isLastPage = currentPage === totalPages;

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  //Sorting Feature
  const sortState = [
    { id: 0, state: "default", textValue: "" },
    { id: 1, state: "ascending", textValue: "↑" },
    { id: 2, state: "descending", textValue: "↓" },
  ];

  const headerClick = (column) => {
    if (sortHeaderValue.id !== column.id) {
      // New column selected, start with ascending order
      setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
      setSortBy([{ id: column.id, desc: false }]);
    } else {
      // Toggle between sorting states (default -> ascending -> descending -> default)
      if (sortHeaderValue.isDefault) {
        setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
        setSortBy([{ id: column.id, desc: false }]);
      } else if (!sortHeaderValue.desc) {
        setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
        setSortBy([{ id: column.id, desc: true }]);
      } else {
        setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
        setSortBy([]); // Clear sorting
      }
    }
  };

  // Ensure sorting is reapplied on dataList reload
  useEffect(() => {
    if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
      setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
    }
  }, [dataList, setSortBy, sortHeaderValue]);

  return (
    <div>
      <table {...getTableProps()} className='border-collapse'>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps()}
                  onClick={() => headerClick(column)}
                  className="sortable-header"
                >
                  {`${column.render("Header")} ${
                    sortHeaderValue.id === column.id
                      ? sortState[
                          sortHeaderValue.isDefault
                            ? 0
                            : sortHeaderValue.desc
                            ? 2
                            : 1
                        ].textValue
                      : ""
                  }`}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {dataList.length <= 0 && (
            <tr>
              <td colSpan={columns.length} style={{ textAlign: "center" }}>
                No data to display
              </td>
            </tr>
          )}
          {currentItems.map((row) => {
            prepareRow(row);
            return (
              <tr
                key={row.original.id}
                {...row.getRowProps()}
                className={row.original.error ? "error" : ""}
              >
                {row.cells.map((cell) => (
                  <SetInfoForUpload
                    header={cell.render("Cell").props.column.Header}
                    _cell={cell}
                  />
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
      {rows.length > itemsPerPage ? (
        <div>
          <div
            className="table-page row"
            style={{
              alignItems: "center",
              justifyContent: "end",
              padding: "20px 0 0 0",
            }}
          >
            <button
              className="prev row"
              onClick={() => paginate(1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
                height: "25px",
              }}
            >
              &lt;&lt;
            </button>
            <button
              className="prev row"
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
                height: "25px",
              }}
            >
              <NavigateBeforeIcon style={{ marginRight: "5px" }} /> PREVIOUS
            </button>
            <button
              className="next row"
              onClick={() => paginate(currentPage + 1)}
              disabled={indexOfLastItem >= rows.length}
              style={{
                visibility:
                  rows.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                marginRight: "5px",
                height: "25px",
              }}
            >
              NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
            </button>
            <button
              className="next row"
              onClick={() => paginate(totalPages)}
              disabled={indexOfLastItem >= rows.length}
              style={{
                visibility:
                  rows.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                height: "25px",
              }}
            >
              &gt;&gt;
            </button>
          </div>
          {`${currentPage}/${totalPages}`}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
function SetInfoForUpload({ header, _cell }) {
  const data = _cell.render("Cell").props.row.original;
  const value = _cell.render("Cell").props.value;

  if (header === "Photo") {
    if (data.photo) {
      const imageSrc = "data:image/jpeg;base64," + data.photo;

      return (
        <td>
          <img className="avatarImg" src={imageSrc} alt="" />
        </td>
      );
    }
    return (
      <td>
        <img className="avatarImg" src="images/sample.jpg" alt="" />
      </td>
    );
  }

  if (header === "Date Created") {
    if (!value) {
      return <td></td>;
    }

    const date = new Date(_cell.render("Cell").props.value);
    if (!date) {
      return <td>-</td>;
    }

    const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
    const dd = date.getDate();
    const yyyy = date.getFullYear();

    const formattedDateFrom = `${mm}/${dd}/${yyyy}`;

    return <td>{formattedDateFrom}</td>;
  }

  if (header === "Error") {
    return (
      <td>{value && <p style={{ color: "red", margin: 0 }}>{value}</p>}</td>
    );
  }

  if (
    header === "Vacation Leave" ||
    header === "Sick Leave" ||
    header === "Service Incentive Leave" ||
    header === "Solo Parent Leave" ||
    header === "Vacation Leave Remaining" ||
    header === "Sick Leave Remaining" ||
    header === "Service Incentive Leave Remaining" ||
    header === "Solo Parent Leave Remaining"
  ) {
    const value = _cell.render("Cell").props.value;

    // Check if value is a number
    const isNumber = typeof value === "number";

    const numberWithCommasAndDecimal = (number) => {
      return number.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };

    if (!isNumber) {
      return <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>;
    }

    const formattedNumber = numberWithCommasAndDecimal(value);

    return <td>{formattedNumber}</td>;
  }

  if (
    header === "Time From" ||
    header === "Time To" ||
    header === "Time In" ||
    header === "Time Out"
  ) {
    let time = _cell.render("Cell").props.value;

    if (!time) {
      return <td></td>;
    }

    let timeParts;
    let formattedTime;

    if (globalTimeFormat === "Standard Time") {
      const timeSplit = time.split("T");
      if (timeSplit.length > 1) {
        timeParts = timeSplit[1].substr(0, 5).split(":");
      } else {
        timeParts = [];
      }
      let hours = parseInt(timeParts[0], 10);
      const minutes = timeParts[1];

      // Convert 24-hour format to 12-hour format and determine AM or PM
      const amPm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

      formattedTime = `${hours}:${minutes} ${amPm}`;
    } else if (globalTimeFormat === "Military Time") {
      const timeSplit = time.split("T");
      if (timeSplit.length > 1) {
        timeParts = timeSplit[1].substr(0, 5).split(":");
      } else {
        timeParts = [];
      }
      let hours = parseInt(timeParts[0], 10);
      const minutes = timeParts[1];

      formattedTime = `${hours}:${minutes}`;
    }

    return <td>{formattedTime}</td>;
  }

  return <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>;
}
function SectionIdSelect({sectionId, setSectionId}){
    
    const handleSelectChange = (event) => {
        setSectionId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Section/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.description.localeCompare(b.description));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={sectionId} onChange={handleSelectChange}style={{ color: "rgb(104, 104, 104)" }}>
            <option value="0" >All</option>
            {data.map((sectionId) => ( 
                SetSectionId(sectionId)
            ))}
            </select>
        </div>
    );
};
function SetSectionId(sectionId){
    return(
        <option value={sectionId.id}>{
            sectionId.description}
        </option>
    )
    
}
function LocationIdSelect({locationId, setLocationId}){
    const handleSelectChange = (event) => {
        setLocationId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Location/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.description.localeCompare(b.description));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={locationId} onChange={handleSelectChange}style={{ height: "30px", color: "rgb(104, 104, 104)" }}>
            <option value="0" >All</option>
            {data.map((locationId) => ( 
                SetLocationId(locationId)
            ))}
            </select>
        </div>
    );
};
function SetLocationId(locationId){
    return(
        <option value={locationId.id}>{
            locationId.description}
        </option>
    )

}
export default Payroll;
